export const keyMap = Object.freeze({
  accountAlreadyHaveAnAccount: 'accountAlreadyHaveAnAccount',
  accountChangeEmailFailedToCheckLinkError: 'accountChangeEmailFailedToCheckLinkError',
  accountChangeEmailNotValidLink: 'accountChangeEmailNotValidLink',
  accountChangeEmailSuccessMessage: 'accountChangeEmailSuccessMessage',
  accountChoosePlatform: 'accountChoosePlatform',
  accountConfirmEmailChangeErrorMessage: 'accountConfirmEmailChangeErrorMessage',
  accountConfirmEmailChangeFailedToCheckLinkError: 'accountConfirmEmailChangeFailedToCheckLinkError',
  accountConfirmEmailChangeMAPassword: 'accountConfirmEmailChangeMAPassword',
  accountConfirmEmailChangeNotValidLink: 'accountConfirmEmailChangeNotValidLink',
  accountConfirmEmailChangeSuccessMessage: 'accountConfirmEmailChangeSuccessMessage',
  accountConfirmEmailChangeTitle: 'accountConfirmEmailChangeTitle',
  accountContinue: 'accountContinue',
  accountDontHaveAnAccountYet: 'accountDontHaveAnAccountYet',
  accountFailedToRegistration: 'accountFailedToRegistration',
  accountFailedToResetPasswordError: 'accountFailedToResetPasswordError',
  accountFailedToSignInError: 'accountFailedToSignInError',
  accountFailedToSignOutError: 'accountFailedToSignOutError',
  accountForgotPassword: 'accountForgotPassword',
  accountForgotPasswordSuccessMessage: 'accountForgotPasswordSuccessMessage',
  accountGoToYourMemberArea: 'accountGoToYourMemberArea',
  accountNext: 'accountNext',
  accountOneTimePasswordHint: 'accountOneTimePasswordHint',
  accountOpenAnAccount: 'accountOpenAnAccount',
  accountOtpLimitExceeded: 'accountOtpLimitExceeded',
  accountPasswordRecoveryErrorMessage: 'accountPasswordRecoveryErrorMessage',
  accountPasswordRecoveryFailedToCheckLinkError: 'accountPasswordRecoveryFailedToCheckLinkError',
  accountPasswordRecoveryNotValidLink: 'accountPasswordRecoveryNotValidLink',
  accountPasswordRecoverySuccessMessage: 'accountPasswordRecoverySuccessMessage',
  accountPasswordRecoveryTitle: 'accountPasswordRecoveryTitle',
  accountPlatformHint: 'accountPlatformHint',
  accountQuickDeposit: 'accountQuickDeposit',
  accountReferralTokenWarning: 'accountReferralTokenWarning',
  accountRegisterBtn: 'accountRegisterBtn',
  accountResetPassword: 'accountResetPassword',
  accountResetPinCodeErrorMessage: 'accountResetPinCodeErrorMessage',
  accountResetPinCodeFailedToCheckLinkError: 'accountResetPinCodeFailedToCheckLinkError',
  accountResetPinCodeNotValidLink: 'accountResetPinCodeNotValidLink',
  accountResetPinCodeSuccessMessage: 'accountResetPinCodeSuccessMessage',
  accountResetPinCodeTitle: 'accountResetPinCodeTitle',
  accountReturnToSignIn: 'accountReturnToSignIn',
  accountSignIn: 'accountSignIn',
  accountSignInHere: 'accountSignInHere',
  accountSignOutBtn: 'accountSignOutBtn',
  accountSignUp: 'accountSignUp',
  accountSignUpHere: 'accountSignUpHere',
  accountSigninFormBtn: 'accountSigninFormBtn',
  adminLegalTradingPlatformDeepLink: 'adminLegalTradingPlatformDeepLink',
  adminLegalTradingPlatformDeepLinkHint: 'adminLegalTradingPlatformDeepLinkHint',
  adminReportsFtdUtmReportFieldsFtdDate: 'adminReportsFtdUtmReportFieldsFtdDate',
  adminReportsFtdUtmReportFieldsFtdValue: 'adminReportsFtdUtmReportFieldsFtdValue',
  adminReportsFtdUtmReportFieldsRegistrationDate: 'adminReportsFtdUtmReportFieldsRegistrationDate',
  adminReportsFtdUtmReportFieldsTotalDepositValue: 'adminReportsFtdUtmReportFieldsTotalDepositValue',
  adminReportsFtdUtmReportFieldsUtmCampaign: 'adminReportsFtdUtmReportFieldsUtmCampaign',
  adminReportsFtdUtmReportFieldsUtmMedium: 'adminReportsFtdUtmReportFieldsUtmMedium',
  adminReportsFtdUtmReportFieldsUtmSource: 'adminReportsFtdUtmReportFieldsUtmSource',
  adminReportsPspOperationReportFieldsAverageDepositUSD: 'adminReportsPspOperationReportFieldsAverageDepositUSD',
  adminReportsPspOperationReportFieldsAverageWithdrawalUSD: 'adminReportsPspOperationReportFieldsAverageWithdrawalUSD',
  adminReportsPspOperationReportFieldsCallbackErrorCode: 'adminReportsPspOperationReportFieldsCallbackErrorCode',
  adminReportsPspOperationReportFieldsCallbackErrorDescription:
    'adminReportsPspOperationReportFieldsCallbackErrorDescription',
  adminReportsPspOperationReportFieldsDepositedSharePercent:
    'adminReportsPspOperationReportFieldsDepositedSharePercent',
  adminReportsPspOperationReportFieldsNetCashUsd: 'adminReportsPspOperationReportFieldsNetCashUsd',
  adminReportsPspOperationReportFieldsOperationTime: 'adminReportsPspOperationReportFieldsOperationTime',
  adminReportsPspOperationReportFieldsPspClassName: 'adminReportsPspOperationReportFieldsPspClassName',
  adminReportsPspOperationReportFieldsPspId: 'adminReportsPspOperationReportFieldsPspId',
  adminReportsPspOperationReportFieldsPspName: 'adminReportsPspOperationReportFieldsPspName',
  adminReportsPspOperationReportFieldsTotalDepositedUSD: 'adminReportsPspOperationReportFieldsTotalDepositedUSD',
  adminReportsPspOperationReportFieldsTotalDeposits: 'adminReportsPspOperationReportFieldsTotalDeposits',
  adminReportsPspOperationReportFieldsTotalWithdrawals: 'adminReportsPspOperationReportFieldsTotalWithdrawals',
  adminReportsPspOperationReportFieldsTotalWithdrawnUSD: 'adminReportsPspOperationReportFieldsTotalWithdrawnUSD',
  adminReportsPspOperationReportFieldsWithdrawnSharePercent:
    'adminReportsPspOperationReportFieldsWithdrawnSharePercent',
  adminSocialTradingInvestorAccountDetailsCopyType: 'adminSocialTradingInvestorAccountDetailsCopyType',
  adminSocialTradingInvestorAccountDetailsGroupMappingType: 'adminSocialTradingInvestorAccountDetailsGroupMappingType',
  adminSocialTradingInvestorAccountDetailsLotMultiplier: 'adminSocialTradingInvestorAccountDetailsLotMultiplier',
  adminSocialTradingInvestorAccountInvestorAccount: 'adminSocialTradingInvestorAccountInvestorAccount',
  adminSocialTradingInvestorAccountInvestorName: 'adminSocialTradingInvestorAccountInvestorName',
  adminSocialTradingInvestorAccountMasterAccount: 'adminSocialTradingInvestorAccountMasterAccount',
  adminSocialTradingInvestorAccountMasterName: 'adminSocialTradingInvestorAccountMasterName',
  adminSocialTradingInvestorAccountSettingsChangeAllocationMethodAllowed:
    'adminSocialTradingInvestorAccountSettingsChangeAllocationMethodAllowed',
  adminSocialTradingInvestorAccountSettingsCommonSettingsTitle:
    'adminSocialTradingInvestorAccountSettingsCommonSettingsTitle',
  adminSocialTradingInvestorAccountSubscribedOn: 'adminSocialTradingInvestorAccountSubscribedOn',
  adminSocialTradingIsPositionAvailable: 'adminSocialTradingIsPositionAvailable',
  adminSocialTradingMasterAccountAverageDrawdown: 'adminSocialTradingMasterAccountAverageDrawdown',
  adminSocialTradingMasterAccountFiltersIsVisible: 'adminSocialTradingMasterAccountFiltersIsVisible',
  adminSocialTradingMasterAccountFiltersPeriod: 'adminSocialTradingMasterAccountFiltersPeriod',
  adminSocialTradingMasterAccountFiltersTradingAccount: 'adminSocialTradingMasterAccountFiltersTradingAccount',
  adminSocialTradingMasterAccountIsVisible: 'adminSocialTradingMasterAccountIsVisible',
  adminSocialTradingMasterAccountMaxDrawdown: 'adminSocialTradingMasterAccountMaxDrawdown',
  adminSocialTradingMasterAccountNickname: 'adminSocialTradingMasterAccountNickname',
  adminSocialTradingMasterAccountPosition: 'adminSocialTradingMasterAccountPosition',
  adminSocialTradingMasterAccountProfitSharing: 'adminSocialTradingMasterAccountProfitSharing',
  adminSocialTradingMasterAccountProfitability: 'adminSocialTradingMasterAccountProfitability',
  adminSocialTradingMasterAccountRecommendedMinDepositAmount:
    'adminSocialTradingMasterAccountRecommendedMinDepositAmount',
  adminSocialTradingMasterAccountReturnOnInvestment: 'adminSocialTradingMasterAccountReturnOnInvestment',
  adminSocialTradingMasterAccountTotalDepositsUsd: 'adminSocialTradingMasterAccountTotalDepositsUsd',
  adminSocialTradingMasterAccountTotalFundsInUsd: 'adminSocialTradingMasterAccountTotalFundsInUsd',
  adminSocialTradingMasterAccountTotalManagedFundsInAccountCurrency:
    'adminSocialTradingMasterAccountTotalManagedFundsInAccountCurrency',
  adminSocialTradingMasterAccountTotalManagedFundsInUsd: 'adminSocialTradingMasterAccountTotalManagedFundsInUsd',
  adminSocialTradingMasterAccountTotalOwnedFundsInAccountCurrency:
    'adminSocialTradingMasterAccountTotalOwnedFundsInAccountCurrency',
  adminSocialTradingMasterAccountTotalOwnedFundsInUsd: 'adminSocialTradingMasterAccountTotalOwnedFundsInUsd',
  adminSocialTradingMasterAccountTotalWithdrawalsUsd: 'adminSocialTradingMasterAccountTotalWithdrawalsUsd',
  adminSocialTradingMasterAccountTradesCount: 'adminSocialTradingMasterAccountTradesCount',
  adminTabsAccesses: 'adminTabsAccesses',
  adminTabsAccessesSettingsCountryAccess: 'adminTabsAccessesSettingsCountryAccess',
  adminTabsAccessesSettingsLoginHistory: 'adminTabsAccessesSettingsLoginHistory',
  adminTabsAccessesSettingsPermission: 'adminTabsAccessesSettingsPermission',
  adminTabsAllowedUsers: 'adminTabsAllowedUsers',
  adminTabsAttachments: 'adminTabsAttachments',
  adminTabsAvailableCountries: 'adminTabsAvailableCountries',
  adminTabsBankAccounts: 'adminTabsBankAccounts',
  adminTabsBonuses: 'adminTabsBonuses',
  adminTabsCommissionHistory: 'adminTabsCommissionHistory',
  adminTabsCopyTradingHistory: 'adminTabsCopyTradingHistory',
  adminTabsCrm: 'adminTabsCrm',
  adminTabsCryptoAccounts: 'adminTabsCryptoAccounts',
  adminTabsCryptoWalletAccounts: 'adminTabsCryptoWalletAccounts',
  adminTabsDataChangeRequest: 'adminTabsDataChangeRequest',
  adminTabsDeposits: 'adminTabsDeposits',
  adminTabsDigitalWalletAccounts: 'adminTabsDigitalWalletAccounts',
  adminTabsDocuments: 'adminTabsDocuments',
  adminTabsEWallets: 'adminTabsEWallets',
  adminTabsExternalJobs: 'adminTabsExternalJobs',
  adminTabsFiles: 'adminTabsFiles',
  adminTabsFilters: 'adminTabsFilters',
  adminTabsFinance: 'adminTabsFinance',
  adminTabsFinanceSettingsAvailableBalance: 'adminTabsFinanceSettingsAvailableBalance',
  adminTabsFinanceSettingsCategorySummary: 'adminTabsFinanceSettingsCategorySummary',
  adminTabsFinanceSettingsPaymentSummary: 'adminTabsFinanceSettingsPaymentSummary',
  adminTabsFinanceSettingsWalletCategorySummary: 'adminTabsFinanceSettingsWalletCategorySummary',
  adminTabsFollowers: 'adminTabsFollowers',
  adminTabsForbiddenUsers: 'adminTabsForbiddenUsers',
  adminTabsImages: 'adminTabsImages',
  adminTabsLocalization: 'adminTabsLocalization',
  adminTabsMasters: 'adminTabsMasters',
  adminTabsMembers: 'adminTabsMembers',
  adminTabsNotes: 'adminTabsNotes',
  adminTabsOperations: 'adminTabsOperations',
  adminTabsParticipants: 'adminTabsParticipants',
  adminTabsPartnershipClosedTradesReport: 'adminTabsPartnershipClosedTradesReport',
  adminTabsPartnershipPartnerClients: 'adminTabsPartnershipPartnerClients',
  adminTabsPartnershipPartnerTradingAccounts: 'adminTabsPartnershipPartnerTradingAccounts',
  adminTabsPartnershipReferralLinks: 'adminTabsPartnershipReferralLinks',
  adminTabsPartnershipTradingVolumeReport: 'adminTabsPartnershipTradingVolumeReport',
  adminTabsProcessors: 'adminTabsProcessors',
  adminTabsReceivedUsers: 'adminTabsReceivedUsers',
  adminTabsRecipients: 'adminTabsRecipients',
  adminTabsRedeemItems: 'adminTabsRedeemItems',
  adminTabsRedeemRequests: 'adminTabsRedeemRequests',
  adminTabsReportHistory: 'adminTabsReportHistory',
  adminTabsRestrictedCountries: 'adminTabsRestrictedCountries',
  adminTabsSales: 'adminTabsSales',
  adminTabsSettings: 'adminTabsSettings',
  adminTabsTickets: 'adminTabsTickets',
  adminTabsTradingAccountTypes: 'adminTabsTradingAccountTypes',
  adminTabsTradingAccounts: 'adminTabsTradingAccounts',
  adminTabsTradingHistory: 'adminTabsTradingHistory',
  adminTabsTradingSettingsCommonTradingSettings: 'adminTabsTradingSettingsCommonTradingSettings',
  adminTabsTradingSettingsDepositWithdrawalSettings: 'adminTabsTradingSettingsDepositWithdrawalSettings',
  adminTabsUserAlias: 'adminTabsUserAlias',
  adminTabsUserCards: 'adminTabsUserCards',
  adminTabsUserSettingsArchivingSettings: 'adminTabsUserSettingsArchivingSettings',
  adminTabsUserSettingsChangeAECode: 'adminTabsUserSettingsChangeAECode',
  adminTabsUserSettingsChangeBDMCode: 'adminTabsUserSettingsChangeBDMCode',
  adminTabsUserSettingsChangeEmail: 'adminTabsUserSettingsChangeEmail',
  adminTabsUserSettingsChangeIBCode: 'adminTabsUserSettingsChangeIBCode',
  adminTabsUserSettingsChangeMAMCode: 'adminTabsUserSettingsChangeMAMCode',
  adminTabsUserSettingsChangeNickname: 'adminTabsUserSettingsChangeNickname',
  adminTabsUserSettingsChangeParentIB: 'adminTabsUserSettingsChangeParentIB',
  adminTabsUserSettingsChangePinCode: 'adminTabsUserSettingsChangePinCode',
  adminTabsUserSettingsCommissionTradingSettings: 'adminTabsUserSettingsCommissionTradingSettings',
  adminTabsUserSettingsConvertToDirect: 'adminTabsUserSettingsConvertToDirect',
  adminTabsUserSettingsDeleteUserAccount: 'adminTabsUserSettingsDeleteUserAccount',
  adminTabsUserSettingsDepositWithdrawalSettings: 'adminTabsUserSettingsDepositWithdrawalSettings',
  adminTabsUserSettingsOneTimePasswordSettings: 'adminTabsUserSettingsOneTimePasswordSettings',
  adminTabsUserSettingsOtherUserSettings: 'adminTabsUserSettingsOtherUserSettings',
  adminTabsUserSettingsOverrideEmail: 'adminTabsUserSettingsOverrideEmail',
  adminTabsUserSettingsPspFeeSettings: 'adminTabsUserSettingsPspFeeSettings',
  adminTabsUserSettingsRestoreUserAccount: 'adminTabsUserSettingsRestoreUserAccount',
  adminTabsUserSettingsSecuritySettings: 'adminTabsUserSettingsSecuritySettings',
  adminTabsUserSettingsStaffSettings: 'adminTabsUserSettingsStaffSettings',
  adminTabsUserSettingsUserTradingSettings: 'adminTabsUserSettingsUserTradingSettings',
  adminTabsUserSettingsWalletCategorySettings: 'adminTabsUserSettingsWalletCategorySettings',
  adminTabsUsers: 'adminTabsUsers',
  adminTabsWalletOperations: 'adminTabsWalletOperations',
  adminTabsWithdrawals: 'adminTabsWithdrawals',
  adminTradingAccountSettingsBonusStopOutSettingsTitle: 'adminTradingAccountSettingsBonusStopOutSettingsTitle',
  adminTradingAccountSettingsIbCodeSettingsActionName: 'adminTradingAccountSettingsIbCodeSettingsActionName',
  adminTradingAccountSettingsIbCodeSettingsChangeIBCodeError:
    'adminTradingAccountSettingsIbCodeSettingsChangeIBCodeError',
  adminTradingAccountSettingsIbCodeSettingsChangeIBCodeSuccess:
    'adminTradingAccountSettingsIbCodeSettingsChangeIBCodeSuccess',
  adminTradingAccountSettingsIbCodeSettingsTitle: 'adminTradingAccountSettingsIbCodeSettingsTitle',
  adminTradingPlatformBrandingSettingsPriorityOrderTooltip: 'adminTradingPlatformBrandingSettingsPriorityOrderTooltip',
  adminTradingPlatformBrandingSettingsTitle: 'adminTradingPlatformBrandingSettingsTitle',
  adminUserAliasesBankHint: 'adminUserAliasesBankHint',
  adminUserColumnsFinanceBlockedBalance: 'adminUserColumnsFinanceBlockedBalance',
  adminUserColumnsFinanceDepositAmount: 'adminUserColumnsFinanceDepositAmount',
  adminUserColumnsFinanceDepositCount: 'adminUserColumnsFinanceDepositCount',
  adminUserColumnsFinanceNetDepositAmount: 'adminUserColumnsFinanceNetDepositAmount',
  adminUserColumnsFinancePaymentCategory: 'adminUserColumnsFinancePaymentCategory',
  adminUserColumnsFinancePaymentSystem: 'adminUserColumnsFinancePaymentSystem',
  adminUserColumnsFinanceWithdrawAmount: 'adminUserColumnsFinanceWithdrawAmount',
  adminUserColumnsFinanceWithdrawCount: 'adminUserColumnsFinanceWithdrawCount',
  adminUserFieldsArchivingSettingsIsAllowed: 'adminUserFieldsArchivingSettingsIsAllowed',
  adminUserFieldsAutoapproved: 'adminUserFieldsAutoapproved',
  adminUserFieldsCommissionSettingsProfitShareLevel: 'adminUserFieldsCommissionSettingsProfitShareLevel',
  adminUserFieldsCommissionSettingsRebateLevel: 'adminUserFieldsCommissionSettingsRebateLevel',
  adminUserFieldsDepositWithdrawalSettingsDepositSettings: 'adminUserFieldsDepositWithdrawalSettingsDepositSettings',
  adminUserFieldsDepositWithdrawalSettingsInternalTransferSettings:
    'adminUserFieldsDepositWithdrawalSettingsInternalTransferSettings',
  adminUserFieldsDepositWithdrawalSettingsIsAllowed: 'adminUserFieldsDepositWithdrawalSettingsIsAllowed',
  adminUserFieldsDepositWithdrawalSettingsIsAllowedOnWeekend:
    'adminUserFieldsDepositWithdrawalSettingsIsAllowedOnWeekend',
  adminUserFieldsDepositWithdrawalSettingsWithdrawalSettings:
    'adminUserFieldsDepositWithdrawalSettingsWithdrawalSettings',
  adminUserFieldsIsBusinessManager: 'adminUserFieldsIsBusinessManager',
  adminUserFieldsIsMam: 'adminUserFieldsIsMam',
  adminUserFieldsIsSalesUser: 'adminUserFieldsIsSalesUser',
  adminUserFieldsOTPSettingsBypassOtpHint: 'adminUserFieldsOTPSettingsBypassOtpHint',
  adminUserFieldsOTPSettingsBypassOtpSingleTimeHint: 'adminUserFieldsOTPSettingsBypassOtpSingleTimeHint',
  adminUserFieldsOTPSettingsBypassOtpSingleTimeTitle: 'adminUserFieldsOTPSettingsBypassOtpSingleTimeTitle',
  adminUserFieldsOTPSettingsBypassOtpTitle: 'adminUserFieldsOTPSettingsBypassOtpTitle',
  adminUserFieldsOneTimePasswordSettingsRequestOTPHint: 'adminUserFieldsOneTimePasswordSettingsRequestOTPHint',
  adminUserFieldsOneTimePasswordSettingsRequestOTPTitle: 'adminUserFieldsOneTimePasswordSettingsRequestOTPTitle',
  adminUserFieldsOtherUserSettingsIsEdgeMobileTradingEnabled:
    'adminUserFieldsOtherUserSettingsIsEdgeMobileTradingEnabled',
  adminUserFieldsOtherUserSettingsIsEdgeWebTradingEnabled: 'adminUserFieldsOtherUserSettingsIsEdgeWebTradingEnabled',
  adminUserFieldsOtherUserSettingsIsSocialTradingEnabled: 'adminUserFieldsOtherUserSettingsIsSocialTradingEnabled',
  adminUserFieldsOtherUserSettingsTradingCentralAccess: 'adminUserFieldsOtherUserSettingsTradingCentralAccess',
  adminUserFieldsStaffSettingsIsStaff: 'adminUserFieldsStaffSettingsIsStaff',
  adminUserFieldsWalletCategorySettingsIsCheckWalletCategory:
    'adminUserFieldsWalletCategorySettingsIsCheckWalletCategory',
  adminUserSettingsBdmCodeSettingsActionName: 'adminUserSettingsBdmCodeSettingsActionName',
  adminUserSettingsBdmCodeSettingsChangeBDMCodeError: 'adminUserSettingsBdmCodeSettingsChangeBDMCodeError',
  adminUserSettingsBdmCodeSettingsChangeBDMCodeSuccess: 'adminUserSettingsBdmCodeSettingsChangeBDMCodeSuccess',
  adminUserSettingsBdmCodeSettingsTitle: 'adminUserSettingsBdmCodeSettingsTitle',
  adminUserSettingsChangeAECodeActionName: 'adminUserSettingsChangeAECodeActionName',
  adminUserSettingsChangeAECodeChangeAECodeError: 'adminUserSettingsChangeAECodeChangeAECodeError',
  adminUserSettingsChangeAECodeChangeAECodeSuccess: 'adminUserSettingsChangeAECodeChangeAECodeSuccess',
  adminUserSettingsChangeAECodeTitle: 'adminUserSettingsChangeAECodeTitle',
  adminUserSettingsChangeEmailActionName: 'adminUserSettingsChangeEmailActionName',
  adminUserSettingsChangeEmailChangeEmailError: 'adminUserSettingsChangeEmailChangeEmailError',
  adminUserSettingsChangeEmailChangeEmailSuccess: 'adminUserSettingsChangeEmailChangeEmailSuccess',
  adminUserSettingsChangeEmailHint: 'adminUserSettingsChangeEmailHint',
  adminUserSettingsChangeEmailTitle: 'adminUserSettingsChangeEmailTitle',
  adminUserSettingsChangeNicknameActionName: 'adminUserSettingsChangeNicknameActionName',
  adminUserSettingsChangeNicknameChangeNicknameError: 'adminUserSettingsChangeNicknameChangeNicknameError',
  adminUserSettingsChangeNicknameChangeNicknameSuccess: 'adminUserSettingsChangeNicknameChangeNicknameSuccess',
  adminUserSettingsChangeNicknameTitle: 'adminUserSettingsChangeNicknameTitle',
  adminUserSettingsCommissionSettingsTitle: 'adminUserSettingsCommissionSettingsTitle',
  adminUserSettingsConvertToDirectActionConfirmationMessage:
    'adminUserSettingsConvertToDirectActionConfirmationMessage',
  adminUserSettingsConvertToDirectActionName: 'adminUserSettingsConvertToDirectActionName',
  adminUserSettingsConvertToDirectDescriptionHeader: 'adminUserSettingsConvertToDirectDescriptionHeader',
  adminUserSettingsConvertToDirectDescriptionItemsEighth: 'adminUserSettingsConvertToDirectDescriptionItemsEighth',
  adminUserSettingsConvertToDirectDescriptionItemsFifth: 'adminUserSettingsConvertToDirectDescriptionItemsFifth',
  adminUserSettingsConvertToDirectDescriptionItemsFirst: 'adminUserSettingsConvertToDirectDescriptionItemsFirst',
  adminUserSettingsConvertToDirectDescriptionItemsFourth: 'adminUserSettingsConvertToDirectDescriptionItemsFourth',
  adminUserSettingsConvertToDirectDescriptionItemsSecond: 'adminUserSettingsConvertToDirectDescriptionItemsSecond',
  adminUserSettingsConvertToDirectDescriptionItemsSeventh: 'adminUserSettingsConvertToDirectDescriptionItemsSeventh',
  adminUserSettingsConvertToDirectDescriptionItemsSixth: 'adminUserSettingsConvertToDirectDescriptionItemsSixth',
  adminUserSettingsConvertToDirectDescriptionItemsThird: 'adminUserSettingsConvertToDirectDescriptionItemsThird',
  adminUserSettingsConvertToDirectRemoveAgentCodeHint: 'adminUserSettingsConvertToDirectRemoveAgentCodeHint',
  adminUserSettingsConvertToDirectRemovingAgentCodeField: 'adminUserSettingsConvertToDirectRemovingAgentCodeField',
  adminUserSettingsConvertToDirectTitle: 'adminUserSettingsConvertToDirectTitle',
  adminUserSettingsDeleteSettingsActionConfirmationMessage: 'adminUserSettingsDeleteSettingsActionConfirmationMessage',
  adminUserSettingsDeleteSettingsActionName: 'adminUserSettingsDeleteSettingsActionName',
  adminUserSettingsDeleteSettingsDeleteUserError: 'adminUserSettingsDeleteSettingsDeleteUserError',
  adminUserSettingsDeleteSettingsDeleteUserSuccess: 'adminUserSettingsDeleteSettingsDeleteUserSuccess',
  adminUserSettingsDeleteSettingsDescriptionHeader: 'adminUserSettingsDeleteSettingsDescriptionHeader',
  adminUserSettingsDeleteSettingsDescriptionItemsFirst: 'adminUserSettingsDeleteSettingsDescriptionItemsFirst',
  adminUserSettingsDeleteSettingsDescriptionItemsSecond: 'adminUserSettingsDeleteSettingsDescriptionItemsSecond',
  adminUserSettingsDeleteSettingsTitle: 'adminUserSettingsDeleteSettingsTitle',
  adminUserSettingsDepositWithdrawalSettingsTitle: 'adminUserSettingsDepositWithdrawalSettingsTitle',
  adminUserSettingsIbCodeSettingsActionName: 'adminUserSettingsIbCodeSettingsActionName',
  adminUserSettingsIbCodeSettingsChangeIBCodeError: 'adminUserSettingsIbCodeSettingsChangeIBCodeError',
  adminUserSettingsIbCodeSettingsChangeIBCodeSuccess: 'adminUserSettingsIbCodeSettingsChangeIBCodeSuccess',
  adminUserSettingsIbCodeSettingsHint: 'adminUserSettingsIbCodeSettingsHint',
  adminUserSettingsIbCodeSettingsTitle: 'adminUserSettingsIbCodeSettingsTitle',
  adminUserSettingsMamCodeSettingsActionName: 'adminUserSettingsMamCodeSettingsActionName',
  adminUserSettingsMamCodeSettingsChangeMAMCodeError: 'adminUserSettingsMamCodeSettingsChangeMAMCodeError',
  adminUserSettingsMamCodeSettingsChangeMAMCodeSuccess: 'adminUserSettingsMamCodeSettingsChangeMAMCodeSuccess',
  adminUserSettingsMamCodeSettingsTitle: 'adminUserSettingsMamCodeSettingsTitle',
  adminUserSettingsOneTimePasswordSettingsTitle: 'adminUserSettingsOneTimePasswordSettingsTitle',
  adminUserSettingsOtherUserSettingsTitle: 'adminUserSettingsOtherUserSettingsTitle',
  adminUserSettingsOverrideEmailActionName: 'adminUserSettingsOverrideEmailActionName',
  adminUserSettingsOverrideEmailChangeEmailError: 'adminUserSettingsOverrideEmailChangeEmailError',
  adminUserSettingsOverrideEmailChangeEmailSuccess: 'adminUserSettingsOverrideEmailChangeEmailSuccess',
  adminUserSettingsOverrideEmailHint: 'adminUserSettingsOverrideEmailHint',
  adminUserSettingsOverrideEmailTitle: 'adminUserSettingsOverrideEmailTitle',
  adminUserSettingsParentIbSettingsActionName: 'adminUserSettingsParentIbSettingsActionName',
  adminUserSettingsParentIbSettingsSetParenIbError: 'adminUserSettingsParentIbSettingsSetParenIbError',
  adminUserSettingsParentIbSettingsSetParenIbSuccess: 'adminUserSettingsParentIbSettingsSetParenIbSuccess',
  adminUserSettingsParentIbSettingsTitle: 'adminUserSettingsParentIbSettingsTitle',
  adminUserSettingsPasswordSettingsResetPasswordActionName: 'adminUserSettingsPasswordSettingsResetPasswordActionName',
  adminUserSettingsPasswordSettingsResetPasswordError: 'adminUserSettingsPasswordSettingsResetPasswordError',
  adminUserSettingsPasswordSettingsResetPasswordHint: 'adminUserSettingsPasswordSettingsResetPasswordHint',
  adminUserSettingsPasswordSettingsResetPasswordSuccess: 'adminUserSettingsPasswordSettingsResetPasswordSuccess',
  adminUserSettingsPasswordSettingsResetPasswordTitle: 'adminUserSettingsPasswordSettingsResetPasswordTitle',
  adminUserSettingsPasswordSettingsSetPasswordActionName: 'adminUserSettingsPasswordSettingsSetPasswordActionName',
  adminUserSettingsPasswordSettingsSetPasswordHint: 'adminUserSettingsPasswordSettingsSetPasswordHint',
  adminUserSettingsPasswordSettingsSetPasswordSetPasswordError:
    'adminUserSettingsPasswordSettingsSetPasswordSetPasswordError',
  adminUserSettingsPasswordSettingsSetPasswordSetPasswordSuccess:
    'adminUserSettingsPasswordSettingsSetPasswordSetPasswordSuccess',
  adminUserSettingsPasswordSettingsSetPasswordTitle: 'adminUserSettingsPasswordSettingsSetPasswordTitle',
  adminUserSettingsPinCodeSettingsGeneratePinCodeActionName:
    'adminUserSettingsPinCodeSettingsGeneratePinCodeActionName',
  adminUserSettingsPinCodeSettingsGeneratePinCodeGeneratePinCodeError:
    'adminUserSettingsPinCodeSettingsGeneratePinCodeGeneratePinCodeError',
  adminUserSettingsPinCodeSettingsGeneratePinCodeGeneratePinCodeSuccess:
    'adminUserSettingsPinCodeSettingsGeneratePinCodeGeneratePinCodeSuccess',
  adminUserSettingsPinCodeSettingsGeneratePinCodeHint: 'adminUserSettingsPinCodeSettingsGeneratePinCodeHint',
  adminUserSettingsPinCodeSettingsGeneratePinCodeTitle: 'adminUserSettingsPinCodeSettingsGeneratePinCodeTitle',
  adminUserSettingsPinCodeSettingsResetPinCodeActionName: 'adminUserSettingsPinCodeSettingsResetPinCodeActionName',
  adminUserSettingsPinCodeSettingsResetPinCodeHint: 'adminUserSettingsPinCodeSettingsResetPinCodeHint',
  adminUserSettingsPinCodeSettingsResetPinCodeResetPinCodeError:
    'adminUserSettingsPinCodeSettingsResetPinCodeResetPinCodeError',
  adminUserSettingsPinCodeSettingsResetPinCodeResetPinCodeSuccess:
    'adminUserSettingsPinCodeSettingsResetPinCodeResetPinCodeSuccess',
  adminUserSettingsPinCodeSettingsResetPinCodeTitle: 'adminUserSettingsPinCodeSettingsResetPinCodeTitle',
  adminUserSettingsPspFeeSettingsDaysWindow: 'adminUserSettingsPspFeeSettingsDaysWindow',
  adminUserSettingsPspFeeSettingsFeeCurrency: 'adminUserSettingsPspFeeSettingsFeeCurrency',
  adminUserSettingsPspFeeSettingsNumberOfOperations: 'adminUserSettingsPspFeeSettingsNumberOfOperations',
  adminUserSettingsPspFeeSettingsNumberOfOperationsComparison:
    'adminUserSettingsPspFeeSettingsNumberOfOperationsComparison',
  adminUserSettingsPspFeeSettingsOperationAmount: 'adminUserSettingsPspFeeSettingsOperationAmount',
  adminUserSettingsPspFeeSettingsOperationAmountComparison: 'adminUserSettingsPspFeeSettingsOperationAmountComparison',
  adminUserSettingsPspFeeSettingsRate: 'adminUserSettingsPspFeeSettingsRate',
  adminUserSettingsPspFeeSettingsTitle: 'adminUserSettingsPspFeeSettingsTitle',
  adminUserSettingsRemoveAECodeActionName: 'adminUserSettingsRemoveAECodeActionName',
  adminUserSettingsRemoveAECodeRemoveAECodeError: 'adminUserSettingsRemoveAECodeRemoveAECodeError',
  adminUserSettingsRemoveAECodeRemoveAECodeSuccess: 'adminUserSettingsRemoveAECodeRemoveAECodeSuccess',
  adminUserSettingsRemoveAECodeTitle: 'adminUserSettingsRemoveAECodeTitle',
  adminUserSettingsRestoreSettingsActionConfirmationMessage:
    'adminUserSettingsRestoreSettingsActionConfirmationMessage',
  adminUserSettingsRestoreSettingsActionName: 'adminUserSettingsRestoreSettingsActionName',
  adminUserSettingsRestoreSettingsDescriptionHeader: 'adminUserSettingsRestoreSettingsDescriptionHeader',
  adminUserSettingsRestoreSettingsDescriptionItemsFirst: 'adminUserSettingsRestoreSettingsDescriptionItemsFirst',
  adminUserSettingsRestoreSettingsDescriptionItemsSecond: 'adminUserSettingsRestoreSettingsDescriptionItemsSecond',
  adminUserSettingsRestoreSettingsRestoreUserError: 'adminUserSettingsRestoreSettingsRestoreUserError',
  adminUserSettingsRestoreSettingsRestoreUserSuccess: 'adminUserSettingsRestoreSettingsRestoreUserSuccess',
  adminUserSettingsRestoreSettingsTitle: 'adminUserSettingsRestoreSettingsTitle',
  adminUserSettingsWalletCategorySettingsTitle: 'adminUserSettingsWalletCategorySettingsTitle',
  adminUserTradingAccountTypeLimitLeverages: 'adminUserTradingAccountTypeLimitLeverages',
  adminUserTradingAccountTypeLimitMaxNumber: 'adminUserTradingAccountTypeLimitMaxNumber',
  adminUserTradingAccountTypeLimitTitle: 'adminUserTradingAccountTypeLimitTitle',
  adminUserTradingAccountTypeLimitUserType: 'adminUserTradingAccountTypeLimitUserType',
  adminUserTradingAccountTypeLimitUserTypeHint: 'adminUserTradingAccountTypeLimitUserTypeHint',
  areYouSureYouWantToLeavePageWithoutSavingQuestion: 'areYouSureYouWantToLeavePageWithoutSavingQuestion',
  assignedToMe: 'assignedToMe',
  autoSuggestionFieldsBusinessManager: 'autoSuggestionFieldsBusinessManager',
  autoSuggestionFieldsIb: 'autoSuggestionFieldsIb',
  autoSuggestionFieldsNoMatchMessage: 'autoSuggestionFieldsNoMatchMessage',
  autoSuggestionFieldsSalesUser: 'autoSuggestionFieldsSalesUser',
  autoSuggestionFieldsUser: 'autoSuggestionFieldsUser',
  availableCountriesAllCountriesHintMessage: 'availableCountriesAllCountriesHintMessage',
  availableCountriesFieldsState: 'availableCountriesFieldsState',
  backgroundJobsFieldsQueue: 'backgroundJobsFieldsQueue',
  backgroundJobsHistoryActionsRepeat: 'backgroundJobsHistoryActionsRepeat',
  backgroundJobsHistoryDetailsPageTitle: 'backgroundJobsHistoryDetailsPageTitle',
  backgroundJobsHistoryFieldsCompletedOn: 'backgroundJobsHistoryFieldsCompletedOn',
  backgroundJobsHistoryFieldsDuration: 'backgroundJobsHistoryFieldsDuration',
  backgroundJobsHistoryFieldsError: 'backgroundJobsHistoryFieldsError',
  backgroundJobsHistoryFieldsExternalJobId: 'backgroundJobsHistoryFieldsExternalJobId',
  backgroundJobsHistoryFieldsParameters: 'backgroundJobsHistoryFieldsParameters',
  backgroundJobsHistoryFieldsRetryAttempt: 'backgroundJobsHistoryFieldsRetryAttempt',
  backgroundJobsHistoryFieldsScheduledOn: 'backgroundJobsHistoryFieldsScheduledOn',
  backgroundJobsHistoryFieldsStartedOn: 'backgroundJobsHistoryFieldsStartedOn',
  backgroundJobsHistoryGridPageTitle: 'backgroundJobsHistoryGridPageTitle',
  backgroundJobsHistoryMessagesFeatureDisabled: 'backgroundJobsHistoryMessagesFeatureDisabled',
  backgroundJobsHistoryMessagesRepeatError: 'backgroundJobsHistoryMessagesRepeatError',
  backgroundJobsHistoryMessagesRepeatedSuccessfully: 'backgroundJobsHistoryMessagesRepeatedSuccessfully',
  backgroundJobsHistoryMessagesWasNotRepeated: 'backgroundJobsHistoryMessagesWasNotRepeated',
  backgroundJobsHistoryTabName: 'backgroundJobsHistoryTabName',
  backgroundJobsRecurringFieldsLastExecution: 'backgroundJobsRecurringFieldsLastExecution',
  backgroundJobsRecurringFieldsNextExecution: 'backgroundJobsRecurringFieldsNextExecution',
  backgroundJobsRecurringFieldsSchedule: 'backgroundJobsRecurringFieldsSchedule',
  backgroundJobsRecurringRescheduleButtonText: 'backgroundJobsRecurringRescheduleButtonText',
  backgroundJobsRecurringRescheduleConfirmationText: 'backgroundJobsRecurringRescheduleConfirmationText',
  bonusProgram: 'bonusProgram',
  bonusesAvailableTableAvailableBonuses: 'bonusesAvailableTableAvailableBonuses',
  bonusesAvailableTableBonusName: 'bonusesAvailableTableBonusName',
  bonusesAvailableTableTimeLeftToDeposit: 'bonusesAvailableTableTimeLeftToDeposit',
  bonusesConfirmBonus: 'bonusesConfirmBonus',
  bonusesFileFormatHintMessage: 'bonusesFileFormatHintMessage',
  bonusesInfinity: 'bonusesInfinity',
  bonusesTitle: 'bonusesTitle',
  bonusesTypeTableBonusLimit: 'bonusesTypeTableBonusLimit',
  bonusesTypeTableBonusName: 'bonusesTypeTableBonusName',
  bonusesTypeTableTitle: 'bonusesTypeTableTitle',
  bonusesTypeTableTotalAdded: 'bonusesTypeTableTotalAdded',
  bonusesTypeTableTotalAvailable: 'bonusesTypeTableTotalAvailable',
  bonusesUserTableAvailableTill: 'bonusesUserTableAvailableTill',
  bonusesUserTableBonusAmount: 'bonusesUserTableBonusAmount',
  bonusesUserTableBonusName: 'bonusesUserTableBonusName',
  bonusesUserTablePaymentId: 'bonusesUserTablePaymentId',
  bonusesUserTablePspAmount: 'bonusesUserTablePspAmount',
  bonusesUserTablePspAmountUSD: 'bonusesUserTablePspAmountUSD',
  bonusesUserTablePublicCommentMeta: 'bonusesUserTablePublicCommentMeta',
  bonusesUserTableShowWithExpiration: 'bonusesUserTableShowWithExpiration',
  bonusesUserTableTitle: 'bonusesUserTableTitle',
  bonusesViewAllBonuses: 'bonusesViewAllBonuses',
  bulkActionStatus: 'bulkActionStatus',
  byCopyingNewMasterYouWillAutomaticallyStopCopyingMaster: 'byCopyingNewMasterYouWillAutomaticallyStopCopyingMaster',
  chartTitlesNoData: 'chartTitlesNoData',
  chartTitlesProfitabilityTitle: 'chartTitlesProfitabilityTitle',
  chartTitlesProfitabilityTooltip: 'chartTitlesProfitabilityTooltip',
  chartTitlesTradingTitle: 'chartTitlesTradingTitle',
  chartTitlesTradingVolumeLotTitle: 'chartTitlesTradingVolumeLotTitle',
  chartTitlesTradingVolumeLotTooltip: 'chartTitlesTradingVolumeLotTooltip',
  chartTitlesTradingVolumeUscTitle: 'chartTitlesTradingVolumeUscTitle',
  chartTitlesTradingVolumeUscTooltip: 'chartTitlesTradingVolumeUscTooltip',
  chartTitlesTradingVolumeUsdTitle: 'chartTitlesTradingVolumeUsdTitle',
  chartTitlesTradingVolumeUsdTooltip: 'chartTitlesTradingVolumeUsdTooltip',
  commonAccountNumber: 'commonAccountNumber',
  commonAction: 'commonAction',
  commonAll: 'commonAll',
  commonApply: 'commonApply',
  commonBalance: 'commonBalance',
  commonBeneficiaryBank: 'commonBeneficiaryBank',
  commonBeneficiaryName: 'commonBeneficiaryName',
  commonBlockedBalance: 'commonBlockedBalance',
  commonButton: 'commonButton',
  commonClassName: 'commonClassName',
  commonClose: 'commonClose',
  commonContent: 'commonContent',
  commonCredit: 'commonCredit',
  commonCustom: 'commonCustom',
  commonDate: 'commonDate',
  commonDearUserName: 'commonDearUserName',
  commonDeposit: 'commonDeposit',
  commonDescription: 'commonDescription',
  commonDigitalWallet: 'commonDigitalWallet',
  commonDocumentsCaps: 'commonDocumentsCaps',
  commonDragAndDropPlaceholder: 'commonDragAndDropPlaceholder',
  commonDuration: 'commonDuration',
  commonDurationEndsIn: 'commonDurationEndsIn',
  commonDurationInDays: 'commonDurationInDays',
  commonDurationInHours: 'commonDurationInHours',
  commonDurationInMinutes: 'commonDurationInMinutes',
  commonEWallet: 'commonEWallet',
  commonEnableField: 'commonEnableField',
  commonEndDate: 'commonEndDate',
  commonEquity: 'commonEquity',
  commonFailed: 'commonFailed',
  commonFreeMargin: 'commonFreeMargin',
  commonFrom: 'commonFrom',
  commonHistory: 'commonHistory',
  commonIPAddress: 'commonIPAddress',
  commonImage: 'commonImage',
  commonImageUploading: 'commonImageUploading',
  commonJoin: 'commonJoin',
  commonLastNdays: 'commonLastNdays',
  commonLeverage: 'commonLeverage',
  commonLink: 'commonLink',
  commonMargin: 'commonMargin',
  commonMaxSizeMb: 'commonMaxSizeMb',
  commonMore: 'commonMore',
  commonNewButton: 'commonNewButton',
  commonNoResults: 'commonNoResults',
  commonNote: 'commonNote',
  commonParticipant: 'commonParticipant',
  commonParticipants: 'commonParticipants',
  commonPaymentSystem: 'commonPaymentSystem',
  commonPlatformType: 'commonPlatformType',
  commonPleaseInputImageUrl: 'commonPleaseInputImageUrl',
  commonPleaseNote: 'commonPleaseNote',
  commonPreview: 'commonPreview',
  commonProcessor: 'commonProcessor',
  commonReadMore: 'commonReadMore',
  commonResendNow: 'commonResendNow',
  commonRole: 'commonRole',
  commonSelectRange: 'commonSelectRange',
  commonSendItAgainInSeconds: 'commonSendItAgainInSeconds',
  commonStartDate: 'commonStartDate',
  commonStatus: 'commonStatus',
  commonSuccess: 'commonSuccess',
  commonText: 'commonText',
  commonThisMonth: 'commonThisMonth',
  commonThisWeek: 'commonThisWeek',
  commonTime: 'commonTime',
  commonTo: 'commonTo',
  commonToday: 'commonToday',
  commonToken: 'commonToken',
  commonTotal: 'commonTotal',
  commonTrade: 'commonTrade',
  commonTradingSymbols: 'commonTradingSymbols',
  commonUrl: 'commonUrl',
  commonUser: 'commonUser',
  commonUserSignature: 'commonUserSignature',
  commonValueMustBeInteger: 'commonValueMustBeInteger',
  commonVisible: 'commonVisible',
  commonWarningMessageBulkOperationInfo: 'commonWarningMessageBulkOperationInfo',
  commonWarningMessageCommentBulkOperation: 'commonWarningMessageCommentBulkOperation',
  commonWithdrawal: 'commonWithdrawal',
  commonYesterday: 'commonYesterday',
  companyAccountBankName: 'companyAccountBankName',
  companyAccountLegalEntity: 'companyAccountLegalEntity',
  companyAccountLegalEntityName: 'companyAccountLegalEntityName',
  companyTransferBeneficiaryCurrency: 'companyTransferBeneficiaryCurrency',
  companyTransferDate: 'companyTransferDate',
  companyTransferInitialBankRequest: 'companyTransferInitialBankRequest',
  companyTransferIntercompanyTransfer: 'companyTransferIntercompanyTransfer',
  companyTransferIsBankRequestExists: 'companyTransferIsBankRequestExists',
  companyTransferOurResponse: 'companyTransferOurResponse',
  companyTransferReceiverAmount: 'companyTransferReceiverAmount',
  companyTransferSenderAmount: 'companyTransferSenderAmount',
  companyTransferSenderBank: 'companyTransferSenderBank',
  companyTransferSenderCurrency: 'companyTransferSenderCurrency',
  companyTransferSenderName: 'companyTransferSenderName',
  componentsClass: 'componentsClass',
  componentsInterface: 'componentsInterface',
  componentsLabel: 'componentsLabel',
  componentsName: 'componentsName',
  componentsParameters: 'componentsParameters',
  contest: 'contest',
  copyToClipboardFailed: 'copyToClipboardFailed',
  copyTradeAllocationModeDeterminesHowFollowersReplicate: 'copyTradeAllocationModeDeterminesHowFollowersReplicate',
  copyTradingAverageDrawDownTitle: 'copyTradingAverageDrawDownTitle',
  copyTradingAverageDrawDownTooltip: 'copyTradingAverageDrawDownTooltip',
  copyTradingCommissionAccount: 'copyTradingCommissionAccount',
  copyTradingInvestor: 'copyTradingInvestor',
  copyTradingIsVisible: 'copyTradingIsVisible',
  copyTradingMakeMinDepositAmountRequiredHint: 'copyTradingMakeMinDepositAmountRequiredHint',
  copyTradingMakeMinDepositAmountRequiredTitle: 'copyTradingMakeMinDepositAmountRequiredTitle',
  copyTradingMaster: 'copyTradingMaster',
  copyTradingMasterForCopy: 'copyTradingMasterForCopy',
  copyTradingMasterNickname: 'copyTradingMasterNickname',
  copyTradingMastersRating: 'copyTradingMastersRating',
  copyTradingMastersRatingFootnote: 'copyTradingMastersRatingFootnote',
  copyTradingMaxDrawDownTitle: 'copyTradingMaxDrawDownTitle',
  copyTradingMaxDrawDownTooltip: 'copyTradingMaxDrawDownTooltip',
  copyTradingMinDepositAmountTitle: 'copyTradingMinDepositAmountTitle',
  copyTradingProfitSharingTitle: 'copyTradingProfitSharingTitle',
  copyTradingProfitSharingTooltip: 'copyTradingProfitSharingTooltip',
  copyTradingReturnOnInvestmentTitle: 'copyTradingReturnOnInvestmentTitle',
  copyTradingReturnOnInvestmentTooltip: 'copyTradingReturnOnInvestmentTooltip',
  copyTradingSelfTrade: 'copyTradingSelfTrade',
  copyTradingTotalFundsTitle: 'copyTradingTotalFundsTitle',
  copyTradingTotalFundsTooltip: 'copyTradingTotalFundsTooltip',
  copying: 'copying',
  countrySupportGuardContinueBrowsing: 'countrySupportGuardContinueBrowsing',
  countrySupportGuardSubTitleOne: 'countrySupportGuardSubTitleOne',
  countrySupportGuardSubTitleThree: 'countrySupportGuardSubTitleThree',
  countrySupportGuardSubTitleTwo: 'countrySupportGuardSubTitleTwo',
  countrySupportGuardTitle: 'countrySupportGuardTitle',
  customNotificationCancelConfirmationMsg: 'customNotificationCancelConfirmationMsg',
  customNotificationEmailCategory: 'customNotificationEmailCategory',
  customNotificationFailed: 'customNotificationFailed',
  customNotificationRead: 'customNotificationRead',
  customNotificationRetryConfirmationMsg: 'customNotificationRetryConfirmationMsg',
  customNotificationSent: 'customNotificationSent',
  customNotificationTotal: 'customNotificationTotal',
  customPushNotificationCancelConfirmationMsg: 'customPushNotificationCancelConfirmationMsg',
  customPushNotificationFieldHint: 'customPushNotificationFieldHint',
  customPushNotificationRetryConfirmationMsg: 'customPushNotificationRetryConfirmationMsg',
  dashboardAdmin: 'dashboardAdmin',
  dataChangeRequest: 'dataChangeRequest',
  dataChangeRequestCurrentData: 'dataChangeRequestCurrentData',
  dataChangeRequestNewData: 'dataChangeRequestNewData',
  dataChangeRequests: 'dataChangeRequests',
  dataImportCsvStatus: 'dataImportCsvStatus',
  dataImportEntityId: 'dataImportEntityId',
  dataImportExecutedStatus: 'dataImportExecutedStatus',
  dataImportFailure: 'dataImportFailure',
  dataImportFileItemTooltip: 'dataImportFileItemTooltip',
  dataImportImportItem: 'dataImportImportItem',
  dataImportImportItemRecordList: 'dataImportImportItemRecordList',
  dataImportImportMode: 'dataImportImportMode',
  dataImportLineNumber: 'dataImportLineNumber',
  dataImportLog: 'dataImportLog',
  dataImportLogAction: 'dataImportLogAction',
  dataImportLogMessage: 'dataImportLogMessage',
  dataImportPreImportStatus: 'dataImportPreImportStatus',
  dataImportRecords: 'dataImportRecords',
  dataImportSuccess: 'dataImportSuccess',
  dataImportTemplate: 'dataImportTemplate',
  dataImportTotal: 'dataImportTotal',
  dataImportTypeTooltip: 'dataImportTypeTooltip',
  depositFinancialIdentityType: 'depositFinancialIdentityType',
  digitalWalletPhoneNumberHint: 'digitalWalletPhoneNumberHint',
  doYouReallyWantToReAsssignAllUsersToNewSalesUserQuestion: 'doYouReallyWantToReAsssignAllUsersToNewSalesUserQuestion',
  doYouReallyWantToReAsssignUsersToNewSalesUserQuestion: 'doYouReallyWantToReAsssignUsersToNewSalesUserQuestion',
  documentOpenFullSize: 'documentOpenFullSize',
  documentTypeConfigBankStatementTitle: 'documentTypeConfigBankStatementTitle',
  documentViewerLoadingError: 'documentViewerLoadingError',
  documentViewerPasswordError: 'documentViewerPasswordError',
  educationPortalAvailableLanguages: 'educationPortalAvailableLanguages',
  educationPortalEducationVideoTitle: 'educationPortalEducationVideoTitle',
  educationPortalRelatedVideos: 'educationPortalRelatedVideos',
  emailTemlateStyleWidth: 'emailTemlateStyleWidth',
  emailTemplateArchivedTemplates: 'emailTemplateArchivedTemplates',
  emailTemplateBottom: 'emailTemplateBottom',
  emailTemplateCenter: 'emailTemplateCenter',
  emailTemplateColumn: 'emailTemplateColumn',
  emailTemplateContainer: 'emailTemplateContainer',
  emailTemplateDesktop: 'emailTemplateDesktop',
  emailTemplateEditor: 'emailTemplateEditor',
  emailTemplateEmailTemplate: 'emailTemplateEmailTemplate',
  emailTemplateEmailTemplates: 'emailTemplateEmailTemplates',
  emailTemplateGallerySelectImage: 'emailTemplateGallerySelectImage',
  emailTemplateGoToEditor: 'emailTemplateGoToEditor',
  emailTemplateImageAlt: 'emailTemplateImageAlt',
  emailTemplateImagePlaceholder: 'emailTemplateImagePlaceholder',
  emailTemplateLeft: 'emailTemplateLeft',
  emailTemplateMobile: 'emailTemplateMobile',
  emailTemplateRight: 'emailTemplateRight',
  emailTemplateRow: 'emailTemplateRow',
  emailTemplateSaveTemplate: 'emailTemplateSaveTemplate',
  emailTemplateSection: 'emailTemplateSection',
  emailTemplateStyleBackgroundColor: 'emailTemplateStyleBackgroundColor',
  emailTemplateStyleBorderRadius: 'emailTemplateStyleBorderRadius',
  emailTemplateStyleFontColor: 'emailTemplateStyleFontColor',
  emailTemplateStyleFontSize: 'emailTemplateStyleFontSize',
  emailTemplateStyleHeight: 'emailTemplateStyleHeight',
  emailTemplateStyleHeightPlaceholder: 'emailTemplateStyleHeightPlaceholder',
  emailTemplateStylePadding: 'emailTemplateStylePadding',
  emailTemplateStyleTextAlign: 'emailTemplateStyleTextAlign',
  emailTemplateStyleWidthPlaceholder: 'emailTemplateStyleWidthPlaceholder',
  emailTemplateStyles: 'emailTemplateStyles',
  emailTemplateTop: 'emailTemplateTop',
  errorsCaptchaCaptchaServerIsUnavailable: 'errorsCaptchaCaptchaServerIsUnavailable',
  errorsUserCantChangeLanguage: 'errorsUserCantChangeLanguage',
  ewalletBalanceAfter: 'ewalletBalanceAfter',
  ewalletBalanceBefore: 'ewalletBalanceBefore',
  ewalletBlockedBalance: 'ewalletBlockedBalance',
  ewalletBlockedBalanceAfter: 'ewalletBlockedBalanceAfter',
  ewalletBlockedBalanceBefore: 'ewalletBlockedBalanceBefore',
  ewalletDescription: 'ewalletDescription',
  ewalletEwalletTitle: 'ewalletEwalletTitle',
  ewalletExecutionType: 'ewalletExecutionType',
  ewalletHistoryTitle: 'ewalletHistoryTitle',
  ewalletOpertionDetailsTitle: 'ewalletOpertionDetailsTitle',
  ewalletTransferType: 'ewalletTransferType',
  ewalletWalletAccountId: 'ewalletWalletAccountId',
  ewalletWalletAccountType: 'ewalletWalletAccountType',
  ewalletWalletNumber: 'ewalletWalletNumber',
  ewalletWalletOperationId: 'ewalletWalletOperationId',
  fileImportFieldsCreatedCount: 'fileImportFieldsCreatedCount',
  fileImportFieldsFailedCount: 'fileImportFieldsFailedCount',
  fileImportFieldsShowLogAction: 'fileImportFieldsShowLogAction',
  fileImportFieldsUpdatedCount: 'fileImportFieldsUpdatedCount',
  filterOperatorDescriptionEnumOrEnumAsStringEndWith: 'filterOperatorDescriptionEnumOrEnumAsStringEndWith',
  filterOperatorDescriptionEnumOrEnumAsStringEqual: 'filterOperatorDescriptionEnumOrEnumAsStringEqual',
  filterOperatorDescriptionEnumOrEnumAsStringIn: 'filterOperatorDescriptionEnumOrEnumAsStringIn',
  filterOperatorDescriptionEnumOrEnumAsStringIsNotNull: 'filterOperatorDescriptionEnumOrEnumAsStringIsNotNull',
  filterOperatorDescriptionEnumOrEnumAsStringIsNotNullOrEmpty:
    'filterOperatorDescriptionEnumOrEnumAsStringIsNotNullOrEmpty',
  filterOperatorDescriptionEnumOrEnumAsStringIsNull: 'filterOperatorDescriptionEnumOrEnumAsStringIsNull',
  filterOperatorDescriptionEnumOrEnumAsStringIsNullOrEmpty: 'filterOperatorDescriptionEnumOrEnumAsStringIsNullOrEmpty',
  filterOperatorDescriptionEnumOrEnumAsStringLike: 'filterOperatorDescriptionEnumOrEnumAsStringLike',
  filterOperatorDescriptionEnumOrEnumAsStringNotEqual: 'filterOperatorDescriptionEnumOrEnumAsStringNotEqual',
  filterOperatorDescriptionEnumOrEnumAsStringNotIn: 'filterOperatorDescriptionEnumOrEnumAsStringNotIn',
  filterOperatorDescriptionEnumOrEnumAsStringStartWith: 'filterOperatorDescriptionEnumOrEnumAsStringStartWith',
  financialIdentityType: 'financialIdentityType',
  followUpDescriptionValidation: 'followUpDescriptionValidation',
  followUpErrorFailedToGetDeclineReason: 'followUpErrorFailedToGetDeclineReason',
  formValidationLimitValidation: 'formValidationLimitValidation',
  formatsFormatNumber: 'formatsFormatNumber',
  formsBrowse: 'formsBrowse',
  formsChoose: 'formsChoose',
  formsChooseFile: 'formsChooseFile',
  formsCreateNew: 'formsCreateNew',
  formsDataRangeAllOption: 'formsDataRangeAllOption',
  formsDataRangeCurrentDayOption: 'formsDataRangeCurrentDayOption',
  formsDataRangeCurrentMonthOption: 'formsDataRangeCurrentMonthOption',
  formsDataRangeCustomOption: 'formsDataRangeCustomOption',
  formsDataRangePastDayOption: 'formsDataRangePastDayOption',
  formsDataRangePastMonthOption: 'formsDataRangePastMonthOption',
  formsDatePlaceholdersDay: 'formsDatePlaceholdersDay',
  formsDatePlaceholdersMonth: 'formsDatePlaceholdersMonth',
  formsDatePlaceholdersYear: 'formsDatePlaceholdersYear',
  formsExport: 'formsExport',
  formsFilter: 'formsFilter',
  formsFrom: 'formsFrom',
  formsInputTooltipsIbCode: 'formsInputTooltipsIbCode',
  formsMax: 'formsMax',
  formsMin: 'formsMin',
  formsPasswordStrengthHasLowercase: 'formsPasswordStrengthHasLowercase',
  formsPasswordStrengthHasNumber: 'formsPasswordStrengthHasNumber',
  formsPasswordStrengthHasSpecialCharacters: 'formsPasswordStrengthHasSpecialCharacters',
  formsPasswordStrengthHasUppercase: 'formsPasswordStrengthHasUppercase',
  formsPasswordStrengthMinLength: 'formsPasswordStrengthMinLength',
  formsPlaceholdersNameOrEmail: 'formsPlaceholdersNameOrEmail',
  formsPlaceholdersTypeNumber: 'formsPlaceholdersTypeNumber',
  formsPlaceholdersTypeText: 'formsPlaceholdersTypeText',
  formsSearch: 'formsSearch',
  formsSegmentedSelectorOptionAll: 'formsSegmentedSelectorOptionAll',
  formsSelect: 'formsSelect',
  formsTo: 'formsTo',
  formsValidationBeneficiaryAccountFieldError: 'formsValidationBeneficiaryAccountFieldError',
  formsValidationBeneficiaryAccountFieldErrorWithLength: 'formsValidationBeneficiaryAccountFieldErrorWithLength',
  formsValidationConfirmError: 'formsValidationConfirmError',
  formsValidationDateTimeError: 'formsValidationDateTimeError',
  formsValidationDigitsOnlyError: 'formsValidationDigitsOnlyError',
  formsValidationEightCharactersLong: 'formsValidationEightCharactersLong',
  formsValidationEmailError: 'formsValidationEmailError',
  formsValidationFieldIsNotFilledIn: 'formsValidationFieldIsNotFilledIn',
  formsValidationFirstNameOnlyChineseCharacters: 'formsValidationFirstNameOnlyChineseCharacters',
  formsValidationFullNameOnlyChineseCharacters: 'formsValidationFullNameOnlyChineseCharacters',
  formsValidationIfscFieldError: 'formsValidationIfscFieldError',
  formsValidationInt32Error: 'formsValidationInt32Error',
  formsValidationInvalidDate: 'formsValidationInvalidDate',
  formsValidationInvalidNumericValue: 'formsValidationInvalidNumericValue',
  formsValidationLastNameOnlyChineseCharacters: 'formsValidationLastNameOnlyChineseCharacters',
  formsValidationMapError: 'formsValidationMapError',
  formsValidationNewPasswordDifferFromOldOne: 'formsValidationNewPasswordDifferFromOldOne',
  formsValidationNewPasswordIsDifferent: 'formsValidationNewPasswordIsDifferent',
  formsValidationNoWhitespaceCharsError: 'formsValidationNoWhitespaceCharsError',
  formsValidationOneLowercaseLetter: 'formsValidationOneLowercaseLetter',
  formsValidationOneNumber: 'formsValidationOneNumber',
  formsValidationOneSpecialSymbol: 'formsValidationOneSpecialSymbol',
  formsValidationOneUppercaseLetter: 'formsValidationOneUppercaseLetter',
  formsValidationOnlyEnglishAndDigitsAndSpecialSymbolsError:
    'formsValidationOnlyEnglishAndDigitsAndSpecialSymbolsError',
  formsValidationOnlyEnglishAndDigitsError: 'formsValidationOnlyEnglishAndDigitsError',
  formsValidationOnlyEnglishError: 'formsValidationOnlyEnglishError',
  formsValidationOutRange: 'formsValidationOutRange',
  formsValidationOutTotal: 'formsValidationOutTotal',
  formsValidationRepeatedCharacters: 'formsValidationRepeatedCharacters',
  formsValidationRequiredError: 'formsValidationRequiredError',
  formsValidationRequiredErrorCanBe0: 'formsValidationRequiredErrorCanBe0',
  formsValidationStrengthError: 'formsValidationStrengthError',
  formsValidationValueShouldBeEmptyOrGreaterThan: 'formsValidationValueShouldBeEmptyOrGreaterThan',
  formsValidationValueShouldBeGreaterThan: 'formsValidationValueShouldBeGreaterThan',
  formsValidationValueShouldBeLowerThan: 'formsValidationValueShouldBeLowerThan',
  governmentPhotoCitizenship: 'governmentPhotoCitizenship',
  governmentPhotoDocumentNumber: 'governmentPhotoDocumentNumber',
  governmentPhotoDocumentType: 'governmentPhotoDocumentType',
  governmentPhotoNationalIDNumber: 'governmentPhotoNationalIDNumber',
  headerWithBalanceAccountBalance: 'headerWithBalanceAccountBalance',
  headerWithBalanceFailedToFetchBalance: 'headerWithBalanceFailedToFetchBalance',
  headerWithBalanceGrid: 'headerWithBalanceGrid',
  headerWithBalanceList: 'headerWithBalanceList',
  headerWithBalanceTABalance: 'headerWithBalanceTABalance',
  iDAddress: 'iDAddress',
  ibCommissionChildRebate: 'ibCommissionChildRebate',
  ibCommissionCloseTime: 'ibCommissionCloseTime',
  ibCommissionCommission: 'ibCommissionCommission',
  ibCommissionCommissionHistoryId: 'ibCommissionCommissionHistoryId',
  ibCommissionCommissionInTaCurrency: 'ibCommissionCommissionInTaCurrency',
  ibCommissionCommissionUnit: 'ibCommissionCommissionUnit',
  ibCommissionIbLevel: 'ibCommissionIbLevel',
  ibCommissionIsDirect: 'ibCommissionIsDirect',
  ibCommissionNotPaidRebate: 'ibCommissionNotPaidRebate',
  ibCommissionOpenTime: 'ibCommissionOpenTime',
  ibCommissionPaidToWallet: 'ibCommissionPaidToWallet',
  ibCommissionPayoutModel: 'ibCommissionPayoutModel',
  ibCommissionPipTaCurrency: 'ibCommissionPipTaCurrency',
  ibCommissionRate: 'ibCommissionRate',
  ibCommissionRateForConversionToAccountCurrency: 'ibCommissionRateForConversionToAccountCurrency',
  ibCommissionRebate: 'ibCommissionRebate',
  ibCommissionRebateExcluded: 'ibCommissionRebateExcluded',
  ibCommissionRebateInTaCurrency: 'ibCommissionRebateInTaCurrency',
  ibCommissionRebateUnit: 'ibCommissionRebateUnit',
  ibCommissionSpread: 'ibCommissionSpread',
  ibCommissionSpreadInTaCurrency: 'ibCommissionSpreadInTaCurrency',
  ibCommissionSpreadUnit: 'ibCommissionSpreadUnit',
  ibCommissionSymbol: 'ibCommissionSymbol',
  ibCommissionTicket: 'ibCommissionTicket',
  ibCommissionTotalInTaCurrency: 'ibCommissionTotalInTaCurrency',
  ibCommissionTotalInUsd: 'ibCommissionTotalInUsd',
  ibCommissionTotalPayoutTaCurrency: 'ibCommissionTotalPayoutTaCurrency',
  ibCommissionTradingAccountCurrency: 'ibCommissionTradingAccountCurrency',
  ibCommissionUserLevel: 'ibCommissionUserLevel',
  ibCommissionVolume: 'ibCommissionVolume',
  ibCommissionVolumeInLots: 'ibCommissionVolumeInLots',
  imageProcessingConfirmationText: 'imageProcessingConfirmationText',
  importItemImportConfirmMessage: 'importItemImportConfirmMessage',
  importItemValidateConfirmMessage: 'importItemValidateConfirmMessage',
  investorsCount: 'investorsCount',
  investorsFieldsAccount: 'investorsFieldsAccount',
  investorsFieldsCopyingMyMasterAccount: 'investorsFieldsCopyingMyMasterAccount',
  investorsFieldsMasterAccount: 'investorsFieldsMasterAccount',
  investorsFieldsPosition: 'investorsFieldsPosition',
  investorsFieldsSubscribedOn: 'investorsFieldsSubscribedOn',
  investorsFieldsTotalDeposits: 'investorsFieldsTotalDeposits',
  investorsFieldsTotalWithdrawals: 'investorsFieldsTotalWithdrawals',
  investorsHint: 'investorsHint',
  investorsInvestorNickname: 'investorsInvestorNickname',
  investorsInvestors: 'investorsInvestors',
  investorsInvestorsAccount: 'investorsInvestorsAccount',
  investorsPlaceholder: 'investorsPlaceholder',
  investorsTitle: 'investorsTitle',
  jurisdictionAdminJurisdiction: 'jurisdictionAdminJurisdiction',
  jurisdictionAdminStartProcessingBtn: 'jurisdictionAdminStartProcessingBtn',
  jurisdictionAdminStartedProcessingSuccessfully: 'jurisdictionAdminStartedProcessingSuccessfully',
  jurisdictionAdminToJurisdiction: 'jurisdictionAdminToJurisdiction',
  jurisdictionAgreementAcceptedOn: 'jurisdictionAgreementAcceptedOn',
  jurisdictionAgreementIsAccepted: 'jurisdictionAgreementIsAccepted',
  jurisdictionAgreementReadOn: 'jurisdictionAgreementReadOn',
  jurisdictionPopupAcceptButton: 'jurisdictionPopupAcceptButton',
  jurisdictionPopupChatButton: 'jurisdictionPopupChatButton',
  jurisdictionPopupQuestions: 'jurisdictionPopupQuestions',
  jurisdictionPopupReadDocuments: 'jurisdictionPopupReadDocuments',
  jurisdictionTitle: 'jurisdictionTitle',
  kycVerificationApiLog: 'kycVerificationApiLog',
  kycVerificationApplicantId: 'kycVerificationApplicantId',
  kycVerificationBatchTitle: 'kycVerificationBatchTitle',
  kycVerificationCallbackLog: 'kycVerificationCallbackLog',
  kycVerificationCompletedOn: 'kycVerificationCompletedOn',
  kycVerificationDelayBetweenEachUser: 'kycVerificationDelayBetweenEachUser',
  kycVerificationDocsUploaded: 'kycVerificationDocsUploaded',
  kycVerificationEnqueueBatch: 'kycVerificationEnqueueBatch',
  kycVerificationEnqueueBatchFromImport: 'kycVerificationEnqueueBatchFromImport',
  kycVerificationFollowedUpButtonToolTip: 'kycVerificationFollowedUpButtonToolTip',
  kycVerificationFollowedUpBy: 'kycVerificationFollowedUpBy',
  kycVerificationHeaders: 'kycVerificationHeaders',
  kycVerificationId: 'kycVerificationId',
  kycVerificationIsPersonalDataEntered: 'kycVerificationIsPersonalDataEntered',
  kycVerificationIsVerified: 'kycVerificationIsVerified',
  kycVerificationKycVerification: 'kycVerificationKycVerification',
  kycVerificationKycVerifications: 'kycVerificationKycVerifications',
  kycVerificationMethod: 'kycVerificationMethod',
  kycVerificationPayload: 'kycVerificationPayload',
  kycVerificationProfileStatus: 'kycVerificationProfileStatus',
  kycVerificationProvider: 'kycVerificationProvider',
  kycVerificationProviderClass: 'kycVerificationProviderClass',
  kycVerificationProviderName: 'kycVerificationProviderName',
  kycVerificationRequest: 'kycVerificationRequest',
  kycVerificationRequestHeaders: 'kycVerificationRequestHeaders',
  kycVerificationResponse: 'kycVerificationResponse',
  kycVerificationResponseHeaders: 'kycVerificationResponseHeaders',
  kycVerificationRunningBatchHint: 'kycVerificationRunningBatchHint',
  kycVerificationStartedOn: 'kycVerificationStartedOn',
  kycVerificationStatus: 'kycVerificationStatus',
  kycVerificationStatusCode: 'kycVerificationStatusCode',
  kycVerificationTotalUsersProcessed: 'kycVerificationTotalUsersProcessed',
  kycVerificationUnfollow: 'kycVerificationUnfollow',
  kycVerificationUnfollowButtonToolTip: 'kycVerificationUnfollowButtonToolTip',
  kycVerificationUnfollowWithOverride: 'kycVerificationUnfollowWithOverride',
  kycVerificationUnverifiedUserBatchEnqueued: 'kycVerificationUnverifiedUserBatchEnqueued',
  kycVerificationUnverifiedUsersBatch: 'kycVerificationUnverifiedUsersBatch',
  kycVerificationUpdateFixedInfo: 'kycVerificationUpdateFixedInfo',
  kycVerificationUpdateRequiredMsg: 'kycVerificationUpdateRequiredMsg',
  kycVerificationUpdateRequiredSecondLineMsg: 'kycVerificationUpdateRequiredSecondLineMsg',
  kycVerificationUpdateRequiredTitle: 'kycVerificationUpdateRequiredTitle',
  kycVerificationUploadedDocumentType1: 'kycVerificationUploadedDocumentType1',
  kycVerificationUploadedDocumentType2: 'kycVerificationUploadedDocumentType2',
  kycVerificationUrgentUpdateMsg: 'kycVerificationUrgentUpdateMsg',
  kycVerificationUrgentUpdateSecondLineMsg: 'kycVerificationUrgentUpdateSecondLineMsg',
  kycVerificationUrl: 'kycVerificationUrl',
  kycVerificationVerificationData: 'kycVerificationVerificationData',
  kycVerificationVerificationType: 'kycVerificationVerificationType',
  kytVerificationAddressFrom: 'kytVerificationAddressFrom',
  kytVerificationAddressTo: 'kytVerificationAddressTo',
  kytVerificationApiLog: 'kytVerificationApiLog',
  kytVerificationApiLogs: 'kytVerificationApiLogs',
  kytVerificationEkytVerification: 'kytVerificationEkytVerification',
  kytVerificationKytProvider: 'kytVerificationKytProvider',
  kytVerificationKytTransfer: 'kytVerificationKytTransfer',
  kytVerificationKytVerification: 'kytVerificationKytVerification',
  kytVerificationKytVerifications: 'kytVerificationKytVerifications',
  kytVerificationKytWithdrawalAttempt: 'kytVerificationKytWithdrawalAttempt',
  kytVerificationKytWithdrawalAttempts: 'kytVerificationKytWithdrawalAttempts',
  kytVerificationMethod: 'kytVerificationMethod',
  kytVerificationNetwork: 'kytVerificationNetwork',
  kytVerificationNotes: 'kytVerificationNotes',
  kytVerificationRateUSD: 'kytVerificationRateUSD',
  kytVerificationRequest: 'kytVerificationRequest',
  kytVerificationResponse: 'kytVerificationResponse',
  kytVerificationRiskScore: 'kytVerificationRiskScore',
  kytVerificationStatusCode: 'kytVerificationStatusCode',
  kytVerificationTransactionReference: 'kytVerificationTransactionReference',
  kytVerificationTransfers: 'kytVerificationTransfers',
  kytVerificationUrl: 'kytVerificationUrl',
  kytVerificationVerificationData: 'kytVerificationVerificationData',
  kytVerificationWithdrawalAttempts: 'kytVerificationWithdrawalAttempts',
  legalDownloadPdf: 'legalDownloadPdf',
  legalSectionType: 'legalSectionType',
  legalTitle: 'legalTitle',
  legalTradingPlatformIcon: 'legalTradingPlatformIcon',
  legalTradingPlatformIsQRCode: 'legalTradingPlatformIsQRCode',
  legalTradingPlatformSectionType: 'legalTradingPlatformSectionType',
  legalTradingPlatformUrlDestinationType: 'legalTradingPlatformUrlDestinationType',
  legalTradingPlatformUrlHint: 'legalTradingPlatformUrlHint',
  loginBrowser: 'loginBrowser',
  loginBrowserVersion: 'loginBrowserVersion',
  loginDevice: 'loginDevice',
  loginHistoryType: 'loginHistoryType',
  loginOperationSystem: 'loginOperationSystem',
  loginPlatform: 'loginPlatform',
  lotMultiplierAllowsYouToMultiplySizeOfYourTradeWithTradeThat:
    'lotMultiplierAllowsYouToMultiplySizeOfYourTradeWithTradeThat',
  loyaltyProgram: 'loyaltyProgram',
  loyaltyProgramAccessDescription: 'loyaltyProgramAccessDescription',
  loyaltyProgramAccessTitle: 'loyaltyProgramAccessTitle',
  loyaltyProgramConsentRequired: 'loyaltyProgramConsentRequired',
  loyaltyProgramConversationRateTradeVolumeHint: 'loyaltyProgramConversationRateTradeVolumeHint',
  loyaltyProgramConversionRateDepositHint: 'loyaltyProgramConversionRateDepositHint',
  loyaltyProgramDocumentBulkExportFileName: 'loyaltyProgramDocumentBulkExportFileName',
  loyaltyProgramDocumentList: 'loyaltyProgramDocumentList',
  loyaltyProgramDurationDays: 'loyaltyProgramDurationDays',
  loyaltyProgramJoinCheckboxLabel: 'loyaltyProgramJoinCheckboxLabel',
  loyaltyProgramJoinSuccess: 'loyaltyProgramJoinSuccess',
  loyaltyProgramLoyaltyPoints: 'loyaltyProgramLoyaltyPoints',
  loyaltyProgramMinDuration: 'loyaltyProgramMinDuration',
  loyaltyProgramNoAvailableOperations: 'loyaltyProgramNoAvailableOperations',
  loyaltyProgramNoAvailablePrizes: 'loyaltyProgramNoAvailablePrizes',
  loyaltyProgramNoProgramAvailable: 'loyaltyProgramNoProgramAvailable',
  loyaltyProgramOperation: 'loyaltyProgramOperation',
  loyaltyProgramOperationList: 'loyaltyProgramOperationList',
  loyaltyProgramOperations: 'loyaltyProgramOperations',
  loyaltyProgramParticipant: 'loyaltyProgramParticipant',
  loyaltyProgramParticipantList: 'loyaltyProgramParticipantList',
  loyaltyProgramParticipantRedeem: 'loyaltyProgramParticipantRedeem',
  loyaltyProgramParticipantRedeemList: 'loyaltyProgramParticipantRedeemList',
  loyaltyProgramParticipants: 'loyaltyProgramParticipants',
  loyaltyProgramParticipate: 'loyaltyProgramParticipate',
  loyaltyProgramPoints: 'loyaltyProgramPoints',
  loyaltyProgramPrice: 'loyaltyProgramPrice',
  loyaltyProgramPrizeDetails: 'loyaltyProgramPrizeDetails',
  loyaltyProgramProcessor: 'loyaltyProgramProcessor',
  loyaltyProgramProcessorDepositParameters: 'loyaltyProgramProcessorDepositParameters',
  loyaltyProgramProcessorList: 'loyaltyProgramProcessorList',
  loyaltyProgramProcessorTradeVolumeParameters: 'loyaltyProgramProcessorTradeVolumeParameters',
  loyaltyProgramProcessors: 'loyaltyProgramProcessors',
  loyaltyProgramRedeem: 'loyaltyProgramRedeem',
  loyaltyProgramRedeemCancelDescription: 'loyaltyProgramRedeemCancelDescription',
  loyaltyProgramRedeemCancelSuccess: 'loyaltyProgramRedeemCancelSuccess',
  loyaltyProgramRedeemEWalletType: 'loyaltyProgramRedeemEWalletType',
  loyaltyProgramRedeemEWalletTypeHint: 'loyaltyProgramRedeemEWalletTypeHint',
  loyaltyProgramRedeemGridTitle: 'loyaltyProgramRedeemGridTitle',
  loyaltyProgramRedeemHintAmountHint: 'loyaltyProgramRedeemHintAmountHint',
  loyaltyProgramRedeemImageHint: 'loyaltyProgramRedeemImageHint',
  loyaltyProgramRedeemItems: 'loyaltyProgramRedeemItems',
  loyaltyProgramRedeemList: 'loyaltyProgramRedeemList',
  loyaltyProgramRedeemMaterialHint: 'loyaltyProgramRedeemMaterialHint',
  loyaltyProgramRedeemModalTitle: 'loyaltyProgramRedeemModalTitle',
  loyaltyProgramRedeemRedemptionType: 'loyaltyProgramRedeemRedemptionType',
  loyaltyProgramRedeemRequests: 'loyaltyProgramRedeemRequests',
  loyaltyProgramRedeemSelectAccount: 'loyaltyProgramRedeemSelectAccount',
  loyaltyProgramRedeemSelectAccountType: 'loyaltyProgramRedeemSelectAccountType',
  loyaltyProgramRedeemSuccess: 'loyaltyProgramRedeemSuccess',
  loyaltyProgramRedeemTitle: 'loyaltyProgramRedeemTitle',
  loyaltyProgramRedemptionEndDate: 'loyaltyProgramRedemptionEndDate',
  loyaltyProgramRedemptionEndOn: 'loyaltyProgramRedemptionEndOn',
  loyaltyProgramRequestDate: 'loyaltyProgramRequestDate',
  loyaltyProgramRequestId: 'loyaltyProgramRequestId',
  loyaltyProgramRequestOperation: 'loyaltyProgramRequestOperation',
  loyaltyProgramResultOperation: 'loyaltyProgramResultOperation',
  loyaltyProgramStopParticipatingDescription: 'loyaltyProgramStopParticipatingDescription',
  loyaltyProgramStopParticipatingSuccess: 'loyaltyProgramStopParticipatingSuccess',
  loyaltyProgramTabPointsHistory: 'loyaltyProgramTabPointsHistory',
  loyaltyProgramTabPrizesHistory: 'loyaltyProgramTabPrizesHistory',
  loyaltyProgramTakePartIn: 'loyaltyProgramTakePartIn',
  loyaltyProgramTradingAccountTypeIdsHint: 'loyaltyProgramTradingAccountTypeIdsHint',
  loyaltyProgramUserAccessSettingList: 'loyaltyProgramUserAccessSettingList',
  loyaltyProgramUserRulesEnd: 'loyaltyProgramUserRulesEnd',
  loyaltyProgramUserRulesStart: 'loyaltyProgramUserRulesStart',
  loyaltyPrograms: 'loyaltyPrograms',
  mamChooseTradingAccount: 'mamChooseTradingAccount',
  mamMasterAccount: 'mamMasterAccount',
  mamMasterAccountMonthlyManagementFee: 'mamMasterAccountMonthlyManagementFee',
  mamMasterAccounts: 'mamMasterAccounts',
  mamMasterCommissionAccount: 'mamMasterCommissionAccount',
  mamMasterCommissionPoints: 'mamMasterCommissionPoints',
  mamMasterProfitSharing: 'mamMasterProfitSharing',
  mamMasterTerminationTimeInHours: 'mamMasterTerminationTimeInHours',
  mamProceedWithLPOA: 'mamProceedWithLPOA',
  mamTerminateConfirmation: 'mamTerminateConfirmation',
  mamTerminateLPOA: 'mamTerminateLPOA',
  marketingBannerFiles: 'marketingBannerFiles',
  masterAccount: 'masterAccount',
  masterProfileAccountDescription: 'masterProfileAccountDescription',
  masterProfileAccountPrefixCent: 'masterProfileAccountPrefixCent',
  masterProfileAccountPrefixECN: 'masterProfileAccountPrefixECN',
  masterProfileAccountPrefixStandard: 'masterProfileAccountPrefixStandard',
  masterProfileInfoFieldsAverageDrawdown: 'masterProfileInfoFieldsAverageDrawdown',
  masterProfileInfoFieldsCopyType: 'masterProfileInfoFieldsCopyType',
  masterProfileInfoFieldsCountry: 'masterProfileInfoFieldsCountry',
  masterProfileInfoFieldsGroupMappingType: 'masterProfileInfoFieldsGroupMappingType',
  masterProfileInfoFieldsLanguage: 'masterProfileInfoFieldsLanguage',
  masterProfileInfoFieldsMaxDrawdown: 'masterProfileInfoFieldsMaxDrawdown',
  masterProfileInfoFieldsOpeningTime: 'masterProfileInfoFieldsOpeningTime',
  masterProfileInfoFieldsPosition: 'masterProfileInfoFieldsPosition',
  masterProfileInfoFieldsProfitSharing: 'masterProfileInfoFieldsProfitSharing',
  masterProfileInfoFieldsProfitability: 'masterProfileInfoFieldsProfitability',
  masterProfileInfoFieldsRecommendedMinDepositAmount: 'masterProfileInfoFieldsRecommendedMinDepositAmount',
  masterProfileInfoFieldsRegistrationDate: 'masterProfileInfoFieldsRegistrationDate',
  masterProfileInfoFieldsReturnOnInvestment: 'masterProfileInfoFieldsReturnOnInvestment',
  masterProfileInfoFieldsTotalManagedFunds: 'masterProfileInfoFieldsTotalManagedFunds',
  masterProfileInfoFieldsTotalOwnedFunds: 'masterProfileInfoFieldsTotalOwnedFunds',
  masterProfileInfoFieldsTradesCount: 'masterProfileInfoFieldsTradesCount',
  masterProfileInvestorProfile: 'masterProfileInvestorProfile',
  masterProfileMasterAccounts: 'masterProfileMasterAccounts',
  masterProfileMasterProfile: 'masterProfileMasterProfile',
  masterProfileStatistics: 'masterProfileStatistics',
  masterProfileTradeColumnsClosePrice: 'masterProfileTradeColumnsClosePrice',
  masterProfileTradeColumnsCloseTime: 'masterProfileTradeColumnsCloseTime',
  masterProfileTradeColumnsInstrument: 'masterProfileTradeColumnsInstrument',
  masterProfileTradeColumnsOpenTime: 'masterProfileTradeColumnsOpenTime',
  masterProfileTradeColumnsProfitUsc: 'masterProfileTradeColumnsProfitUsc',
  masterProfileTradeColumnsProfitUsd: 'masterProfileTradeColumnsProfitUsd',
  masterProfileTradeColumnsSize: 'masterProfileTradeColumnsSize',
  masterProfileTradeColumnsStopLoss: 'masterProfileTradeColumnsStopLoss',
  masterProfileTradeColumnsTakeProfit: 'masterProfileTradeColumnsTakeProfit',
  masterProfileTradeColumnsType: 'masterProfileTradeColumnsType',
  masterProfileTradeHistoryTitle: 'masterProfileTradeHistoryTitle',
  masterProfileTradeHistoryTooltip: 'masterProfileTradeHistoryTooltip',
  mastersFieldsInvestorAccount: 'mastersFieldsInvestorAccount',
  mastersFieldsProfitSharing: 'mastersFieldsProfitSharing',
  mastersFieldsProfitability: 'mastersFieldsProfitability',
  mastersFilterName: 'mastersFilterName',
  mastersHint: 'mastersHint',
  mastersPlaceholder: 'mastersPlaceholder',
  mastersSelectPlaceholder: 'mastersSelectPlaceholder',
  mastersTitle: 'mastersTitle',
  menuAccounts: 'menuAccounts',
  menuEducationPortal: 'menuEducationPortal',
  menuFaq: 'menuFaq',
  menuFunding: 'menuFunding',
  menuHelpCenter: 'menuHelpCenter',
  menuHistory: 'menuHistory',
  menuLegal: 'menuLegal',
  menuLoyaltyProgram: 'menuLoyaltyProgram',
  menuNotificationsAndMessages: 'menuNotificationsAndMessages',
  menuOpenInvestorsAccount: 'menuOpenInvestorsAccount',
  menuOpenMastersAccount: 'menuOpenMastersAccount',
  menuPartnership: 'menuPartnership',
  menuRatings: 'menuRatings',
  menuSales: 'menuSales',
  menuServerTime: 'menuServerTime',
  menuSettings: 'menuSettings',
  menuSocialTrading: 'menuSocialTrading',
  menuStatistics: 'menuStatistics',
  menuTickets: 'menuTickets',
  menuTradingContests: 'menuTradingContests',
  menuTradingPlatforms: 'menuTradingPlatforms',
  menuTradingTools: 'menuTradingTools',
  menuViewMore: 'menuViewMore',
  modalClose: 'modalClose',
  modalConfirm: 'modalConfirm',
  modalConfirmation: 'modalConfirmation',
  modalGotIt: 'modalGotIt',
  modalItCouldBeDelays: 'modalItCouldBeDelays',
  modalNo: 'modalNo',
  modalProcessingCompleteWithin: 'modalProcessingCompleteWithin',
  modalThanksForRequest: 'modalThanksForRequest',
  modalValidationMessage: 'modalValidationMessage',
  modalWelcomeCompleteProfile: 'modalWelcomeCompleteProfile',
  modalWelcomeDepositNow: 'modalWelcomeDepositNow',
  modalWelcomeGetTradingApp: 'modalWelcomeGetTradingApp',
  modalWelcomeGettingStarted: 'modalWelcomeGettingStarted',
  modalWelcomeTitle: 'modalWelcomeTitle',
  modalWelcomeYourTradingJourneyStartsHere: 'modalWelcomeYourTradingJourneyStartsHere',
  modalYes: 'modalYes',
  myCopyingAccounts: 'myCopyingAccounts',
  myStatisticsChartInvestorSubtitle: 'myStatisticsChartInvestorSubtitle',
  myStatisticsChartMasterSubtitle: 'myStatisticsChartMasterSubtitle',
  myStatisticsFilterName: 'myStatisticsFilterName',
  myStatisticsInvestorsHint: 'myStatisticsInvestorsHint',
  myStatisticsMasters: 'myStatisticsMasters',
  myStatisticsMastersHint: 'myStatisticsMastersHint',
  myStatisticsOpenDetailsList: 'myStatisticsOpenDetailsList',
  myStatisticsTitle: 'myStatisticsTitle',
  noStayOnPage: 'noStayOnPage',
  notesHistory: 'notesHistory',
  notificationGroupDistributionList: 'notificationGroupDistributionList',
  notificationGroupDynamicFieldsFilterBy: 'notificationGroupDynamicFieldsFilterBy',
  notificationGroupDynamicFieldsFilterValue: 'notificationGroupDynamicFieldsFilterValue',
  notificationGroupDynamicFieldsOperatorType: 'notificationGroupDynamicFieldsOperatorType',
  notificationGroupDynamicFilterListTitle: 'notificationGroupDynamicFilterListTitle',
  notificationGroupMemberAdminTitle: 'notificationGroupMemberAdminTitle',
  notificationGroupMemberFormImportModalExpectedColumns: 'notificationGroupMemberFormImportModalExpectedColumns',
  notificationGroupMemberFormImportModalExpectedExtension: 'notificationGroupMemberFormImportModalExpectedExtension',
  notificationGroupMemberFormImportModalPromptList1: 'notificationGroupMemberFormImportModalPromptList1',
  notificationGroupMemberFormImportModalPromptList2: 'notificationGroupMemberFormImportModalPromptList2',
  notificationGroupMemberFormImportModalPromptList3: 'notificationGroupMemberFormImportModalPromptList3',
  notificationGroupMemberFormImportModalPromptTitle: 'notificationGroupMemberFormImportModalPromptTitle',
  notificationGroupMemberFormImportModalPromptTitle2: 'notificationGroupMemberFormImportModalPromptTitle2',
  notificationsFieldsEventTypeTitle: 'notificationsFieldsEventTypeTitle',
  notificationsFieldsIsSaveNotificationTitle: 'notificationsFieldsIsSaveNotificationTitle',
  notificationsFieldsIsUseUserLanguageTitle: 'notificationsFieldsIsUseUserLanguageTitle',
  notificationsFieldsNotificationApplicationTitle: 'notificationsFieldsNotificationApplicationTitle',
  notificationsFieldsNotificationMethodHint: 'notificationsFieldsNotificationMethodHint',
  notificationsFieldsNotificationMethodTitle: 'notificationsFieldsNotificationMethodTitle',
  notificationsFieldsSubjectTitle: 'notificationsFieldsSubjectTitle',
  notificationsMarkNewBtn: 'notificationsMarkNewBtn',
  notificationsMarkReadBtn: 'notificationsMarkReadBtn',
  notificationsNotificationsTitle: 'notificationsNotificationsTitle',
  onboardingConfigurationFieldsNewDirectUsersInvited: 'onboardingConfigurationFieldsNewDirectUsersInvited',
  onboardingConfigurationFieldsShowBonusesTab: 'onboardingConfigurationFieldsShowBonusesTab',
  onboardingConfigurationFieldsShowEducationPortalTab: 'onboardingConfigurationFieldsShowEducationPortalTab',
  onboardingConfigurationFieldsShowFaqTab: 'onboardingConfigurationFieldsShowFaqTab',
  onboardingConfigurationFieldsShowLoyaltyProgramsTab: 'onboardingConfigurationFieldsShowLoyaltyProgramsTab',
  onboardingConfigurationFieldsShowTradingContestsTab: 'onboardingConfigurationFieldsShowTradingContestsTab',
  onboardingConfigurationFieldsShowTradingPushNotificationsTab:
    'onboardingConfigurationFieldsShowTradingPushNotificationsTab',
  onboardingConfigurationFieldsShowTradingToolTab: 'onboardingConfigurationFieldsShowTradingToolTab',
  onboardingConfigurationFieldsShowUserPushNotificationsTab:
    'onboardingConfigurationFieldsShowUserPushNotificationsTab',
  operationHistoryFieldsDate: 'operationHistoryFieldsDate',
  operationHistoryFieldsEvent: 'operationHistoryFieldsEvent',
  operationHistoryFieldsMyAccount: 'operationHistoryFieldsMyAccount',
  operationHistoryFieldsPosition: 'operationHistoryFieldsPosition',
  operationHistoryTitle: 'operationHistoryTitle',
  pageTitlesAdminBrandingBrandingMenuTitle: 'pageTitlesAdminBrandingBrandingMenuTitle',
  pageTitlesAdminBrandingChildrenBanners: 'pageTitlesAdminBrandingChildrenBanners',
  pageTitlesAdminBrandingChildrenClientSideTranslations: 'pageTitlesAdminBrandingChildrenClientSideTranslations',
  pageTitlesAdminBrandingChildrenConsents: 'pageTitlesAdminBrandingChildrenConsents',
  pageTitlesAdminBrandingChildrenFaqs: 'pageTitlesAdminBrandingChildrenFaqs',
  pageTitlesAdminBrandingChildrenLegalDocuments: 'pageTitlesAdminBrandingChildrenLegalDocuments',
  pageTitlesAdminBrandingChildrenLegalTradingPlatforms: 'pageTitlesAdminBrandingChildrenLegalTradingPlatforms',
  pageTitlesAdminBrandingChildrenLinks: 'pageTitlesAdminBrandingChildrenLinks',
  pageTitlesAdminBrandingChildrenMarketingBannerCategories: 'pageTitlesAdminBrandingChildrenMarketingBannerCategories',
  pageTitlesAdminBrandingChildrenTradingPlatformBrandingSettings:
    'pageTitlesAdminBrandingChildrenTradingPlatformBrandingSettings',
  pageTitlesAdminBrandingChildrenUrlDomains: 'pageTitlesAdminBrandingChildrenUrlDomains',
  pageTitlesAdminBrandingChildrenVideos: 'pageTitlesAdminBrandingChildrenVideos',
  pageTitlesAdminCompaniesChildrenCompanyAccount: 'pageTitlesAdminCompaniesChildrenCompanyAccount',
  pageTitlesAdminCompaniesChildrenCompanyTransfer: 'pageTitlesAdminCompaniesChildrenCompanyTransfer',
  pageTitlesAdminCompaniesCompanyMenuTitle: 'pageTitlesAdminCompaniesCompanyMenuTitle',
  pageTitlesAdminContestsChildrenTradingContestParticipants:
    'pageTitlesAdminContestsChildrenTradingContestParticipants',
  pageTitlesAdminContestsChildrenTradingContests: 'pageTitlesAdminContestsChildrenTradingContests',
  pageTitlesAdminContestsContestsMenuTitle: 'pageTitlesAdminContestsContestsMenuTitle',
  pageTitlesAdminCrmChildrenAssignmentRules: 'pageTitlesAdminCrmChildrenAssignmentRules',
  pageTitlesAdminCrmChildrenBusinessManagers: 'pageTitlesAdminCrmChildrenBusinessManagers',
  pageTitlesAdminCrmChildrenCrmCache: 'pageTitlesAdminCrmChildrenCrmCache',
  pageTitlesAdminCrmChildrenExternalJobs: 'pageTitlesAdminCrmChildrenExternalJobs',
  pageTitlesAdminCrmChildrenSalesLeads: 'pageTitlesAdminCrmChildrenSalesLeads',
  pageTitlesAdminCrmChildrenSalesUsers: 'pageTitlesAdminCrmChildrenSalesUsers',
  pageTitlesAdminCrmCrmMenuTitle: 'pageTitlesAdminCrmCrmMenuTitle',
  pageTitlesAdminDashboard: 'pageTitlesAdminDashboard',
  pageTitlesAdminDocumentsDocumentsMenuTitle: 'pageTitlesAdminDocumentsDocumentsMenuTitle',
  pageTitlesAdminFinancialIdentityChildrenBanks: 'pageTitlesAdminFinancialIdentityChildrenBanks',
  pageTitlesAdminFinancialIdentityChildrenCryptoWalletAccounts:
    'pageTitlesAdminFinancialIdentityChildrenCryptoWalletAccounts',
  pageTitlesAdminFinancialIdentityChildrenDigitalWallets: 'pageTitlesAdminFinancialIdentityChildrenDigitalWallets',
  pageTitlesAdminFinancialIdentityChildrenUserBankAccountCreate:
    'pageTitlesAdminFinancialIdentityChildrenUserBankAccountCreate',
  pageTitlesAdminFinancialIdentityChildrenUserBankAccounts: 'pageTitlesAdminFinancialIdentityChildrenUserBankAccounts',
  pageTitlesAdminFinancialIdentityChildrenUserCardAccounts: 'pageTitlesAdminFinancialIdentityChildrenUserCardAccounts',
  pageTitlesAdminFinancialIdentityChildrenUserDigitalWalletAccounts:
    'pageTitlesAdminFinancialIdentityChildrenUserDigitalWalletAccounts',
  pageTitlesAdminFinancialIdentityFinancialIdentityMenuTitle:
    'pageTitlesAdminFinancialIdentityFinancialIdentityMenuTitle',
  pageTitlesAdminFinancialIdentityUserCryptoWalletAccounts: 'pageTitlesAdminFinancialIdentityUserCryptoWalletAccounts',
  pageTitlesAdminImportChildrenImportItems: 'pageTitlesAdminImportChildrenImportItems',
  pageTitlesAdminImportImportMenuTitle: 'pageTitlesAdminImportImportMenuTitle',
  pageTitlesAdminImportingChildrenUsers: 'pageTitlesAdminImportingChildrenUsers',
  pageTitlesAdminImportingImportMenuTitle: 'pageTitlesAdminImportingImportMenuTitle',
  pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramOperations:
    'pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramOperations',
  pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramParticipantRedeems:
    'pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramParticipantRedeems',
  pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramParticipants:
    'pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramParticipants',
  pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramProcessors:
    'pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramProcessors',
  pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramRedeems:
    'pageTitlesAdminLoyaltyProgramsChildrenLoyaltyProgramRedeems',
  pageTitlesAdminLoyaltyProgramsChildrenLoyaltyPrograms: 'pageTitlesAdminLoyaltyProgramsChildrenLoyaltyPrograms',
  pageTitlesAdminLoyaltyProgramsLoyaltyProgramsMenuTitle: 'pageTitlesAdminLoyaltyProgramsLoyaltyProgramsMenuTitle',
  pageTitlesAdminNotificationsChildrenAutoNotification: 'pageTitlesAdminNotificationsChildrenAutoNotification',
  pageTitlesAdminNotificationsChildrenCustomNotification: 'pageTitlesAdminNotificationsChildrenCustomNotification',
  pageTitlesAdminNotificationsChildrenCustomPushNotification:
    'pageTitlesAdminNotificationsChildrenCustomPushNotification',
  pageTitlesAdminNotificationsChildrenEmailTemplates: 'pageTitlesAdminNotificationsChildrenEmailTemplates',
  pageTitlesAdminNotificationsChildrenMail: 'pageTitlesAdminNotificationsChildrenMail',
  pageTitlesAdminNotificationsChildrenNotificationCategory: 'pageTitlesAdminNotificationsChildrenNotificationCategory',
  pageTitlesAdminNotificationsChildrenNotificationGroup: 'pageTitlesAdminNotificationsChildrenNotificationGroup',
  pageTitlesAdminNotificationsChildrenPush: 'pageTitlesAdminNotificationsChildrenPush',
  pageTitlesAdminNotificationsChildrenSms: 'pageTitlesAdminNotificationsChildrenSms',
  pageTitlesAdminNotificationsNotificationsMenuTitle: 'pageTitlesAdminNotificationsNotificationsMenuTitle',
  pageTitlesAdminOnboardingChildrenDocumentsConfiguration: 'pageTitlesAdminOnboardingChildrenDocumentsConfiguration',
  pageTitlesAdminOnboardingChildrenOnboardingConfiguration: 'pageTitlesAdminOnboardingChildrenOnboardingConfiguration',
  pageTitlesAdminOnboardingOnboardingMenuTitle: 'pageTitlesAdminOnboardingOnboardingMenuTitle',
  pageTitlesAdminPartnershipChildrenIbCommissionSummary: 'pageTitlesAdminPartnershipChildrenIbCommissionSummary',
  pageTitlesAdminPartnershipChildrenMamMasterAccounts: 'pageTitlesAdminPartnershipChildrenMamMasterAccounts',
  pageTitlesAdminPartnershipChildrenQuestionnaires: 'pageTitlesAdminPartnershipChildrenQuestionnaires',
  pageTitlesAdminPartnershipPartnershipMenuTitle: 'pageTitlesAdminPartnershipPartnershipMenuTitle',
  pageTitlesAdminReportsChildrenCommissionHistory: 'pageTitlesAdminReportsChildrenCommissionHistory',
  pageTitlesAdminReportsChildrenCommissionTicketProcessing: 'pageTitlesAdminReportsChildrenCommissionTicketProcessing',
  pageTitlesAdminReportsChildrenDeposits: 'pageTitlesAdminReportsChildrenDeposits',
  pageTitlesAdminReportsChildrenDepositsNew: 'pageTitlesAdminReportsChildrenDepositsNew',
  pageTitlesAdminReportsChildrenEWallets: 'pageTitlesAdminReportsChildrenEWallets',
  pageTitlesAdminReportsChildrenFtdUtmReport: 'pageTitlesAdminReportsChildrenFtdUtmReport',
  pageTitlesAdminReportsChildrenPspActivityTimeReport: 'pageTitlesAdminReportsChildrenPspActivityTimeReport',
  pageTitlesAdminReportsChildrenPspOperationHistoryReport: 'pageTitlesAdminReportsChildrenPspOperationHistoryReport',
  pageTitlesAdminReportsChildrenPspOperationPerCountryReport:
    'pageTitlesAdminReportsChildrenPspOperationPerCountryReport',
  pageTitlesAdminReportsChildrenPspOperationReport: 'pageTitlesAdminReportsChildrenPspOperationReport',
  pageTitlesAdminReportsChildrenPspOperationStatisticsReport:
    'pageTitlesAdminReportsChildrenPspOperationStatisticsReport',
  pageTitlesAdminReportsChildrenReportJobs: 'pageTitlesAdminReportsChildrenReportJobs',
  pageTitlesAdminReportsChildrenReportsHistory: 'pageTitlesAdminReportsChildrenReportsHistory',
  pageTitlesAdminReportsChildrenTradingBonusLinkReport: 'pageTitlesAdminReportsChildrenTradingBonusLinkReport',
  pageTitlesAdminReportsChildrenWalletOperations: 'pageTitlesAdminReportsChildrenWalletOperations',
  pageTitlesAdminReportsChildrenWithdrawals: 'pageTitlesAdminReportsChildrenWithdrawals',
  pageTitlesAdminReportsChildrenWithdrawalsNew: 'pageTitlesAdminReportsChildrenWithdrawalsNew',
  pageTitlesAdminReportsReportsMenuTitle: 'pageTitlesAdminReportsReportsMenuTitle',
  pageTitlesAdminSettingsChildrenAppVersions: 'pageTitlesAdminSettingsChildrenAppVersions',
  pageTitlesAdminSettingsChildrenCustomTags: 'pageTitlesAdminSettingsChildrenCustomTags',
  pageTitlesAdminSettingsChildrenComponents: 'pageTitlesAdminSettingsChildrenComponents',
  pageTitlesAdminSettingsChildrenJobs: 'pageTitlesAdminSettingsChildrenJobs',
  pageTitlesAdminSettingsChildrenJobsHistory: 'pageTitlesAdminSettingsChildrenJobsHistory',
  pageTitlesAdminSettingsChildrenJurisdictionUpdate: 'pageTitlesAdminSettingsChildrenJurisdictionUpdate',
  pageTitlesAdminSettingsChildrenPsp: 'pageTitlesAdminSettingsChildrenPsp',
  pageTitlesAdminSettingsChildrenTradingServers: 'pageTitlesAdminSettingsChildrenTradingServers',
  pageTitlesAdminSettingsSettingsMenuTitle: 'pageTitlesAdminSettingsSettingsMenuTitle',
  pageTitlesAdminSocialTradingChildrenInvestorAccount: 'pageTitlesAdminSocialTradingChildrenInvestorAccount',
  pageTitlesAdminSocialTradingChildrenMasterAccount: 'pageTitlesAdminSocialTradingChildrenMasterAccount',
  pageTitlesAdminSocialTradingSocialTradingMenuTitle: 'pageTitlesAdminSocialTradingSocialTradingMenuTitle',
  pageTitlesAdminTradingConfigsChildrenTradingAccountTypes: 'pageTitlesAdminTradingConfigsChildrenTradingAccountTypes',
  pageTitlesAdminTradingConfigsChildrenTradingAccounts: 'pageTitlesAdminTradingConfigsChildrenTradingAccounts',
  pageTitlesAdminTradingConfigsChildrenTradingCategories: 'pageTitlesAdminTradingConfigsChildrenTradingCategories',
  pageTitlesAdminTradingConfigsChildrenTradingGroups: 'pageTitlesAdminTradingConfigsChildrenTradingGroups',
  pageTitlesAdminTradingConfigsChildrenTradingSymbols: 'pageTitlesAdminTradingConfigsChildrenTradingSymbols',
  pageTitlesAdminTradingConfigsTradingConfigsMenuTitle: 'pageTitlesAdminTradingConfigsTradingConfigsMenuTitle',
  pageTitlesAdminUsersChildrenDataChangeRequest: 'pageTitlesAdminUsersChildrenDataChangeRequest',
  pageTitlesAdminUsersChildrenLoginHistory: 'pageTitlesAdminUsersChildrenLoginHistory',
  pageTitlesAdminUsersChildrenPermissions: 'pageTitlesAdminUsersChildrenPermissions',
  pageTitlesAdminUsersChildrenTradingBonusLinks: 'pageTitlesAdminUsersChildrenTradingBonusLinks',
  pageTitlesAdminUsersChildrenTrustedDevices: 'pageTitlesAdminUsersChildrenTrustedDevices',
  pageTitlesAdminUsersChildrenUserBonuses: 'pageTitlesAdminUsersChildrenUserBonuses',
  pageTitlesAdminUsersChildrenUserCountryAccess: 'pageTitlesAdminUsersChildrenUserCountryAccess',
  pageTitlesAdminUsersChildrenUserNameAliases: 'pageTitlesAdminUsersChildrenUserNameAliases',
  pageTitlesAdminUsersChildrenUserTickets: 'pageTitlesAdminUsersChildrenUserTickets',
  pageTitlesAdminUsersChildrenUserUISettings: 'pageTitlesAdminUsersChildrenUserUISettings',
  pageTitlesAdminUsersUsersMenuTitle: 'pageTitlesAdminUsersUsersMenuTitle',
  pageTitlesAdminVerificationChildrenEKYC: 'pageTitlesAdminVerificationChildrenEKYC',
  pageTitlesAdminVerificationChildrenEKYCApiLogs: 'pageTitlesAdminVerificationChildrenEKYCApiLogs',
  pageTitlesAdminVerificationChildrenEKYCCallbackLogs: 'pageTitlesAdminVerificationChildrenEKYCCallbackLogs',
  pageTitlesAdminVerificationChildrenEKYT: 'pageTitlesAdminVerificationChildrenEKYT',
  pageTitlesAdminVerificationChildrenEKYTApiLogs: 'pageTitlesAdminVerificationChildrenEKYTApiLogs',
  pageTitlesAdminVerificationChildrenEKYTTransfers: 'pageTitlesAdminVerificationChildrenEKYTTransfers',
  pageTitlesAdminVerificationChildrenEKYTWithdrawalAttempts:
    'pageTitlesAdminVerificationChildrenEKYTWithdrawalAttempts',
  pageTitlesAdminVerificationChildrenUnverifiedUsers: 'pageTitlesAdminVerificationChildrenUnverifiedUsers',
  pageTitlesAdminVerificationChildrenUnverifiedUsersBatches:
    'pageTitlesAdminVerificationChildrenUnverifiedUsersBatches',
  pageTitlesAdminVerificationChildrenUnverifiedUsersImport: 'pageTitlesAdminVerificationChildrenUnverifiedUsersImport',
  pageTitlesAdminVerificationVerificationMenuTitle: 'pageTitlesAdminVerificationVerificationMenuTitle',
  partnershipIbInfoBalance: 'partnershipIbInfoBalance',
  partnershipIbInfoIbType: 'partnershipIbInfoIbType',
  partnershipIbInfoInfoTitle: 'partnershipIbInfoInfoTitle',
  partnershipIbInfoProfitShareOnConditionLevel: 'partnershipIbInfoProfitShareOnConditionLevel',
  partnershipIbInfoRebateLevel: 'partnershipIbInfoRebateLevel',
  partnershipIbInfoStatisticsClosetTradersReportAccountNumber:
    'partnershipIbInfoStatisticsClosetTradersReportAccountNumber',
  partnershipIbInfoStatisticsClosetTradersReportAccountType:
    'partnershipIbInfoStatisticsClosetTradersReportAccountType',
  partnershipIbInfoStatisticsClosetTradersReportClosePrice: 'partnershipIbInfoStatisticsClosetTradersReportClosePrice',
  partnershipIbInfoStatisticsClosetTradersReportCloseTime: 'partnershipIbInfoStatisticsClosetTradersReportCloseTime',
  partnershipIbInfoStatisticsClosetTradersReportCommission: 'partnershipIbInfoStatisticsClosetTradersReportCommission',
  partnershipIbInfoStatisticsClosetTradersReportCommissionInTaCurrency:
    'partnershipIbInfoStatisticsClosetTradersReportCommissionInTaCurrency',
  partnershipIbInfoStatisticsClosetTradersReportCommissionUnit:
    'partnershipIbInfoStatisticsClosetTradersReportCommissionUnit',
  partnershipIbInfoStatisticsClosetTradersReportDifference: 'partnershipIbInfoStatisticsClosetTradersReportDifference',
  partnershipIbInfoStatisticsClosetTradersReportOpenTime: 'partnershipIbInfoStatisticsClosetTradersReportOpenTime',
  partnershipIbInfoStatisticsClosetTradersReportPeriod: 'partnershipIbInfoStatisticsClosetTradersReportPeriod',
  partnershipIbInfoStatisticsClosetTradersReportProfit: 'partnershipIbInfoStatisticsClosetTradersReportProfit',
  partnershipIbInfoStatisticsClosetTradersReportRebateInTaCurrency:
    'partnershipIbInfoStatisticsClosetTradersReportRebateInTaCurrency',
  partnershipIbInfoStatisticsClosetTradersReportSide: 'partnershipIbInfoStatisticsClosetTradersReportSide',
  partnershipIbInfoStatisticsClosetTradersReportSpread: 'partnershipIbInfoStatisticsClosetTradersReportSpread',
  partnershipIbInfoStatisticsClosetTradersReportSpreadInTaCurrency:
    'partnershipIbInfoStatisticsClosetTradersReportSpreadInTaCurrency',
  partnershipIbInfoStatisticsClosetTradersReportSpreadUnit: 'partnershipIbInfoStatisticsClosetTradersReportSpreadUnit',
  partnershipIbInfoStatisticsClosetTradersReportTicket: 'partnershipIbInfoStatisticsClosetTradersReportTicket',
  partnershipIbInfoStatisticsClosetTradersReportTitle: 'partnershipIbInfoStatisticsClosetTradersReportTitle',
  partnershipIbInfoStatisticsClosetTradersReportTotalInTaCurrency:
    'partnershipIbInfoStatisticsClosetTradersReportTotalInTaCurrency',
  partnershipIbInfoStatisticsClosetTradersReportTotalInUsd: 'partnershipIbInfoStatisticsClosetTradersReportTotalInUsd',
  partnershipIbInfoStatisticsClosetTradersReportVolume: 'partnershipIbInfoStatisticsClosetTradersReportVolume',
  partnershipIbInfoStatisticsPreviousReportDocTitle: 'partnershipIbInfoStatisticsPreviousReportDocTitle',
  partnershipIbInfoStatisticsPreviousReportTitle: 'partnershipIbInfoStatisticsPreviousReportTitle',
  partnershipIbInfoStatisticsStatisticsTitle: 'partnershipIbInfoStatisticsStatisticsTitle',
  partnershipIbInfoStatisticsTradingVolReportByAccount: 'partnershipIbInfoStatisticsTradingVolReportByAccount',
  partnershipIbInfoStatisticsTradingVolReportBySymbol: 'partnershipIbInfoStatisticsTradingVolReportBySymbol',
  partnershipIbInfoStatisticsTradingVolReportCommissionUsd: 'partnershipIbInfoStatisticsTradingVolReportCommissionUsd',
  partnershipIbInfoStatisticsTradingVolReportLevel: 'partnershipIbInfoStatisticsTradingVolReportLevel',
  partnershipIbInfoStatisticsTradingVolReportMainIbCode: 'partnershipIbInfoStatisticsTradingVolReportMainIbCode',
  partnershipIbInfoStatisticsTradingVolReportOwnDepositUsd: 'partnershipIbInfoStatisticsTradingVolReportOwnDepositUsd',
  partnershipIbInfoStatisticsTradingVolReportOwnNetDepositUsd:
    'partnershipIbInfoStatisticsTradingVolReportOwnNetDepositUsd',
  partnershipIbInfoStatisticsTradingVolReportOwnTradingVolume:
    'partnershipIbInfoStatisticsTradingVolReportOwnTradingVolume',
  partnershipIbInfoStatisticsTradingVolReportOwnWithdrawalUsd:
    'partnershipIbInfoStatisticsTradingVolReportOwnWithdrawalUsd',
  partnershipIbInfoStatisticsTradingVolReportPartnerAccount:
    'partnershipIbInfoStatisticsTradingVolReportPartnerAccount',
  partnershipIbInfoStatisticsTradingVolReportPartnerDepositUsd:
    'partnershipIbInfoStatisticsTradingVolReportPartnerDepositUsd',
  partnershipIbInfoStatisticsTradingVolReportPartnerNetDepositUsd:
    'partnershipIbInfoStatisticsTradingVolReportPartnerNetDepositUsd',
  partnershipIbInfoStatisticsTradingVolReportPartnerTradingVolume:
    'partnershipIbInfoStatisticsTradingVolReportPartnerTradingVolume',
  partnershipIbInfoStatisticsTradingVolReportPartnerWithdrawalUsd:
    'partnershipIbInfoStatisticsTradingVolReportPartnerWithdrawalUsd',
  partnershipIbInfoStatisticsTradingVolReportPeriod: 'partnershipIbInfoStatisticsTradingVolReportPeriod',
  partnershipIbInfoStatisticsTradingVolReportTitle: 'partnershipIbInfoStatisticsTradingVolReportTitle',
  partnershipIbInfoStatisticsTradingVolReportTotalClientsSubIb:
    'partnershipIbInfoStatisticsTradingVolReportTotalClientsSubIb',
  partnershipIbInfoStatisticsTradingVolReportTotalEcn: 'partnershipIbInfoStatisticsTradingVolReportTotalEcn',
  partnershipIbInfoStatisticsTradingVolReportTotalNonEcn: 'partnershipIbInfoStatisticsTradingVolReportTotalNonEcn',
  partnershipIbInfoTradersSettingsActionTitle: 'partnershipIbInfoTradersSettingsActionTitle',
  partnershipIbInfoTradersSettingsCategory: 'partnershipIbInfoTradersSettingsCategory',
  partnershipIbInfoTradersSettingsCommission: 'partnershipIbInfoTradersSettingsCommission',
  partnershipIbInfoTradersSettingsIsHidden: 'partnershipIbInfoTradersSettingsIsHidden',
  partnershipIbInfoTradersSettingsSpread: 'partnershipIbInfoTradersSettingsSpread',
  partnershipIbInfoTradersSettingsTitle: 'partnershipIbInfoTradersSettingsTitle',
  partnershipIbInfoTradersSettingsUser: 'partnershipIbInfoTradersSettingsUser',
  partnershipIbInfoTradersTraderAccountsTitle: 'partnershipIbInfoTradersTraderAccountsTitle',
  partnershipIbInfoTradersTraderClientsTitle: 'partnershipIbInfoTradersTraderClientsTitle',
  partnershipIbInfoTradersTradersTitle: 'partnershipIbInfoTradersTradersTitle',
  partnershipIbInfoTradingReportsLink: 'partnershipIbInfoTradingReportsLink',
  partnershipIbSettingsCanBeIb: 'partnershipIbSettingsCanBeIb',
  partnershipIbSettingsCanBeIbHint: 'partnershipIbSettingsCanBeIbHint',
  partnershipIbSettingsCopyToClipboardBtn: 'partnershipIbSettingsCopyToClipboardBtn',
  partnershipIbSettingsGenerateBtn: 'partnershipIbSettingsGenerateBtn',
  partnershipIbSettingsGenerateNote: 'partnershipIbSettingsGenerateNote',
  partnershipIbSettingsIbCodeTitle: 'partnershipIbSettingsIbCodeTitle',
  partnershipIbSettingsIbDataFetchFail: 'partnershipIbSettingsIbDataFetchFail',
  partnershipIbSettingsMinMaxMessage: 'partnershipIbSettingsMinMaxMessage',
  partnershipIbSettingsName: 'partnershipIbSettingsName',
  partnershipIbSettingsNameValueError: 'partnershipIbSettingsNameValueError',
  partnershipIbSettingsNoticeMessageTitle: 'partnershipIbSettingsNoticeMessageTitle',
  partnershipIbSettingsRefLinkSuccessCopy: 'partnershipIbSettingsRefLinkSuccessCopy',
  partnershipIbSettingsReferralLinkCopy: 'partnershipIbSettingsReferralLinkCopy',
  partnershipIbSettingsReferralLinkTitle: 'partnershipIbSettingsReferralLinkTitle',
  partnershipIbSettingsReferralLinkWasCreated: 'partnershipIbSettingsReferralLinkWasCreated',
  partnershipIbSettingsReferralLinkWasCreatedForShare: 'partnershipIbSettingsReferralLinkWasCreatedForShare',
  partnershipIbSettingsReferralLinksList: 'partnershipIbSettingsReferralLinksList',
  partnershipIbSettingsReferralSettingsTitle: 'partnershipIbSettingsReferralSettingsTitle',
  partnershipIbSettingsRegisteredUsers: 'partnershipIbSettingsRegisteredUsers',
  partnershipIbSettingsSaveAsDraftBtn: 'partnershipIbSettingsSaveAsDraftBtn',
  partnershipIbSettingsSaveAsDraftNote: 'partnershipIbSettingsSaveAsDraftNote',
  partnershipIbSettingsSendSubmitForApprovalSuccess: 'partnershipIbSettingsSendSubmitForApprovalSuccess',
  partnershipIbSettingsSettingsCommission: 'partnershipIbSettingsSettingsCommission',
  partnershipIbSettingsSettingsCommissionMax: 'partnershipIbSettingsSettingsCommissionMax',
  partnershipIbSettingsSettingsCommissionPrefix: 'partnershipIbSettingsSettingsCommissionPrefix',
  partnershipIbSettingsSettingsCommissionSettings: 'partnershipIbSettingsSettingsCommissionSettings',
  partnershipIbSettingsSettingsCommissionUnit: 'partnershipIbSettingsSettingsCommissionUnit',
  partnershipIbSettingsSettingsCost: 'partnershipIbSettingsSettingsCost',
  partnershipIbSettingsSettingsCostPrefix: 'partnershipIbSettingsSettingsCostPrefix',
  partnershipIbSettingsSettingsCostSettings: 'partnershipIbSettingsSettingsCostSettings',
  partnershipIbSettingsSettingsIsAllowCommission: 'partnershipIbSettingsSettingsIsAllowCommission',
  partnershipIbSettingsSettingsIsIb: 'partnershipIbSettingsSettingsIsIb',
  partnershipIbSettingsSettingsPayoutType: 'partnershipIbSettingsSettingsPayoutType',
  partnershipIbSettingsSettingsProfitShare: 'partnershipIbSettingsSettingsProfitShare',
  partnershipIbSettingsSettingsProfitShareSettings: 'partnershipIbSettingsSettingsProfitShareSettings',
  partnershipIbSettingsSettingsProfitShareUnit: 'partnershipIbSettingsSettingsProfitShareUnit',
  partnershipIbSettingsSettingsRebate: 'partnershipIbSettingsSettingsRebate',
  partnershipIbSettingsSettingsRebateSettings: 'partnershipIbSettingsSettingsRebateSettings',
  partnershipIbSettingsSettingsRebateUnit: 'partnershipIbSettingsSettingsRebateUnit',
  partnershipIbSettingsSettingsSpread: 'partnershipIbSettingsSettingsSpread',
  partnershipIbSettingsSettingsSpreadMax: 'partnershipIbSettingsSettingsSpreadMax',
  partnershipIbSettingsSettingsSpreadPrefix: 'partnershipIbSettingsSettingsSpreadPrefix',
  partnershipIbSettingsSettingsSpreadSettings: 'partnershipIbSettingsSettingsSpreadSettings',
  partnershipIbSettingsSettingsSpreadUnit: 'partnershipIbSettingsSettingsSpreadUnit',
  partnershipIbSettingsSettingsTotalMax: 'partnershipIbSettingsSettingsTotalMax',
  partnershipIbSettingsSettingsTotalSettings: 'partnershipIbSettingsSettingsTotalSettings',
  partnershipIbSettingsSettingsTotalUnit: 'partnershipIbSettingsSettingsTotalUnit',
  partnershipIbSettingsSettingsTradingGroup: 'partnershipIbSettingsSettingsTradingGroup',
  partnershipIbSettingsSettingsTradingSymbol: 'partnershipIbSettingsSettingsTradingSymbol',
  partnershipIbSettingsSubmitForApproval: 'partnershipIbSettingsSubmitForApproval',
  partnershipIbTreeComission: 'partnershipIbTreeComission',
  partnershipIbTreeDirectAccountsEmptyListTxt: 'partnershipIbTreeDirectAccountsEmptyListTxt',
  partnershipIbTreeDirectAccountsTitle: 'partnershipIbTreeDirectAccountsTitle',
  partnershipIbTreeEmail: 'partnershipIbTreeEmail',
  partnershipIbTreeIb: 'partnershipIbTreeIb',
  partnershipIbTreeIbCode: 'partnershipIbTreeIbCode',
  partnershipIbTreePartners: 'partnershipIbTreePartners',
  partnershipIbTreeSubIb: 'partnershipIbTreeSubIb',
  partnershipIbTreeSubIbsEmptyListTxt: 'partnershipIbTreeSubIbsEmptyListTxt',
  partnershipIbTreeSubIbsTitle: 'partnershipIbTreeSubIbsTitle',
  partnershipIbTreeTreeTitle: 'partnershipIbTreeTreeTitle',
  partnershipMamInfoInfoTitle: 'partnershipMamInfoInfoTitle',
  partnershipMamInfoInvestorAccountsTitle: 'partnershipMamInfoInvestorAccountsTitle',
  partnershipMamInfoInvestorUsersTitle: 'partnershipMamInfoInvestorUsersTitle',
  partnershipMamInfoMamCodeTitle: 'partnershipMamInfoMamCodeTitle',
  partnershipMamInfoMamDataFetchFail: 'partnershipMamInfoMamDataFetchFail',
  partnershipMamInvestorTitle: 'partnershipMamInvestorTitle',
  partnershipMamLinksCreateMamLink: 'partnershipMamLinksCreateMamLink',
  partnershipMamLinksEditMamLink: 'partnershipMamLinksEditMamLink',
  partnershipMamLinksMamLinkDetailsTitle: 'partnershipMamLinksMamLinkDetailsTitle',
  partnershipMamLinksMamLinksFormAccountCategory: 'partnershipMamLinksMamLinksFormAccountCategory',
  partnershipMamLinksMamLinksFormAllocationMode: 'partnershipMamLinksMamLinksFormAllocationMode',
  partnershipMamLinksMamLinksFormCommission: 'partnershipMamLinksMamLinksFormCommission',
  partnershipMamLinksMamLinksFormCommissionAccount: 'partnershipMamLinksMamLinksFormCommissionAccount',
  partnershipMamLinksMamLinksFormCreationAgreement: 'partnershipMamLinksMamLinksFormCreationAgreement',
  partnershipMamLinksMamLinksFormManagementFeesMonthly: 'partnershipMamLinksMamLinksFormManagementFeesMonthly',
  partnershipMamLinksMamLinksFormMinMaxMessage: 'partnershipMamLinksMamLinksFormMinMaxMessage',
  partnershipMamLinksMamLinksFormNoTradingAccounts: 'partnershipMamLinksMamLinksFormNoTradingAccounts',
  partnershipMamLinksMamLinksFormProfitSharing: 'partnershipMamLinksMamLinksFormProfitSharing',
  partnershipMamLinksMamLinksFormTerminationHours: 'partnershipMamLinksMamLinksFormTerminationHours',
  partnershipMamLinksMamLinksFormTradingAccount: 'partnershipMamLinksMamLinksFormTradingAccount',
  partnershipMamLinksMamLinksListTitle: 'partnershipMamLinksMamLinksListTitle',
  partnershipMamManagerTitle: 'partnershipMamManagerTitle',
  partnershipPartnershipEWallets: 'partnershipPartnershipEWallets',
  partnershipPartnershipSettingSetMainIbBtn: 'partnershipPartnershipSettingSetMainIbBtn',
  partnershipPartnershipSettingUpdateBtn: 'partnershipPartnershipSettingUpdateBtn',
  partnershipPartnershipSettingUpdateConfirmationTxt: 'partnershipPartnershipSettingUpdateConfirmationTxt',
  partnershipPartnershipTitle: 'partnershipPartnershipTitle',
  partnershipQuestionnaireCreateQuestionarrieTxt: 'partnershipQuestionnaireCreateQuestionarrieTxt',
  partnershipQuestionnaireDeleteConfirmationTxt: 'partnershipQuestionnaireDeleteConfirmationTxt',
  partnershipQuestionnaireProvideSignature: 'partnershipQuestionnaireProvideSignature',
  partnershipQuestionnaireQuestionnaireCreateFailErr: 'partnershipQuestionnaireQuestionnaireCreateFailErr',
  partnershipQuestionnaireQuestionnaireDeleteFailErr: 'partnershipQuestionnaireQuestionnaireDeleteFailErr',
  partnershipQuestionnaireQuestionnaireSendFailErr: 'partnershipQuestionnaireQuestionnaireSendFailErr',
  partnershipQuestionnaireQuestionnaireUpdateFailErr: 'partnershipQuestionnaireQuestionnaireUpdateFailErr',
  partnershipQuestionnaireSendBtn: 'partnershipQuestionnaireSendBtn',
  partnershipQuestionnaireStartBtn: 'partnershipQuestionnaireStartBtn',
  partnershipQuestionnaireValidationFailTxt: 'partnershipQuestionnaireValidationFailTxt',
  partnershipSalesUserInfoEmail: 'partnershipSalesUserInfoEmail',
  partnershipSalesUserInfoName: 'partnershipSalesUserInfoName',
  partnershipSalesUserInfoPhone: 'partnershipSalesUserInfoPhone',
  partnershipSalesUserInfoTitle: 'partnershipSalesUserInfoTitle',
  paymentMethod: 'paymentMethod',
  paymentStatus: 'paymentStatus',
  paymentSystemConsent: 'paymentSystemConsent',
  paymentSystemConsents: 'paymentSystemConsents',
  paymentSystemUserAccessSettingList: 'paymentSystemUserAccessSettingList',
  permissionGroup: 'permissionGroup',
  permissionGroups: 'permissionGroups',
  customTag: 'customTag',
  customTags: 'customTags',
  permissionsUser: 'permissionsUser',
  pinCodeConfirmNewPinCode: 'pinCodeConfirmNewPinCode',
  pinCodeConfirmNewPinCodeValidationMessage: 'pinCodeConfirmNewPinCodeValidationMessage',
  pinCodeMAPassword: 'pinCodeMAPassword',
  pinCodeNewPinCode: 'pinCodeNewPinCode',
  pinCodePinCodeHint: 'pinCodePinCodeHint',
  pinCodePinCodeValidationMessage: 'pinCodePinCodeValidationMessage',
  profileAboutMe: 'profileAboutMe',
  profileAccountIsNotValidatedToDeposit: 'profileAccountIsNotValidatedToDeposit',
  profileAccountIsNotValidatedToWithdraw: 'profileAccountIsNotValidatedToWithdraw',
  profileAddress: 'profileAddress',
  profileBankDetailsTitle: 'profileBankDetailsTitle',
  profileBeforeSubmitDocumentsHint: 'profileBeforeSubmitDocumentsHint',
  profileCategoryABProofOfAddress: 'profileCategoryABProofOfAddress',
  profileCategoryABProofOfIdentity: 'profileCategoryABProofOfIdentity',
  profileCategoryABTopHint: 'profileCategoryABTopHint',
  profileChangeAvatar: 'profileChangeAvatar',
  profileChinesePinyin: 'profileChinesePinyin',
  profileChinesePinyinHint: 'profileChinesePinyinHint',
  profileCity: 'profileCity',
  profileCompleteIdentification: 'profileCompleteIdentification',
  profileCompleteProfileToDeposit: 'profileCompleteProfileToDeposit',
  profileConfirmPassword: 'profileConfirmPassword',
  profileContactDetailsTitle: 'profileContactDetailsTitle',
  profileCountryOfResidence: 'profileCountryOfResidence',
  profileDateBirthHint: 'profileDateBirthHint',
  profileDateBirthHintWithMaxAllowedAge: 'profileDateBirthHintWithMaxAllowedAge',
  profileDateOfBirth: 'profileDateOfBirth',
  profileDepositsAndWithdrawalOnlyForVerifiedAccounts: 'profileDepositsAndWithdrawalOnlyForVerifiedAccounts',
  profileDepositsForUnverifiedAccounts: 'profileDepositsForUnverifiedAccounts',
  profileDocumentSideNationalIdBack: 'profileDocumentSideNationalIdBack',
  profileDocumentSideNationalIdFront: 'profileDocumentSideNationalIdFront',
  profileDocumentsHint: 'profileDocumentsHint',
  profileEmail: 'profileEmail',
  profileEnterYourNickname: 'profileEnterYourNickname',
  profileFailedToGetSignature: 'profileFailedToGetSignature',
  profileFailedToSendingUserProfile: 'profileFailedToSendingUserProfile',
  profileFirstName: 'profileFirstName',
  profileFirstNameIsTheSameAsInID: 'profileFirstNameIsTheSameAsInID',
  profileGovernmentPhotoTitle: 'profileGovernmentPhotoTitle',
  profileHoldOn: 'profileHoldOn',
  profileLastName: 'profileLastName',
  profileLastNameIsTheSameAsInID: 'profileLastNameIsTheSameAsInID',
  profileNewPassword: 'profileNewPassword',
  profileNickname: 'profileNickname',
  profileOccupation: 'profileOccupation',
  profileOneTimePassword: 'profileOneTimePassword',
  profilePassword: 'profilePassword',
  profilePasswordRegistrationRulesHint: 'profilePasswordRegistrationRulesHint',
  profilePersonalDetailsTitle: 'profilePersonalDetailsTitle',
  profilePhone: 'profilePhone',
  profilePlaceholder: 'profilePlaceholder',
  profilePleaseSelectOne: 'profilePleaseSelectOne',
  profilePleaseSelectRequiredCount: 'profilePleaseSelectRequiredCount',
  profilePleaseValidateAccountToWithdraw: 'profilePleaseValidateAccountToWithdraw',
  profileProofOfAddress: 'profileProofOfAddress',
  profileProofOfIdentity: 'profileProofOfIdentity',
  profileQformsTypeTitle: 'profileQformsTypeTitle',
  profileSignature: 'profileSignature',
  profileState: 'profileState',
  profileSubmitPersonalDetailsToDeposit: 'profileSubmitPersonalDetailsToDeposit',
  profileUploadDocumentsBankStatementBankStatementAccountHoldersName:
    'profileUploadDocumentsBankStatementBankStatementAccountHoldersName',
  profileUploadDocumentsBankStatementBankStatementBankAccountNumber:
    'profileUploadDocumentsBankStatementBankStatementBankAccountNumber',
  profileUploadDocumentsBankStatementBankStatementBankName: 'profileUploadDocumentsBankStatementBankStatementBankName',
  profileUploadDocumentsBankStatementBankStatementLessThan3MonthOld:
    'profileUploadDocumentsBankStatementBankStatementLessThan3MonthOld',
  profileUploadDocumentsBankStatementBankStatementMustShow: 'profileUploadDocumentsBankStatementBankStatementMustShow',
  profileUploadDocumentsBankTransferBankTransferBankAccountNumber:
    'profileUploadDocumentsBankTransferBankTransferBankAccountNumber',
  profileUploadDocumentsBankTransferBankTransferDateTimeOfPayment:
    'profileUploadDocumentsBankTransferBankTransferDateTimeOfPayment',
  profileUploadDocumentsBankTransferBankTransferMustShow: 'profileUploadDocumentsBankTransferBankTransferMustShow',
  profileUploadDocumentsBankTransferBankTransferPaidAmount: 'profileUploadDocumentsBankTransferBankTransferPaidAmount',
  profileUploadDocumentsBankTransferBankTransferTransactionID:
    'profileUploadDocumentsBankTransferBankTransferTransactionID',
  profileUploadDocumentsDigitalWalletStatementDigitalWalletStatementAccountNumber:
    'profileUploadDocumentsDigitalWalletStatementDigitalWalletStatementAccountNumber',
  profileUploadDocumentsDigitalWalletStatementDigitalWalletStatementMustShow:
    'profileUploadDocumentsDigitalWalletStatementDigitalWalletStatementMustShow',
  profileUploadDocumentsDigitalWalletStatementDigitalWalletStatementName:
    'profileUploadDocumentsDigitalWalletStatementDigitalWalletStatementName',
  profileUploadDocumentsProofAccountProofAccountBankingDetails:
    'profileUploadDocumentsProofAccountProofAccountBankingDetails',
  profileUploadDocumentsProofAccountProofAccountFullName: 'profileUploadDocumentsProofAccountProofAccountFullName',
  profileUploadDocumentsProofAccountProofAccountFundingHistory:
    'profileUploadDocumentsProofAccountProofAccountFundingHistory',
  profileUploadDocumentsProofAccountProofAccountMustShow: 'profileUploadDocumentsProofAccountProofAccountMustShow',
  profileUploadDocumentsProofTransactionProofTransactionAddress:
    'profileUploadDocumentsProofTransactionProofTransactionAddress',
  profileUploadDocumentsProofTransactionProofTransactionDateTimeOfPayment:
    'profileUploadDocumentsProofTransactionProofTransactionDateTimeOfPayment',
  profileUploadDocumentsProofTransactionProofTransactionMustShow:
    'profileUploadDocumentsProofTransactionProofTransactionMustShow',
  profileUploadDocumentsProofTransactionProofTransactionPaidAmount:
    'profileUploadDocumentsProofTransactionProofTransactionPaidAmount',
  profileUploadDocumentsProofTransactionProofTransactionTransactionID:
    'profileUploadDocumentsProofTransactionProofTransactionTransactionID',
  profileUploadDocumentsUserCardStatementUserCardStatementCardHolderNameSide:
    'profileUploadDocumentsUserCardStatementUserCardStatementCardHolderNameSide',
  profileUploadDocumentsUserCardStatementUserCardStatementCardNumber:
    'profileUploadDocumentsUserCardStatementUserCardStatementCardNumber',
  profileUploadDocumentsUserCardStatementUserCardStatementCardholderName:
    'profileUploadDocumentsUserCardStatementUserCardStatementCardholderName',
  profileUploadDocumentsUserCardStatementUserCardStatementCode:
    'profileUploadDocumentsUserCardStatementUserCardStatementCode',
  profileUploadDocumentsUserCardStatementUserCardStatementDropzoneTitle:
    'profileUploadDocumentsUserCardStatementUserCardStatementDropzoneTitle',
  profileUploadDocumentsUserCardStatementUserCardStatementMustShow:
    'profileUploadDocumentsUserCardStatementUserCardStatementMustShow',
  profileUploadDocumentsUserCardStatementUserCardStatementRequired:
    'profileUploadDocumentsUserCardStatementUserCardStatementRequired',
  profileUploadDocumentsUserCardStatementUserCardUploadExpirationDate:
    'profileUploadDocumentsUserCardStatementUserCardUploadExpirationDate',
  profileUserUploadsTitle: 'profileUserUploadsTitle',
  profileVerificationBtnTxt: 'profileVerificationBtnTxt',
  profileVerificationRequiredTxt: 'profileVerificationRequiredTxt',
  profileVerifyAndProceed: 'profileVerifyAndProceed',
  profileVerifyPhoneHint: 'profileVerifyPhoneHint',
  profileWarningMessageBankCardDropzoneHint: 'profileWarningMessageBankCardDropzoneHint',
  profileWarningMessageBankCardDropzoneTitle: 'profileWarningMessageBankCardDropzoneTitle',
  profileWarningMessageBankCardProvideInfo: 'profileWarningMessageBankCardProvideInfo',
  profileWarningMessageBankCardRequiresUpdates: 'profileWarningMessageBankCardRequiresUpdates',
  profileWarningMessageBankCardRequiresUpdatesDescription: 'profileWarningMessageBankCardRequiresUpdatesDescription',
  profileWarningMessageBankCardRequiresUpdatesReview: 'profileWarningMessageBankCardRequiresUpdatesReview',
  profileWarningMessageBankCardRequiresUpdatesTitle: 'profileWarningMessageBankCardRequiresUpdatesTitle',
  profileWarningMessageConfirmThatPaymentsAreMadeFromRegisteredAccount:
    'profileWarningMessageConfirmThatPaymentsAreMadeFromRegisteredAccount',
  profileWarningMessageImportantInformation: 'profileWarningMessageImportantInformation',
  profileWarningMessageMakeSureDescriptionIsEmptyForUnionPayOnlyCN:
    'profileWarningMessageMakeSureDescriptionIsEmptyForUnionPayOnlyCN',
  profileWarningMessageNameDoesNotMatch: 'profileWarningMessageNameDoesNotMatch',
  profileWarningMessageNicknameisAlreadyUsed: 'profileWarningMessageNicknameisAlreadyUsed',
  profileWarningMessageThirdPartyDeposits: 'profileWarningMessageThirdPartyDeposits',
  profileWarningMessageUploadBankCardDropzoneTitle: 'profileWarningMessageUploadBankCardDropzoneTitle',
  profileWarningMessageVerifyYourIdentity: 'profileWarningMessageVerifyYourIdentity',
  profileWithdrawalOnlyForVerifiedAccounts: 'profileWithdrawalOnlyForVerifiedAccounts',
  profileWorkingOnVerifyingData: 'profileWorkingOnVerifyingData',
  profileZipCode: 'profileZipCode',
  pspAmountLimitHint: 'pspAmountLimitHint',
  pspAssociatedCryptoWalletAccount: 'pspAssociatedCryptoWalletAccount',
  pspBackToPaymentMethods: 'pspBackToPaymentMethods',
  pspBankAccountDetailsBankAccountFormBankHint: 'pspBankAccountDetailsBankAccountFormBankHint',
  pspBankAccountDetailsBankAccountFormExpectedBank: 'pspBankAccountDetailsBankAccountFormExpectedBank',
  pspBankAccountDetailsBankAccountFormNoBankOption: 'pspBankAccountDetailsBankAccountFormNoBankOption',
  pspBankAccountDetailsBankAccountTabTitle: 'pspBankAccountDetailsBankAccountTabTitle',
  pspBankAccountDetailsCreateDuplicateConfirmMessage: 'pspBankAccountDetailsCreateDuplicateConfirmMessage',
  pspBankAccountDetailsCreateProhibitedBankConfirmMessage: 'pspBankAccountDetailsCreateProhibitedBankConfirmMessage',
  pspBankAccountDetailsTooltipStatusCreated: 'pspBankAccountDetailsTooltipStatusCreated',
  pspBankAccountDetailsWarningMessageTitle: 'pspBankAccountDetailsWarningMessageTitle',
  pspBankAccountDetailsWithdrawalHint: 'pspBankAccountDetailsWithdrawalHint',
  pspBankAccountWasSuccessfullyCreated: 'pspBankAccountWasSuccessfullyCreated',
  pspBankDocument: 'pspBankDocument',
  pspBankStatement: 'pspBankStatement',
  pspBankStatementTooltip: 'pspBankStatementTooltip',
  pspBankTransfer: 'pspBankTransfer',
  pspBankTransferReceipt: 'pspBankTransferReceipt',
  pspBankTransferReceiptTooltip: 'pspBankTransferReceiptTooltip',
  pspCardStatement: 'pspCardStatement',
  pspChoosePreferredMethod: 'pspChoosePreferredMethod',
  pspConfirmFormConfirmDepositStepTitle: 'pspConfirmFormConfirmDepositStepTitle',
  pspConfirmFormConfirmWithdrawalStepTitle: 'pspConfirmFormConfirmWithdrawalStepTitle',
  pspConfirmFormPinCodeTitle: 'pspConfirmFormPinCodeTitle',
  pspConfirmQRCode: 'pspConfirmQRCode',
  pspConfirmQRCodeGBPrimePay: 'pspConfirmQRCodeGBPrimePay',
  pspConfirmQRCodeParemit: 'pspConfirmQRCodeParemit',
  pspConsentList: 'pspConsentList',
  pspConsents: 'pspConsents',
  pspContactUs: 'pspContactUs',
  pspCryptoWalletAccountWarningMessageTitle: 'pspCryptoWalletAccountWarningMessageTitle',
  pspCryptoWalletCryptoAddressWasSuccessfullyCreated: 'pspCryptoWalletCryptoAddressWasSuccessfullyCreated',
  pspCryptoWalletDetailsCreateTitle: 'pspCryptoWalletDetailsCreateTitle',
  pspCryptoWalletDetailsCryptoWalletTabTitle: 'pspCryptoWalletDetailsCryptoWalletTabTitle',
  pspCryptoWalletDetailsDocumentStatementAddressTitle: 'pspCryptoWalletDetailsDocumentStatementAddressTitle',
  pspCryptoWalletDetailsDocumentStatementImageCryptoAddress:
    'pspCryptoWalletDetailsDocumentStatementImageCryptoAddress',
  pspCryptoWalletDetailsDocumentStatementWalletEmailAddress:
    'pspCryptoWalletDetailsDocumentStatementWalletEmailAddress',
  pspCryptoWalletDetailsDocumentStatementWalletHolderFullName:
    'pspCryptoWalletDetailsDocumentStatementWalletHolderFullName',
  pspCryptoWalletDetailsDocumentStatementWalletLogoOfExchanger:
    'pspCryptoWalletDetailsDocumentStatementWalletLogoOfExchanger',
  pspCryptoWalletDetailsDocumentStatementWalletTitle: 'pspCryptoWalletDetailsDocumentStatementWalletTitle',
  pspCryptoWalletDetailsReceivingAddressTitleWarning: 'pspCryptoWalletDetailsReceivingAddressTitleWarning',
  pspCryptoWalletDetailsWalletOwnershipTitleWarning: 'pspCryptoWalletDetailsWalletOwnershipTitleWarning',
  pspCurrencyAmountHint: 'pspCurrencyAmountHint',
  pspCurrencyAmountHintWithPrecision: 'pspCurrencyAmountHintWithPrecision',
  pspCurrentTransactionStatus: 'pspCurrentTransactionStatus',
  pspDepositBonusModalActiveModalNoticeListItemsItem1: 'pspDepositBonusModalActiveModalNoticeListItemsItem1',
  pspDepositBonusModalActiveModalNoticeMessage: 'pspDepositBonusModalActiveModalNoticeMessage',
  pspDepositBonusModalActiveModalTitle: 'pspDepositBonusModalActiveModalTitle',
  pspDepositBonusModalButtonsContact: 'pspDepositBonusModalButtonsContact',
  pspDepositBonusModalButtonsProceed: 'pspDepositBonusModalButtonsProceed',
  pspDepositBonusModalDisabledModalTitle: 'pspDepositBonusModalDisabledModalTitle',
  pspDepositBonusModalDisabledModalWarningListItemsItem1: 'pspDepositBonusModalDisabledModalWarningListItemsItem1',
  pspDepositBonusModalDisabledModalWarningListItemsItem2: 'pspDepositBonusModalDisabledModalWarningListItemsItem2',
  pspDepositBonusModalDisabledModalWarningMessage: 'pspDepositBonusModalDisabledModalWarningMessage',
  pspDepositBonusModalExpiredModalSubTitle: 'pspDepositBonusModalExpiredModalSubTitle',
  pspDepositBonusModalExpiredModalTitle: 'pspDepositBonusModalExpiredModalTitle',
  pspDepositBonusModalTimerDays: 'pspDepositBonusModalTimerDays',
  pspDepositBonusModalTimerHeader: 'pspDepositBonusModalTimerHeader',
  pspDepositBonusModalTimerHours: 'pspDepositBonusModalTimerHours',
  pspDepositBonusModalTimerMinutes: 'pspDepositBonusModalTimerMinutes',
  pspDepositBonusModalTimerSeconds: 'pspDepositBonusModalTimerSeconds',
  pspDepositDepositCPFNumberTitle: 'pspDepositDepositCPFNumberTitle',
  pspDepositDepositFormAccountBalanceHint: 'pspDepositDepositFormAccountBalanceHint',
  pspDepositDepositFormAccountHint: 'pspDepositDepositFormAccountHint',
  pspDepositDepositFormAccountHolderName: 'pspDepositDepositFormAccountHolderName',
  pspDepositDepositFormAccountNumberIsTheSameAsOnPhoto: 'pspDepositDepositFormAccountNumberIsTheSameAsOnPhoto',
  pspDepositDepositFormAccountNumberTitle: 'pspDepositDepositFormAccountNumberTitle',
  pspDepositDepositFormAccountOwnership: 'pspDepositDepositFormAccountOwnership',
  pspDepositDepositFormAccountTitle: 'pspDepositDepositFormAccountTitle',
  pspDepositDepositFormAccountVerificationCode: 'pspDepositDepositFormAccountVerificationCode',
  pspDepositDepositFormAddNewBankAccount: 'pspDepositDepositFormAddNewBankAccount',
  pspDepositDepositFormAddNewBankAccountHolderName: 'pspDepositDepositFormAddNewBankAccountHolderName',
  pspDepositDepositFormAddNewBankCardNumber: 'pspDepositDepositFormAddNewBankCardNumber',
  pspDepositDepositFormAddNewDigitalWalletAccount: 'pspDepositDepositFormAddNewDigitalWalletAccount',
  pspDepositDepositFormAddress: 'pspDepositDepositFormAddress',
  pspDepositDepositFormAddressLine1: 'pspDepositDepositFormAddressLine1',
  pspDepositDepositFormAmountTitle: 'pspDepositDepositFormAmountTitle',
  pspDepositDepositFormAmountUSDTitle: 'pspDepositDepositFormAmountUSDTitle',
  pspDepositDepositFormAssociatedBankAccount: 'pspDepositDepositFormAssociatedBankAccount',
  pspDepositDepositFormAssociatedDigitalWalletAccount: 'pspDepositDepositFormAssociatedDigitalWalletAccount',
  pspDepositDepositFormAssociatedPayerName: 'pspDepositDepositFormAssociatedPayerName',
  pspDepositDepositFormAssociatedUserCard: 'pspDepositDepositFormAssociatedUserCard',
  pspDepositDepositFormBankAccountHolderName: 'pspDepositDepositFormBankAccountHolderName',
  pspDepositDepositFormBankAccountHolderNameTooltip: 'pspDepositDepositFormBankAccountHolderNameTooltip',
  pspDepositDepositFormBankAccountNumber: 'pspDepositDepositFormBankAccountNumber',
  pspDepositDepositFormBankAccountTitle: 'pspDepositDepositFormBankAccountTitle',
  pspDepositDepositFormBankBranchNameHint: 'pspDepositDepositFormBankBranchNameHint',
  pspDepositDepositFormBankBranchNameTitle: 'pspDepositDepositFormBankBranchNameTitle',
  pspDepositDepositFormBankCardNumberTitle: 'pspDepositDepositFormBankCardNumberTitle',
  pspDepositDepositFormBankNameTitle: 'pspDepositDepositFormBankNameTitle',
  pspDepositDepositFormBankStatement: 'pspDepositDepositFormBankStatement',
  pspDepositDepositFormBankTitle: 'pspDepositDepositFormBankTitle',
  pspDepositDepositFormBeneficiaryBankNameTitle: 'pspDepositDepositFormBeneficiaryBankNameTitle',
  pspDepositDepositFormBeneficiaryDigitalWalletNameTitle: 'pspDepositDepositFormBeneficiaryDigitalWalletNameTitle',
  pspDepositDepositFormCardHint: 'pspDepositDepositFormCardHint',
  pspDepositDepositFormCardHintInRange: 'pspDepositDepositFormCardHintInRange',
  pspDepositDepositFormChannelNameTitle: 'pspDepositDepositFormChannelNameTitle',
  pspDepositDepositFormCityTitle: 'pspDepositDepositFormCityTitle',
  pspDepositDepositFormConvertedAmount: 'pspDepositDepositFormConvertedAmount',
  pspDepositDepositFormCryptoAddress: 'pspDepositDepositFormCryptoAddress',
  pspDepositDepositFormCryptoCyrrencyHint: 'pspDepositDepositFormCryptoCyrrencyHint',
  pspDepositDepositFormCryptoCyrrencyTitle: 'pspDepositDepositFormCryptoCyrrencyTitle',
  pspDepositDepositFormCurrencyTitle: 'pspDepositDepositFormCurrencyTitle',
  pspDepositDepositFormDepositVerification: 'pspDepositDepositFormDepositVerification',
  pspDepositDepositFormDigitalWalletAccountNumber: 'pspDepositDepositFormDigitalWalletAccountNumber',
  pspDepositDepositFormDigitalWalletNameTitle: 'pspDepositDepositFormDigitalWalletNameTitle',
  pspDepositDepositFormDigitalWalletStatement: 'pspDepositDepositFormDigitalWalletStatement',
  pspDepositDepositFormDigitalWalletTitle: 'pspDepositDepositFormDigitalWalletTitle',
  pspDepositDepositFormEmailAddress: 'pspDepositDepositFormEmailAddress',
  pspDepositDepositFormEmulatorIsRedirectTitle: 'pspDepositDepositFormEmulatorIsRedirectTitle',
  pspDepositDepositFormFileInputHint: 'pspDepositDepositFormFileInputHint',
  pspDepositDepositFormFileTitle: 'pspDepositDepositFormFileTitle',
  pspDepositDepositFormFpAccountFrom: 'pspDepositDepositFormFpAccountFrom',
  pspDepositDepositFormFullNameInChinese: 'pspDepositDepositFormFullNameInChinese',
  pspDepositDepositFormFullNameInChineseHint: 'pspDepositDepositFormFullNameInChineseHint',
  pspDepositDepositFormIdentityNumberTitle: 'pspDepositDepositFormIdentityNumberTitle',
  pspDepositDepositFormIdentityTypeTitle: 'pspDepositDepositFormIdentityTypeTitle',
  pspDepositDepositFormLocalAgent: 'pspDepositDepositFormLocalAgent',
  pspDepositDepositFormMakeSurePspDescriptionFieldIsEmpty: 'pspDepositDepositFormMakeSurePspDescriptionFieldIsEmpty',
  pspDepositDepositFormMinDepositError: 'pspDepositDepositFormMinDepositError',
  pspDepositDepositFormNetellerAccountEmailTitle: 'pspDepositDepositFormNetellerAccountEmailTitle',
  pspDepositDepositFormPayerBankAccountNumberTitle: 'pspDepositDepositFormPayerBankAccountNumberTitle',
  pspDepositDepositFormPayerCardNumberTitle: 'pspDepositDepositFormPayerCardNumberTitle',
  pspDepositDepositFormPayerDigitalWalletNumberTitle: 'pspDepositDepositFormPayerDigitalWalletNumberTitle',
  pspDepositDepositFormPayerNameTitle: 'pspDepositDepositFormPayerNameTitle',
  pspDepositDepositFormPersonalId: 'pspDepositDepositFormPersonalId',
  pspDepositDepositFormSkrillAccountEmailHint: 'pspDepositDepositFormSkrillAccountEmailHint',
  pspDepositDepositFormStateTitle: 'pspDepositDepositFormStateTitle',
  pspDepositDepositFormTotalAfterFee: 'pspDepositDepositFormTotalAfterFee',
  pspDepositDepositFormUpiAddress: 'pspDepositDepositFormUpiAddress',
  pspDepositDepositFormUpiId: 'pspDepositDepositFormUpiId',
  pspDepositDepositTabTitle: 'pspDepositDepositTabTitle',
  pspDepositFetchFailErr: 'pspDepositFetchFailErr',
  pspDigitalWalletStatement: 'pspDigitalWalletStatement',
  pspExchangeRatesTitle: 'pspExchangeRatesTitle',
  pspFailedToSetPreferredAccount: 'pspFailedToSetPreferredAccount',
  pspFastBanking: 'pspFastBanking',
  pspFastBankingDescription: 'pspFastBankingDescription',
  pspFastest: 'pspFastest',
  pspFileFormat: 'pspFileFormat',
  pspFormAddNewCryptoAddress: 'pspFormAddNewCryptoAddress',
  pspFromToAmountHint: 'pspFromToAmountHint',
  pspGetCredited: 'pspGetCredited',
  pspInternalTransferProcessFailErr: 'pspInternalTransferProcessFailErr',
  pspLocalAgentTableAccountName: 'pspLocalAgentTableAccountName',
  pspLocalAgentTableDescription: 'pspLocalAgentTableDescription',
  pspLocalAgentTableEmail: 'pspLocalAgentTableEmail',
  pspLocalAgentTableFullName: 'pspLocalAgentTableFullName',
  pspLocalAgentTablePhone: 'pspLocalAgentTablePhone',
  pspLocalDepositRecipientInfo: 'pspLocalDepositRecipientInfo',
  pspLocalDepositReject: 'pspLocalDepositReject',
  pspLocalDepositSubmit: 'pspLocalDepositSubmit',
  pspLocalDepositSuccessMessage: 'pspLocalDepositSuccessMessage',
  pspLocalDepositTitle: 'pspLocalDepositTitle',
  pspLockedPaymentMethod: 'pspLockedPaymentMethod',
  pspMinimalAmountHint: 'pspMinimalAmountHint',
  pspMinimalDepositAmountHint: 'pspMinimalDepositAmountHint',
  pspNationalIdentityWarning: 'pspNationalIdentityWarning',
  pspOnlyNumericAccepted: 'pspOnlyNumericAccepted',
  pspOperationTableCallbackStatusFromPsp: 'pspOperationTableCallbackStatusFromPsp',
  pspOperationsTableAccountTitle: 'pspOperationsTableAccountTitle',
  pspOperationsTableActionAllowed: 'pspOperationsTableActionAllowed',
  pspOperationsTableAmountUSDTitle: 'pspOperationsTableAmountUSDTitle',
  pspOperationsTableAttachedFiles: 'pspOperationsTableAttachedFiles',
  pspOperationsTableBalanceUpdatedTitle: 'pspOperationsTableBalanceUpdatedTitle',
  pspOperationsTableBeneficiaryAccountNumberStatus: 'pspOperationsTableBeneficiaryAccountNumberStatus',
  pspOperationsTableCallbackStatusTitle: 'pspOperationsTableCallbackStatusTitle',
  pspOperationsTableDepositHistoryTitle: 'pspOperationsTableDepositHistoryTitle',
  pspOperationsTableExecutionType: 'pspOperationsTableExecutionType',
  pspOperationsTableFeeUSDTitle: 'pspOperationsTableFeeUSDTitle',
  pspOperationsTableIsMoneyTransfer: 'pspOperationsTableIsMoneyTransfer',
  pspOperationsTableIsMoneyTransferDeposit: 'pspOperationsTableIsMoneyTransferDeposit',
  pspOperationsTableIsMoneyTransferDepositFalse: 'pspOperationsTableIsMoneyTransferDepositFalse',
  pspOperationsTableIsMoneyTransferWithdrawal: 'pspOperationsTableIsMoneyTransferWithdrawal',
  pspOperationsTableIsMoneyTransferWithdrawalFalse: 'pspOperationsTableIsMoneyTransferWithdrawalFalse',
  pspOperationsTableKytVerificationOperation: 'pspOperationsTableKytVerificationOperation',
  pspOperationsTableNetAmountUSDTitle: 'pspOperationsTableNetAmountUSDTitle',
  pspOperationsTableOperationIdTitle: 'pspOperationsTableOperationIdTitle',
  pspOperationsTablePaymentSystemClassTitle: 'pspOperationsTablePaymentSystemClassTitle',
  pspOperationsTablePaymentSystemNameTitle: 'pspOperationsTablePaymentSystemNameTitle',
  pspOperationsTablePspDepositAdminAction: 'pspOperationsTablePspDepositAdminAction',
  pspOperationsTableTransactionTypeTitle: 'pspOperationsTableTransactionTypeTitle',
  pspOperationsTableUserNote: 'pspOperationsTableUserNote',
  pspOperationsTableWalletOperationId: 'pspOperationsTableWalletOperationId',
  pspOperationsTableWithdrawalsHistoryTitle: 'pspOperationsTableWithdrawalsHistoryTitle',
  pspPayByLink: 'pspPayByLink',
  pspPleaseEnsureDocumentAge: 'pspPleaseEnsureDocumentAge',
  pspPluginsEmpty: 'pspPluginsEmpty',
  pspPlusTransferReceipt: 'pspPlusTransferReceipt',
  pspPreferred: 'pspPreferred',
  pspProofAccount: 'pspProofAccount',
  pspProofTransaction: 'pspProofTransaction',
  pspPspTitle: 'pspPspTitle',
  pspQrCodeNotice: 'pspQrCodeNotice',
  pspQrCodeNoticeParemit: 'pspQrCodeNoticeParemit',
  pspQrCodeTitle: 'pspQrCodeTitle',
  pspQrCodeTitleParemit: 'pspQrCodeTitleParemit',
  pspReprocessFailedToResubmitWithdrawal: 'pspReprocessFailedToResubmitWithdrawal',
  pspReprocessWithdrawalResubmitted: 'pspReprocessWithdrawalResubmitted',
  pspSingleTransactionBanking: 'pspSingleTransactionBanking',
  pspSingleTransactionBankingDescription: 'pspSingleTransactionBankingDescription',
  pspStatusFixActionConfirmation: 'pspStatusFixActionConfirmation',
  pspStatusFixActionFailed: 'pspStatusFixActionFailed',
  pspStatusFixActionName: 'pspStatusFixActionName',
  pspStatusFixObtainingAllowedStatusFixesFailed: 'pspStatusFixObtainingAllowedStatusFixesFailed',
  pspTransactionInfoFetchFailErr: 'pspTransactionInfoFetchFailErr',
  pspTransactionResultTitle: 'pspTransactionResultTitle',
  pspTransactionStatus: 'pspTransactionStatus',
  pspTransferTransferFormAccountFromTitle: 'pspTransferTransferFormAccountFromTitle',
  pspTransferTransferFormAccountToTitle: 'pspTransferTransferFormAccountToTitle',
  pspTransferTransferFormAmountErrorRange: 'pspTransferTransferFormAmountErrorRange',
  pspTransferTransferFormAmountTitle: 'pspTransferTransferFormAmountTitle',
  pspTransferTransferFormAmountToTransferTxt: 'pspTransferTransferFormAmountToTransferTxt',
  pspTransferTransferFormAvailableAmountTxt: 'pspTransferTransferFormAvailableAmountTxt',
  pspTransferTransferFormCentToCentDecimalHint: 'pspTransferTransferFormCentToCentDecimalHint',
  pspTransferTransferFormCentToDollarIntegerHint: 'pspTransferTransferFormCentToDollarIntegerHint',
  pspTransferTransferFormContinueBtn: 'pspTransferTransferFormContinueBtn',
  pspTransferTransferFormDollarDecimalHint: 'pspTransferTransferFormDollarDecimalHint',
  pspTransferTransferFormSelectAccountTxt: 'pspTransferTransferFormSelectAccountTxt',
  pspTransferTransferFormTransferFormTitle: 'pspTransferTransferFormTransferFormTitle',
  pspTransferTransferSuccessTxt: 'pspTransferTransferSuccessTxt',
  pspTransferTransferTabTitle: 'pspTransferTransferTabTitle',
  pspTransferTransferTitle: 'pspTransferTransferTitle',
  pspUploadBankDocumentDropzoneTitle: 'pspUploadBankDocumentDropzoneTitle',
  pspUploadBankStatement: 'pspUploadBankStatement',
  pspUploadBankStatementDropzoneTitle: 'pspUploadBankStatementDropzoneTitle',
  pspUploadBankStatementOnce: 'pspUploadBankStatementOnce',
  pspUploadDigitalWalletDropzoneTitle: 'pspUploadDigitalWalletDropzoneTitle',
  pspUploadPayslipDropzoneTitle: 'pspUploadPayslipDropzoneTitle',
  pspUploadProofAccountDropzoneTitle: 'pspUploadProofAccountDropzoneTitle',
  pspUploadProofTransactionDropzoneTitle: 'pspUploadProofTransactionDropzoneTitle',
  pspUserSettings: 'pspUserSettings',
  pspWaitingRedirectToPsp: 'pspWaitingRedirectToPsp',
  pspWithdrawalFetchFailErr: 'pspWithdrawalFetchFailErr',
  pspWithdrawalSendToPspConfirmationText: 'pspWithdrawalSendToPspConfirmationText',
  pspWithdrawalWithdrawalFormAccountReceiverTitle: 'pspWithdrawalWithdrawalFormAccountReceiverTitle',
  pspWithdrawalWithdrawalFormAccountTitle: 'pspWithdrawalWithdrawalFormAccountTitle',
  pspWithdrawalWithdrawalFormAgencyAccountNumberTitle: 'pspWithdrawalWithdrawalFormAgencyAccountNumberTitle',
  pspWithdrawalWithdrawalFormAmountTitle: 'pspWithdrawalWithdrawalFormAmountTitle',
  pspWithdrawalWithdrawalFormAmountUSDTitle: 'pspWithdrawalWithdrawalFormAmountUSDTitle',
  pspWithdrawalWithdrawalFormBankAccountTypeTitle: 'pspWithdrawalWithdrawalFormBankAccountTypeTitle',
  pspWithdrawalWithdrawalFormBankBranchAddressTitle: 'pspWithdrawalWithdrawalFormBankBranchAddressTitle',
  pspWithdrawalWithdrawalFormBankBranchNameHint: 'pspWithdrawalWithdrawalFormBankBranchNameHint',
  pspWithdrawalWithdrawalFormBankBranchNameTitle: 'pspWithdrawalWithdrawalFormBankBranchNameTitle',
  pspWithdrawalWithdrawalFormBankCityTitle: 'pspWithdrawalWithdrawalFormBankCityTitle',
  pspWithdrawalWithdrawalFormBankCityTitleHint: 'pspWithdrawalWithdrawalFormBankCityTitleHint',
  pspWithdrawalWithdrawalFormBankCountryHint: 'pspWithdrawalWithdrawalFormBankCountryHint',
  pspWithdrawalWithdrawalFormBankCountryTitle: 'pspWithdrawalWithdrawalFormBankCountryTitle',
  pspWithdrawalWithdrawalFormBankIFSCCodeHint: 'pspWithdrawalWithdrawalFormBankIFSCCodeHint',
  pspWithdrawalWithdrawalFormBankIFSCCodeTitle: 'pspWithdrawalWithdrawalFormBankIFSCCodeTitle',
  pspWithdrawalWithdrawalFormBankProvinceTitle: 'pspWithdrawalWithdrawalFormBankProvinceTitle',
  pspWithdrawalWithdrawalFormBankProvinceTitleHint: 'pspWithdrawalWithdrawalFormBankProvinceTitleHint',
  pspWithdrawalWithdrawalFormBeneficiaryAccountNameTitle: 'pspWithdrawalWithdrawalFormBeneficiaryAccountNameTitle',
  pspWithdrawalWithdrawalFormBeneficiaryAccountNumberHint: 'pspWithdrawalWithdrawalFormBeneficiaryAccountNumberHint',
  pspWithdrawalWithdrawalFormBeneficiaryAccountNumberPagsmilePixTitle:
    'pspWithdrawalWithdrawalFormBeneficiaryAccountNumberPagsmilePixTitle',
  pspWithdrawalWithdrawalFormBeneficiaryAccountNumberTitle: 'pspWithdrawalWithdrawalFormBeneficiaryAccountNumberTitle',
  pspWithdrawalWithdrawalFormBeneficiaryBankAddressTitle: 'pspWithdrawalWithdrawalFormBeneficiaryBankAddressTitle',
  pspWithdrawalWithdrawalFormBeneficiaryBankNameHint: 'pspWithdrawalWithdrawalFormBeneficiaryBankNameHint',
  pspWithdrawalWithdrawalFormBeneficiaryBankNameTitle: 'pspWithdrawalWithdrawalFormBeneficiaryBankNameTitle',
  pspWithdrawalWithdrawalFormBeneficiaryFirstLastNameHint: 'pspWithdrawalWithdrawalFormBeneficiaryFirstLastNameHint',
  pspWithdrawalWithdrawalFormBeneficiaryFirstNameTitle: 'pspWithdrawalWithdrawalFormBeneficiaryFirstNameTitle',
  pspWithdrawalWithdrawalFormBeneficiaryLastNameTitle: 'pspWithdrawalWithdrawalFormBeneficiaryLastNameTitle',
  pspWithdrawalWithdrawalFormBeneficiaryNameHint: 'pspWithdrawalWithdrawalFormBeneficiaryNameHint',
  pspWithdrawalWithdrawalFormBeneficiaryNameTitle: 'pspWithdrawalWithdrawalFormBeneficiaryNameTitle',
  pspWithdrawalWithdrawalFormBeneficiaryVoletWalletHint: 'pspWithdrawalWithdrawalFormBeneficiaryVoletWalletHint',
  pspWithdrawalWithdrawalFormBranchCode: 'pspWithdrawalWithdrawalFormBranchCode',
  pspWithdrawalWithdrawalFormBranchCodeHint: 'pspWithdrawalWithdrawalFormBranchCodeHint',
  pspWithdrawalWithdrawalFormCPFNumberTitle: 'pspWithdrawalWithdrawalFormCPFNumberTitle',
  pspWithdrawalWithdrawalFormCardHolder: 'pspWithdrawalWithdrawalFormCardHolder',
  pspWithdrawalWithdrawalFormCardNumber: 'pspWithdrawalWithdrawalFormCardNumber',
  pspWithdrawalWithdrawalFormCardType: 'pspWithdrawalWithdrawalFormCardType',
  pspWithdrawalWithdrawalFormCityTitle: 'pspWithdrawalWithdrawalFormCityTitle',
  pspWithdrawalWithdrawalFormConvertedAmount: 'pspWithdrawalWithdrawalFormConvertedAmount',
  pspWithdrawalWithdrawalFormCurrencyTitle: 'pspWithdrawalWithdrawalFormCurrencyTitle',
  pspWithdrawalWithdrawalFormDigitalWalletAccountNumber: 'pspWithdrawalWithdrawalFormDigitalWalletAccountNumber',
  pspWithdrawalWithdrawalFormDocumentNumberTitle: 'pspWithdrawalWithdrawalFormDocumentNumberTitle',
  pspWithdrawalWithdrawalFormDocumentTypeTitle: 'pspWithdrawalWithdrawalFormDocumentTypeTitle',
  pspWithdrawalWithdrawalFormEmulatorIsNeedApproveTitle: 'pspWithdrawalWithdrawalFormEmulatorIsNeedApproveTitle',
  pspWithdrawalWithdrawalFormEmulatorIsRedirectTitle: 'pspWithdrawalWithdrawalFormEmulatorIsRedirectTitle',
  pspWithdrawalWithdrawalFormExchangeRateNote: 'pspWithdrawalWithdrawalFormExchangeRateNote',
  pspWithdrawalWithdrawalFormFundPurposeTitle: 'pspWithdrawalWithdrawalFormFundPurposeTitle',
  pspWithdrawalWithdrawalFormIdentityNumberTitle: 'pspWithdrawalWithdrawalFormIdentityNumberTitle',
  pspWithdrawalWithdrawalFormIdentityTypeTitle: 'pspWithdrawalWithdrawalFormIdentityTypeTitle',
  pspWithdrawalWithdrawalFormIfscCode: 'pspWithdrawalWithdrawalFormIfscCode',
  pspWithdrawalWithdrawalFormImpsAccountName: 'pspWithdrawalWithdrawalFormImpsAccountName',
  pspWithdrawalWithdrawalFormImpsAccountNumber: 'pspWithdrawalWithdrawalFormImpsAccountNumber',
  pspWithdrawalWithdrawalFormNetellerAccountEmailTitle: 'pspWithdrawalWithdrawalFormNetellerAccountEmailTitle',
  pspWithdrawalWithdrawalFormPayTmAccountNumber: 'pspWithdrawalWithdrawalFormPayTmAccountNumber',
  pspWithdrawalWithdrawalFormPayeeAccountTitle: 'pspWithdrawalWithdrawalFormPayeeAccountTitle',
  pspWithdrawalWithdrawalFormPaymePhoneNumberTitle: 'pspWithdrawalWithdrawalFormPaymePhoneNumberTitle',
  pspWithdrawalWithdrawalFormPaymeWalletNameTitle: 'pspWithdrawalWithdrawalFormPaymeWalletNameTitle',
  pspWithdrawalWithdrawalFormPayoutAccountTypeTitle: 'pspWithdrawalWithdrawalFormPayoutAccountTypeTitle',
  pspWithdrawalWithdrawalFormPixKeyHint: 'pspWithdrawalWithdrawalFormPixKeyHint',
  pspWithdrawalWithdrawalFormPixKeyTitle: 'pspWithdrawalWithdrawalFormPixKeyTitle',
  pspWithdrawalWithdrawalFormProvinceTitle: 'pspWithdrawalWithdrawalFormProvinceTitle',
  pspWithdrawalWithdrawalFormSWIFTHint: 'pspWithdrawalWithdrawalFormSWIFTHint',
  pspWithdrawalWithdrawalFormSWIFTTitle: 'pspWithdrawalWithdrawalFormSWIFTTitle',
  pspWithdrawalWithdrawalFormSortCodeHint: 'pspWithdrawalWithdrawalFormSortCodeHint',
  pspWithdrawalWithdrawalFormSortCodeTitle: 'pspWithdrawalWithdrawalFormSortCodeTitle',
  pspWithdrawalWithdrawalFormTotalAfterFee: 'pspWithdrawalWithdrawalFormTotalAfterFee',
  pspWithdrawalWithdrawalFormUpiAddress: 'pspWithdrawalWithdrawalFormUpiAddress',
  pspWithdrawalWithdrawalFormWithdrawBtn: 'pspWithdrawalWithdrawalFormWithdrawBtn',
  pspWithdrawalWithdrawalFormWithdrawalVerification: 'pspWithdrawalWithdrawalFormWithdrawalVerification',
  pspWithdrawalWithdrawalTabTitle: 'pspWithdrawalWithdrawalTabTitle',
  pushNotifications: 'pushNotifications',
  questionnaire: 'questionnaire',
  questionnaires: 'questionnaires',
  reAssignmentUsersToNewSalesUser: 'reAssignmentUsersToNewSalesUser',
  recurringJobs: 'recurringJobs',
  salesActivityHistoryContactMethod: 'salesActivityHistoryContactMethod',
  salesActivityHistoryContactOn: 'salesActivityHistoryContactOn',
  salesActivityHistoryTitle: 'salesActivityHistoryTitle',
  salesClientsDepositTitle: 'salesClientsDepositTitle',
  salesClientsIbSummary: 'salesClientsIbSummary',
  salesClientsIbTreesTradingVolume: 'salesClientsIbTreesTradingVolume',
  salesClientsSalesClientsInfoTitle: 'salesClientsSalesClientsInfoTitle',
  salesClientsTradingAccountTitle: 'salesClientsTradingAccountTitle',
  salesClientsUserTitle: 'salesClientsUserTitle',
  salesClientsWithdrawalTitle: 'salesClientsWithdrawalTitle',
  salesFieldsTradingAccountIsReadOnly: 'salesFieldsTradingAccountIsReadOnly',
  salesFieldsTradingAccountLastDeposit: 'salesFieldsTradingAccountLastDeposit',
  salesFieldsTradingAccountLastLogin: 'salesFieldsTradingAccountLastLogin',
  salesFieldsUserNetAmountUsd: 'salesFieldsUserNetAmountUsd',
  salesFieldsUserOwnIbRebate: 'salesFieldsUserOwnIbRebate',
  salesFieldsUserParentIbRebate: 'salesFieldsUserParentIbRebate',
  salesFieldsUserPeriodOn: 'salesFieldsUserPeriodOn',
  salesFieldsUserPeriodOnTooltip: 'salesFieldsUserPeriodOnTooltip',
  salesFieldsUserTotalDepositedUsd: 'salesFieldsUserTotalDepositedUsd',
  salesFieldsUserTotalVolume: 'salesFieldsUserTotalVolume',
  salesFieldsUserTotalWithdrawnUsd: 'salesFieldsUserTotalWithdrawnUsd',
  salesInfoTitle: 'salesInfoTitle',
  salesLeadCampaignCode: 'salesLeadCampaignCode',
  salesLeadDownloadCount: 'salesLeadDownloadCount',
  salesLeadIsNewLead: 'salesLeadIsNewLead',
  salesLeadIsNewLeadAndRegistered: 'salesLeadIsNewLeadAndRegistered',
  salesLeadLandingPageUrl: 'salesLeadLandingPageUrl',
  salesLeadRegisteredOn: 'salesLeadRegisteredOn',
  salesLeadTotalDepositUSD: 'salesLeadTotalDepositUSD',
  salesLeadVerified: 'salesLeadVerified',
  salesPartnershipDetailsTitle: 'salesPartnershipDetailsTitle',
  salesPartnershipErrorMessage: 'salesPartnershipErrorMessage',
  salesPartnershipHintMessage: 'salesPartnershipHintMessage',
  salesPartnershipSearchTitle: 'salesPartnershipSearchTitle',
  salesPartnershipTitle: 'salesPartnershipTitle',
  salesTitle: 'salesTitle',
  settingsChangeEmailFormChangeEmailStepHintsFifthStepHint: 'settingsChangeEmailFormChangeEmailStepHintsFifthStepHint',
  settingsChangeEmailFormChangeEmailStepHintsFirstStepHint: 'settingsChangeEmailFormChangeEmailStepHintsFirstStepHint',
  settingsChangeEmailFormChangeEmailStepHintsFourthStepHint:
    'settingsChangeEmailFormChangeEmailStepHintsFourthStepHint',
  settingsChangeEmailFormChangeEmailStepHintsSecondStepHint:
    'settingsChangeEmailFormChangeEmailStepHintsSecondStepHint',
  settingsChangeEmailFormChangeEmailStepHintsSeventhStepHint:
    'settingsChangeEmailFormChangeEmailStepHintsSeventhStepHint',
  settingsChangeEmailFormChangeEmailStepHintsSixthStepHint: 'settingsChangeEmailFormChangeEmailStepHintsSixthStepHint',
  settingsChangeEmailFormChangeEmailStepHintsThirdStepHint: 'settingsChangeEmailFormChangeEmailStepHintsThirdStepHint',
  settingsChangeEmailFormChangeEmailStepHintsTitle: 'settingsChangeEmailFormChangeEmailStepHintsTitle',
  settingsChangeEmailFormErrorMessage: 'settingsChangeEmailFormErrorMessage',
  settingsChangeEmailFormNewEmailTitle: 'settingsChangeEmailFormNewEmailTitle',
  settingsChangeEmailFormNewEmailValidation: 'settingsChangeEmailFormNewEmailValidation',
  settingsChangeEmailFormSuccessMessage: 'settingsChangeEmailFormSuccessMessage',
  settingsChangeEmailFormTitle: 'settingsChangeEmailFormTitle',
  settingsChangeMemberAreaPasswordFormConfirmPasswordTitle: 'settingsChangeMemberAreaPasswordFormConfirmPasswordTitle',
  settingsChangeMemberAreaPasswordFormErrorMessage: 'settingsChangeMemberAreaPasswordFormErrorMessage',
  settingsChangeMemberAreaPasswordFormNewPasswordTitle: 'settingsChangeMemberAreaPasswordFormNewPasswordTitle',
  settingsChangeMemberAreaPasswordFormOldPasswordTitle: 'settingsChangeMemberAreaPasswordFormOldPasswordTitle',
  settingsChangeMemberAreaPasswordFormPinTitle: 'settingsChangeMemberAreaPasswordFormPinTitle',
  settingsChangeMemberAreaPasswordFormSuccessMessage: 'settingsChangeMemberAreaPasswordFormSuccessMessage',
  settingsChangeMemberAreaPasswordFormTitle: 'settingsChangeMemberAreaPasswordFormTitle',
  settingsChangePinCodeFormConfirmNewPinCodeTitle: 'settingsChangePinCodeFormConfirmNewPinCodeTitle',
  settingsChangePinCodeFormConfirmNewPinCodeValidation: 'settingsChangePinCodeFormConfirmNewPinCodeValidation',
  settingsChangePinCodeFormErrorMessage: 'settingsChangePinCodeFormErrorMessage',
  settingsChangePinCodeFormNewPinCodeTitle: 'settingsChangePinCodeFormNewPinCodeTitle',
  settingsChangePinCodeFormNewPinCodeValidation: 'settingsChangePinCodeFormNewPinCodeValidation',
  settingsChangePinCodeFormOldPinCodeTitle: 'settingsChangePinCodeFormOldPinCodeTitle',
  settingsChangePinCodeFormPasswordTitle: 'settingsChangePinCodeFormPasswordTitle',
  settingsChangePinCodeFormPinCodeHint: 'settingsChangePinCodeFormPinCodeHint',
  settingsChangePinCodeFormSuccessMessage: 'settingsChangePinCodeFormSuccessMessage',
  settingsChangePinCodeFormTitle: 'settingsChangePinCodeFormTitle',
  settingsDocsFormAnd: 'settingsDocsFormAnd',
  settingsDocsFormDeleteConfirmMessage: 'settingsDocsFormDeleteConfirmMessage',
  settingsDocsFormDocumentNameTitle: 'settingsDocsFormDocumentNameTitle',
  settingsDocsFormDocumentNumber: 'settingsDocsFormDocumentNumber',
  settingsDocsFormDocumentTypeBankCardRequiredTitle: 'settingsDocsFormDocumentTypeBankCardRequiredTitle',
  settingsDocsFormDocumentTypeBankCardRequiredTitleForChineseCountries:
    'settingsDocsFormDocumentTypeBankCardRequiredTitleForChineseCountries',
  settingsDocsFormDocumentTypeTitle: 'settingsDocsFormDocumentTypeTitle',
  settingsDocsFormDocumentsUploadedTitle: 'settingsDocsFormDocumentsUploadedTitle',
  settingsDocsFormFileExtensionErrorHint: 'settingsDocsFormFileExtensionErrorHint',
  settingsDocsFormFileHint: 'settingsDocsFormFileHint',
  settingsDocsFormFileHintCustomSizeAndFormat: 'settingsDocsFormFileHintCustomSizeAndFormat',
  settingsDocsFormFileHintImage: 'settingsDocsFormFileHintImage',
  settingsDocsFormFileHintPdf: 'settingsDocsFormFileHintPdf',
  settingsDocsFormFileUploaded: 'settingsDocsFormFileUploaded',
  settingsDocsFormFrontSideTitle: 'settingsDocsFormFrontSideTitle',
  settingsDocsFormNoDocuments: 'settingsDocsFormNoDocuments',
  settingsDocsFormNoDocumentsWithDocTypes: 'settingsDocsFormNoDocumentsWithDocTypes',
  settingsDocsFormOneRequiredText: 'settingsDocsFormOneRequiredText',
  settingsDocsFormReverseSideTitle: 'settingsDocsFormReverseSideTitle',
  settingsDocsFormUploadAnImageTitle: 'settingsDocsFormUploadAnImageTitle',
  settingsDocsFormUploadBackSideTitle: 'settingsDocsFormUploadBackSideTitle',
  settingsDocsFormUploadDocumentsTitle: 'settingsDocsFormUploadDocumentsTitle',
  settingsDocsFormUploadErrorMessage: 'settingsDocsFormUploadErrorMessage',
  settingsDocsFormUploadFieldDescription: 'settingsDocsFormUploadFieldDescription',
  settingsDocsFormUploadFieldTitle: 'settingsDocsFormUploadFieldTitle',
  settingsDocsFormUploadFrontSideTitle: 'settingsDocsFormUploadFrontSideTitle',
  settingsDocsFormUploadReverseSideTitle: 'settingsDocsFormUploadReverseSideTitle',
  settingsDocsFormUploadSuccessMessage: 'settingsDocsFormUploadSuccessMessage',
  settingsDocsFormUploadedDocumentsTableTableTitle: 'settingsDocsFormUploadedDocumentsTableTableTitle',
  settingsEmailSubscriptionsCategoryHintsMarketing: 'settingsEmailSubscriptionsCategoryHintsMarketing',
  settingsEmailSubscriptionsCategoryHintsTransactional: 'settingsEmailSubscriptionsCategoryHintsTransactional',
  settingsEmailSubscriptionsTitle: 'settingsEmailSubscriptionsTitle',
  settingsMasterAccountSettingsFormMastersVisibilityHint: 'settingsMasterAccountSettingsFormMastersVisibilityHint',
  settingsProfileFormNotValidFormMessage: 'settingsProfileFormNotValidFormMessage',
  settingsProfileFormPleaseUploadBackSide: 'settingsProfileFormPleaseUploadBackSide',
  settingsProfileFormPleaseUploadBankCard: 'settingsProfileFormPleaseUploadBankCard',
  settingsProfileFormPleaseUploadFrontSide: 'settingsProfileFormPleaseUploadFrontSide',
  settingsProfileFormPleaseUploadProofOfIdentity: 'settingsProfileFormPleaseUploadProofOfIdentity',
  settingsProfileFormSaveUserErrorMessage: 'settingsProfileFormSaveUserErrorMessage',
  settingsProfileFormSendUserErrorMessage: 'settingsProfileFormSendUserErrorMessage',
  settingsProfileFormSendUserSuccessMessage: 'settingsProfileFormSendUserSuccessMessage',
  settingsProfileFormTitle: 'settingsProfileFormTitle',
  settingsProfileFormUnverifiedDocumentsModalSubtitle: 'settingsProfileFormUnverifiedDocumentsModalSubtitle',
  settingsProfileFormUnverifiedDocumentsModalTitle: 'settingsProfileFormUnverifiedDocumentsModalTitle',
  settingsProfileFormVerifyID: 'settingsProfileFormVerifyID',
  settingsProfileFormYourDetailsSubmittedSuccessfully: 'settingsProfileFormYourDetailsSubmittedSuccessfully',
  settingsPushSubscriptionsTitle: 'settingsPushSubscriptionsTitle',
  settingsResetPinCodeFormErrorMessage: 'settingsResetPinCodeFormErrorMessage',
  settingsResetPinCodeFormForgotPin: 'settingsResetPinCodeFormForgotPin',
  settingsResetPinCodeFormForgotPinClick: 'settingsResetPinCodeFormForgotPinClick',
  settingsResetPinCodeFormResetPinCodeHint: 'settingsResetPinCodeFormResetPinCodeHint',
  settingsResetPinCodeFormSubmitBtn: 'settingsResetPinCodeFormSubmitBtn',
  settingsResetPinCodeFormSuccessMessage: 'settingsResetPinCodeFormSuccessMessage',
  settingsResetPinCodeFormTitle: 'settingsResetPinCodeFormTitle',
  settingsTitle: 'settingsTitle',
  settingsTrustedDevicesTitle: 'settingsTrustedDevicesTitle',
  settingsUserFormAccountManagerTitle: 'settingsUserFormAccountManagerTitle',
  settingsUserFormBankCardPhoto: 'settingsUserFormBankCardPhoto',
  settingsUserFormBankDetailsBankAccountCurrencyTitle: 'settingsUserFormBankDetailsBankAccountCurrencyTitle',
  settingsUserFormBankDetailsBankBranchNameTitle: 'settingsUserFormBankDetailsBankBranchNameTitle',
  settingsUserFormBankDetailsBankCountryTitle: 'settingsUserFormBankDetailsBankCountryTitle',
  settingsUserFormBankDetailsBeneficiaryAccountNumberTitle: 'settingsUserFormBankDetailsBeneficiaryAccountNumberTitle',
  settingsUserFormBankDetailsBeneficiaryBankNameTitle: 'settingsUserFormBankDetailsBeneficiaryBankNameTitle',
  settingsUserFormBankDetailsBeneficiaryNameTitle: 'settingsUserFormBankDetailsBeneficiaryNameTitle',
  settingsUserFormBankDetailsSWIFTTitle: 'settingsUserFormBankDetailsSWIFTTitle',
  settingsUserFormBankDetailsSortCodeTitle: 'settingsUserFormBankDetailsSortCodeTitle',
  settingsUserFormBankDetailsTitle: 'settingsUserFormBankDetailsTitle',
  settingsUserFormBusinessManagerTitle: 'settingsUserFormBusinessManagerTitle',
  settingsUserFormGovernmentPhotoTitle: 'settingsUserFormGovernmentPhotoTitle',
  settingsUserFormPersonalDataTitle: 'settingsUserFormPersonalDataTitle',
  settingsUserFormProfileAddressTitle: 'settingsUserFormProfileAddressTitle',
  settingsUserFormProfileCityTitle: 'settingsUserFormProfileCityTitle',
  settingsUserFormProfileCountryTitle: 'settingsUserFormProfileCountryTitle',
  settingsUserFormProfileDateOfBirthTitle: 'settingsUserFormProfileDateOfBirthTitle',
  settingsUserFormProfileFirstNameTitle: 'settingsUserFormProfileFirstNameTitle',
  settingsUserFormProfileGenderTitle: 'settingsUserFormProfileGenderTitle',
  settingsUserFormProfileLanguage: 'settingsUserFormProfileLanguage',
  settingsUserFormProfileLastNameTitle: 'settingsUserFormProfileLastNameTitle',
  settingsUserFormProfileMobilePhoneTitle: 'settingsUserFormProfileMobilePhoneTitle',
  settingsUserFormProfileOccupation: 'settingsUserFormProfileOccupation',
  settingsUserFormProfileStateTitle: 'settingsUserFormProfileStateTitle',
  settingsUserFormProfileZipCodeTitle: 'settingsUserFormProfileZipCodeTitle',
  settingsUserFormUserGovernmentPhotoUserCitizenship: 'settingsUserFormUserGovernmentPhotoUserCitizenship',
  settingsUserFormUserGovernmentPhotoUserDocumentNumber: 'settingsUserFormUserGovernmentPhotoUserDocumentNumber',
  settingsUserFormUserGovernmentPhotoUserDocumentType: 'settingsUserFormUserGovernmentPhotoUserDocumentType',
  settingsUserFormUserGovernmentPhotoUserGovernmentId: 'settingsUserFormUserGovernmentPhotoUserGovernmentId',
  sharedActionsActions: 'sharedActionsActions',
  sharedActionsActivate: 'sharedActionsActivate',
  sharedActionsAdd: 'sharedActionsAdd',
  sharedActionsArchive: 'sharedActionsArchive',
  sharedActionsBack: 'sharedActionsBack',
  sharedActionsCancel: 'sharedActionsCancel',
  sharedActionsCheck: 'sharedActionsCheck',
  sharedActionsClaim: 'sharedActionsClaim',
  sharedActionsClear: 'sharedActionsClear',
  sharedActionsClone: 'sharedActionsClone',
  sharedActionsComment: 'sharedActionsComment',
  sharedActionsCopy: 'sharedActionsCopy',
  sharedActionsCreate: 'sharedActionsCreate',
  sharedActionsDelete: 'sharedActionsDelete',
  sharedActionsDeposit: 'sharedActionsDeposit',
  sharedActionsDetails: 'sharedActionsDetails',
  sharedActionsDisable: 'sharedActionsDisable',
  sharedActionsDownload: 'sharedActionsDownload',
  sharedActionsEdit: 'sharedActionsEdit',
  sharedActionsEnable: 'sharedActionsEnable',
  sharedActionsExport: 'sharedActionsExport',
  sharedActionsExportAs: 'sharedActionsExportAs',
  sharedActionsFilter: 'sharedActionsFilter',
  sharedActionsFollowUp: 'sharedActionsFollowUp',
  sharedActionsGoToProfile: 'sharedActionsGoToProfile',
  sharedActionsHide: 'sharedActionsHide',
  sharedActionsImport: 'sharedActionsImport',
  sharedActionsLater: 'sharedActionsLater',
  sharedActionsLess: 'sharedActionsLess',
  sharedActionsMore: 'sharedActionsMore',
  sharedActionsOpen: 'sharedActionsOpen',
  sharedActionsPromote: 'sharedActionsPromote',
  sharedActionsRecovery: 'sharedActionsRecovery',
  sharedActionsReprocess: 'sharedActionsReprocess',
  sharedActionsRetry: 'sharedActionsRetry',
  sharedActionsSave: 'sharedActionsSave',
  sharedActionsSend: 'sharedActionsSend',
  sharedActionsSendToVerification: 'sharedActionsSendToVerification',
  sharedActionsSettings: 'sharedActionsSettings',
  sharedActionsShow: 'sharedActionsShow',
  sharedActionsStop: 'sharedActionsStop',
  sharedActionsStopCopy: 'sharedActionsStopCopy',
  sharedActionsSubmit: 'sharedActionsSubmit',
  sharedActionsSync: 'sharedActionsSync',
  sharedActionsSyncToCRM: 'sharedActionsSyncToCRM',
  sharedActionsTrigger: 'sharedActionsTrigger',
  sharedActionsUnarchive: 'sharedActionsUnarchive',
  sharedActionsUpload: 'sharedActionsUpload',
  sharedActionsValidate: 'sharedActionsValidate',
  sharedAdminDashboard: 'sharedAdminDashboard',
  sharedConfirmMessage: 'sharedConfirmMessage',
  sharedConfirmMessageArchive: 'sharedConfirmMessageArchive',
  sharedConfirmMessageCancel: 'sharedConfirmMessageCancel',
  sharedConfirmMessageClone: 'sharedConfirmMessageClone',
  sharedConfirmMessageDelete: 'sharedConfirmMessageDelete',
  sharedConfirmMessageDisable: 'sharedConfirmMessageDisable',
  sharedConfirmMessageEnable: 'sharedConfirmMessageEnable',
  sharedConfirmMessageHide: 'sharedConfirmMessageHide',
  sharedConfirmMessageShow: 'sharedConfirmMessageShow',
  sharedConfirmMessageSendToVerification: 'sharedConfirmMessageSendToVerification',
  sharedConfirmMessageStopCopy: 'sharedConfirmMessageStopCopy',
  sharedConfirmMessageUnarchive: 'sharedConfirmMessageUnarchive',
  sharedErrorsFailedMessageForRecord: 'sharedErrorsFailedMessageForRecord',
  sharedErrorsFailedToCommitOperation: 'sharedErrorsFailedToCommitOperation',
  sharedErrorsFailedToCreateRecord: 'sharedErrorsFailedToCreateRecord',
  sharedErrorsFailedToDeleteRecord: 'sharedErrorsFailedToDeleteRecord',
  sharedErrorsFailedToGetData: 'sharedErrorsFailedToGetData',
  sharedErrorsFailedToGetInterfaces: 'sharedErrorsFailedToGetInterfaces',
  sharedErrorsFailedToGetRecord: 'sharedErrorsFailedToGetRecord',
  sharedErrorsFailedToGetSettings: 'sharedErrorsFailedToGetSettings',
  sharedErrorsFailedToLoadBanner: 'sharedErrorsFailedToLoadBanner',
  sharedErrorsFailedToLoadFile: 'sharedErrorsFailedToLoadFile',
  sharedErrorsFailedToPromoteRecord: 'sharedErrorsFailedToPromoteRecord',
  sharedErrorsFailedToSaveRecord: 'sharedErrorsFailedToSaveRecord',
  sharedErrorsFailedToSaveSettings: 'sharedErrorsFailedToSaveSettings',
  sharedErrorsFailedToSaveTemplate: 'sharedErrorsFailedToSaveTemplate',
  sharedErrorsFailedToSendProfile: 'sharedErrorsFailedToSendProfile',
  sharedErrorsFailedToSyncRecord: 'sharedErrorsFailedToSyncRecord',
  sharedErrorsFailedToSyncRecordToCRM: 'sharedErrorsFailedToSyncRecordToCRM',
  sharedErrorsFailedToUpdateRecord: 'sharedErrorsFailedToUpdateRecord',
  sharedErrorsHaveUnsavedChanges: 'sharedErrorsHaveUnsavedChanges',
  sharedErrorsOperationFailed: 'sharedErrorsOperationFailed',
  sharedFieldsAccountId: 'sharedFieldsAccountId',
  sharedFieldsAccountType: 'sharedFieldsAccountType',
  sharedFieldsAeCode: 'sharedFieldsAeCode',
  sharedFieldsAmount: 'sharedFieldsAmount',
  sharedFieldsApplication: 'sharedFieldsApplication',
  sharedFieldsArchivedBy: 'sharedFieldsArchivedBy',
  sharedFieldsArchivedOn: 'sharedFieldsArchivedOn',
  sharedFieldsArguments: 'sharedFieldsArguments',
  sharedFieldsAutoComment: 'sharedFieldsAutoComment',
  sharedFieldsAvailableBalanceUsd: 'sharedFieldsAvailableBalanceUsd',
  sharedFieldsBdmCode: 'sharedFieldsBdmCode',
  sharedFieldsBody: 'sharedFieldsBody',
  sharedFieldsCategory: 'sharedFieldsCategory',
  sharedFieldsClientApp: 'sharedFieldsClientApp',
  sharedFieldsClientSourceType: 'sharedFieldsClientSourceType',
  sharedFieldsComment: 'sharedFieldsComment',
  sharedFieldsConversionRate: 'sharedFieldsConversionRate',
  sharedFieldsCountry: 'sharedFieldsCountry',
  sharedFieldsCreatedBy: 'sharedFieldsCreatedBy',
  sharedFieldsCreatedOn: 'sharedFieldsCreatedOn',
  sharedFieldsCryptoAddress: 'sharedFieldsCryptoAddress',
  sharedFieldsCurrency: 'sharedFieldsCurrency',
  sharedFieldsDeclineReason: 'sharedFieldsDeclineReason',
  sharedFieldsDescription: 'sharedFieldsDescription',
  sharedFieldsDescriptionHtml: 'sharedFieldsDescriptionHtml',
  sharedFieldsDestinationType: 'sharedFieldsDestinationType',
  sharedFieldsDisplayName: 'sharedFieldsDisplayName',
  sharedFieldsEWallet: 'sharedFieldsEWallet',
  sharedFieldsEmail: 'sharedFieldsEmail',
  sharedFieldsEnabled: 'sharedFieldsEnabled',
  sharedFieldsEndOn: 'sharedFieldsEndOn',
  sharedFieldsExternalId: 'sharedFieldsExternalId',
  sharedFieldsFile: 'sharedFieldsFile',
  sharedFieldsFullName: 'sharedFieldsFullName',
  sharedFieldsGroup: 'sharedFieldsGroup',
  sharedFieldsHeight: 'sharedFieldsHeight',
  sharedFieldsIb: 'sharedFieldsIb',
  sharedFieldsIbCode: 'sharedFieldsIbCode',
  sharedFieldsIbId: 'sharedFieldsIbId',
  sharedFieldsId: 'sharedFieldsId',
  sharedFieldsInternalComment: 'sharedFieldsInternalComment',
  sharedFieldsIsArchived: 'sharedFieldsIsArchived',
  sharedFieldsIsConsentRequired: 'sharedFieldsIsConsentRequired',
  sharedFieldsIsHidden: 'sharedFieldsIsHidden',
  sharedFieldsExecutionType: 'Execution type',
  sharedFieldsLanguage: 'sharedFieldsLanguage',
  sharedFieldsLocation: 'sharedFieldsLocation',
  sharedFieldsLockedBy: 'sharedFieldsLockedBy',
  sharedFieldsLockedOn: 'sharedFieldsLockedOn',
  sharedFieldsMamCode: 'sharedFieldsMamCode',
  sharedFieldsMaxAmount: 'sharedFieldsMaxAmount',
  sharedFieldsMaxVolume: 'sharedFieldsMaxVolume',
  sharedFieldsMinAmount: 'sharedFieldsMinAmount',
  sharedFieldsMinMobileAppVersion: 'sharedFieldsMinMobileAppVersion',
  sharedFieldsMinVolume: 'sharedFieldsMinVolume',
  sharedFieldsModifiedBy: 'sharedFieldsModifiedBy',
  sharedFieldsModifiedOn: 'sharedFieldsModifiedOn',
  sharedFieldsName: 'sharedFieldsName',
  sharedFieldsNumber: 'sharedFieldsNumber',
  sharedFieldsOpenPrice: 'sharedFieldsOpenPrice',
  sharedFieldsOrder: 'sharedFieldsOrder',
  sharedFieldsParameters: 'sharedFieldsParameters',
  sharedFieldsParentIbCode: 'sharedFieldsParentIbCode',
  sharedFieldsPhone: 'sharedFieldsPhone',
  sharedFieldsProhibitedBank: 'sharedFieldsProhibitedBank',
  sharedFieldsPromotedBy: 'sharedFieldsPromotedBy',
  sharedFieldsPromotedOn: 'sharedFieldsPromotedOn',
  sharedFieldsPublicComment: 'sharedFieldsPublicComment',
  sharedFieldsPublishOn: 'sharedFieldsPublishOn',
  sharedFieldsSalesUser: 'sharedFieldsSalesUser',
  sharedFieldsStartOn: 'sharedFieldsStartOn',
  sharedFieldsStatus: 'sharedFieldsStatus',
  sharedFieldsSubtype: 'sharedFieldsSubtype',
  sharedFieldsTitle: 'sharedFieldsTitle',
  sharedFieldsToken: 'sharedFieldsToken',
  sharedFieldsTotalAvailableBalance: 'sharedFieldsTotalAvailableBalance',
  sharedFieldsTotalPayoutUsd: 'sharedFieldsTotalPayoutUsd',
  sharedFieldsTradedAccount: 'sharedFieldsTradedAccount',
  sharedFieldsTradingAccount: 'sharedFieldsTradingAccount',
  sharedFieldsTradingAccountType: 'sharedFieldsTradingAccountType',
  sharedFieldsTradingAccountTypes: 'sharedFieldsTradingAccountTypes',
  sharedFieldsTradingPlatformType: 'sharedFieldsTradingPlatformType',
  sharedFieldsTradingServer: 'sharedFieldsTradingServer',
  sharedFieldsTransactionId: 'sharedFieldsTransactionId',
  sharedFieldsTreeIbCode: 'sharedFieldsTreeIbCode',
  sharedFieldsType: 'sharedFieldsType',
  sharedFieldsUrl: 'sharedFieldsUrl',
  sharedFieldsUseBackwardCompatibleHint: 'sharedFieldsUseBackwardCompatibleHint',
  sharedFieldsUser: 'sharedFieldsUser',
  sharedFieldsVersion: 'sharedFieldsVersion',
  sharedFieldsWidth: 'sharedFieldsWidth',
  sharedImportedBy: 'sharedImportedBy',
  sharedImportedOn: 'sharedImportedOn',
  sharedMemberDashboard: 'sharedMemberDashboard',
  sharedMsgProfileSentSuccessfully: 'sharedMsgProfileSentSuccessfully',
  sharedMsgRecordSuccessDeleted: 'sharedMsgRecordSuccessDeleted',
  sharedMsgRecordSuccessPromote: 'sharedMsgRecordSuccessPromote',
  sharedMsgRecordSuccessSaved: 'sharedMsgRecordSuccessSaved',
  sharedMsgRecordSuccessSynced: 'sharedMsgRecordSuccessSynced',
  sharedMsgRecordSuccessUpdated: 'sharedMsgRecordSuccessUpdated',
  sharedMsgSettingsSuccessSaved: 'sharedMsgSettingsSuccessSaved',
  sharedSystemError401: 'sharedSystemError401',
  sharedSystemError403: 'sharedSystemError403',
  sharedSystemError503: 'sharedSystemError503',
  sharedSystemErrorOccurred: 'sharedSystemErrorOccurred',
  sharedSystemInternalServerError: 'sharedSystemInternalServerError',
  sharedSystemInvalidSession: 'sharedSystemInvalidSession',
  sharedSystemNoPermissionToAccessSection: 'sharedSystemNoPermissionToAccessSection',
  sharedSystemNotFoundPageButton: 'sharedSystemNotFoundPageButton',
  sharedSystemNotFoundPageSubtitle: 'sharedSystemNotFoundPageSubtitle',
  sharedSystemNotFoundPageTitle: 'sharedSystemNotFoundPageTitle',
  sharedSystemRefreshButton: 'sharedSystemRefreshButton',
  sharedSystemRefreshPage: 'sharedSystemRefreshPage',
  sharedSystemSomethingWentWrong: 'sharedSystemSomethingWentWrong',
  sharedWelcome: 'sharedWelcome',
  shortLinksAlternativeDomain: 'shortLinksAlternativeDomain',
  shortLinksShortLink: 'shortLinksShortLink',
  shortLinksShortLinkCreate: 'shortLinksShortLinkCreate',
  shortLinksShortLinks: 'shortLinksShortLinks',
  shortLinksUsageCount: 'shortLinksUsageCount',
  shortLinksUseAlternativeURL: 'shortLinksUseAlternativeURL',
  signatureClearBtn: 'signatureClearBtn',
  socialTradingModalAccountNumber: 'socialTradingModalAccountNumber',
  socialTradingModalAll: 'socialTradingModalAll',
  socialTradingModalCopyTitle: 'socialTradingModalCopyTitle',
  socialTradingModalMasterDescription: 'socialTradingModalMasterDescription',
  socialTradingModalMastersStopCopyError: 'socialTradingModalMastersStopCopyError',
  socialTradingModalMastersinvisibilityCopyError: 'socialTradingModalMastersinvisibilityCopyError',
  socialTradingModalSelectAcountDescription: 'socialTradingModalSelectAcountDescription',
  socialTradingModalStartCopy: 'socialTradingModalStartCopy',
  socialTradingModalStopByMasterDescription: 'socialTradingModalStopByMasterDescription',
  socialTradingModalStopCopy: 'socialTradingModalStopCopy',
  socialTradingModalStopDescriptionFirstLine: 'socialTradingModalStopDescriptionFirstLine',
  socialTradingModalStopDescriptionSecondLine: 'socialTradingModalStopDescriptionSecondLine',
  socialTradingModalStopTitle: 'socialTradingModalStopTitle',
  socialTradingModalWarning: 'socialTradingModalWarning',
  sticpayPspEmailHint: 'sticpayPspEmailHint',
  successfullyCopiedToClipboard: 'successfullyCopiedToClipboard',
  tableClearSection: 'tableClearSection',
  tableClickFilterButton: 'tableClickFilterButton',
  tablePosition: 'tablePosition',
  tableProfitability: 'tableProfitability',
  tableQuotesNote: 'tableQuotesNote',
  tableShowItems: 'tableShowItems',
  tableShowTotals: 'tableShowTotals',
  tableShowTotalsFieldsAmount: 'tableShowTotalsFieldsAmount',
  tableShowTotalsFieldsAmountUsd: 'tableShowTotalsFieldsAmountUsd',
  tableShowTotalsFieldsTotalInCurrency: 'tableShowTotalsFieldsTotalInCurrency',
  tableShowTotalsFieldsTradingVolumeInLots: 'tableShowTotalsFieldsTradingVolumeInLots',
  tableTotal: 'tableTotal',
  tableTotalCount: 'tableTotalCount',
  ticketsCreateTicketTitle: 'ticketsCreateTicketTitle',
  ticketsDetailsTicketTitle: 'ticketsDetailsTicketTitle',
  ticketsFieldsAssignedTitle: 'ticketsFieldsAssignedTitle',
  ticketsFieldsBodyTitle: 'ticketsFieldsBodyTitle',
  ticketsFieldsSubjectTitle: 'ticketsFieldsSubjectTitle',
  ticketsTicketsTitle: 'ticketsTicketsTitle',
  totalNetAmountUSD: 'totalNetAmountUSD',
  tradindServerAskViewPasPermissionMes: 'tradindServerAskViewPasPermissionMes',
  tradingAccountPushNotificationLabel: 'tradingAccountPushNotificationLabel',
  tradingAccountTypeMinMobileAppVersionHint: 'tradingAccountTypeMinMobileAppVersionHint',
  tradingAccountTypeUserAccessSettingList: 'tradingAccountTypeUserAccessSettingList',
  tradingAccountsAccount: 'tradingAccountsAccount',
  tradingAccountsAccountHistoryFormTitle: 'tradingAccountsAccountHistoryFormTitle',
  tradingAccountsAccountHistoryTitle: 'tradingAccountsAccountHistoryTitle',
  tradingAccountsAccountOrderHistory: 'tradingAccountsAccountOrderHistory',
  tradingAccountsAccountSuccessfullyCreated: 'tradingAccountsAccountSuccessfullyCreated',
  tradingAccountsAccounts: 'tradingAccountsAccounts',
  tradingAccountsActionsDepositTitle: 'tradingAccountsActionsDepositTitle',
  tradingAccountsActionsSaveTitle: 'tradingAccountsActionsSaveTitle',
  tradingAccountsActionsSetPasswordTitle: 'tradingAccountsActionsSetPasswordTitle',
  tradingAccountsActionsWithdrawTitle: 'tradingAccountsActionsWithdrawTitle',
  tradingAccountsArchvingFormConfirmMessage: 'tradingAccountsArchvingFormConfirmMessage',
  tradingAccountsArchvingFormErrorMessage: 'tradingAccountsArchvingFormErrorMessage',
  tradingAccountsArchvingFormSuccessMessage: 'tradingAccountsArchvingFormSuccessMessage',
  tradingAccountsArchvingFormTitle: 'tradingAccountsArchvingFormTitle',
  tradingAccountsArchvingFormWarnigingMessageRestrictInformation:
    'tradingAccountsArchvingFormWarnigingMessageRestrictInformation',
  tradingAccountsArchvingFormWarnigingMessageTitle: 'tradingAccountsArchvingFormWarnigingMessageTitle',
  tradingAccountsArchvingFormWarnigingMessageUndoneAction: 'tradingAccountsArchvingFormWarnigingMessageUndoneAction',
  tradingAccountsChangeSettings: 'tradingAccountsChangeSettings',
  tradingAccountsChangeSettingsErrorMessage: 'tradingAccountsChangeSettingsErrorMessage',
  tradingAccountsChangeSettingsSuccessMessage: 'tradingAccountsChangeSettingsSuccessMessage',
  tradingAccountsChangeTradingAccountNameSubtitle: 'tradingAccountsChangeTradingAccountNameSubtitle',
  tradingAccountsCommissionAccount: 'tradingAccountsCommissionAccount',
  tradingAccountsCopyType: 'tradingAccountsCopyType',
  tradingAccountsCopyingNotice: 'tradingAccountsCopyingNotice',
  tradingAccountsDefaultActionMessage: 'tradingAccountsDefaultActionMessage',
  tradingAccountsDemoTitle: 'tradingAccountsDemoTitle',
  tradingAccountsDepositFormTitle: 'tradingAccountsDepositFormTitle',
  tradingAccountsFailedToChangeTradingAccountName: 'tradingAccountsFailedToChangeTradingAccountName',
  tradingAccountsFailedToFetchTradingAccounts: 'tradingAccountsFailedToFetchTradingAccounts',
  tradingAccountsGroupUpdateWarning: 'tradingAccountsGroupUpdateWarning',
  tradingAccountsHideActionMessagesHideActiveInvestorAccountConfirmation:
    'tradingAccountsHideActionMessagesHideActiveInvestorAccountConfirmation',
  tradingAccountsHideActionMessagesHideActiveMamAccountConfirmation:
    'tradingAccountsHideActionMessagesHideActiveMamAccountConfirmation',
  tradingAccountsInactiveAccount: 'tradingAccountsInactiveAccount',
  tradingAccountsInitialDeposit: 'tradingAccountsInitialDeposit',
  tradingAccountsInvestorAccount: 'tradingAccountsInvestorAccount',
  tradingAccountsInvestorPasswordFormConfirmPasswordTitle: 'tradingAccountsInvestorPasswordFormConfirmPasswordTitle',
  tradingAccountsInvestorPasswordFormErrorMessage: 'tradingAccountsInvestorPasswordFormErrorMessage',
  tradingAccountsInvestorPasswordFormPasswordTitle: 'tradingAccountsInvestorPasswordFormPasswordTitle',
  tradingAccountsInvestorPasswordFormPinCodeTitle: 'tradingAccountsInvestorPasswordFormPinCodeTitle',
  tradingAccountsInvestorPasswordFormSuccessMessage: 'tradingAccountsInvestorPasswordFormSuccessMessage',
  tradingAccountsInvestorPasswordFormTitle: 'tradingAccountsInvestorPasswordFormTitle',
  tradingAccountsLeverageFormErrorMessage: 'tradingAccountsLeverageFormErrorMessage',
  tradingAccountsLeverageFormLeverageHint: 'tradingAccountsLeverageFormLeverageHint',
  tradingAccountsLeverageFormSuccessMessage: 'tradingAccountsLeverageFormSuccessMessage',
  tradingAccountsLeverageFormTitle: 'tradingAccountsLeverageFormTitle',
  tradingAccountsLogin: 'tradingAccountsLogin',
  tradingAccountsLotMultiplier: 'tradingAccountsLotMultiplier',
  tradingAccountsMarginStopCopyLevel: 'tradingAccountsMarginStopCopyLevel',
  tradingAccountsMarginStopCopyLevelTooltip: 'tradingAccountsMarginStopCopyLevelTooltip',
  tradingAccountsMasterAccountLink: 'tradingAccountsMasterAccountLink',
  tradingAccountsMasterPasswordFormConfirmPasswordTitle: 'tradingAccountsMasterPasswordFormConfirmPasswordTitle',
  tradingAccountsMasterPasswordFormErrorMessage: 'tradingAccountsMasterPasswordFormErrorMessage',
  tradingAccountsMasterPasswordFormPasswordTitle: 'tradingAccountsMasterPasswordFormPasswordTitle',
  tradingAccountsMasterPasswordFormPinCodeTitle: 'tradingAccountsMasterPasswordFormPinCodeTitle',
  tradingAccountsMasterPasswordFormSuccessMessage: 'tradingAccountsMasterPasswordFormSuccessMessage',
  tradingAccountsMasterPasswordFormTitle: 'tradingAccountsMasterPasswordFormTitle',
  tradingAccountsMasterStatusInvisible: 'tradingAccountsMasterStatusInvisible',
  tradingAccountsMasterStatusVisible: 'tradingAccountsMasterStatusVisible',
  tradingAccountsNoAccountsHint: 'tradingAccountsNoAccountsHint',
  tradingAccountsNotificationsFormTitle: 'tradingAccountsNotificationsFormTitle',
  tradingAccountsOpenAccount: 'tradingAccountsOpenAccount',
  tradingAccountsOpenAccountAgree: 'tradingAccountsOpenAccountAgree',
  tradingAccountsOpenAccountAgreeNew: 'tradingAccountsOpenAccountAgreeNew',
  tradingAccountsOpenAccountError: 'tradingAccountsOpenAccountError',
  tradingAccountsOpenAccountModalTitle: 'tradingAccountsOpenAccountModalTitle',
  tradingAccountsOpenMasterAccountFormRecommendedDeposit: 'tradingAccountsOpenMasterAccountFormRecommendedDeposit',
  tradingAccountsOpenMasterAccountFormRecommendedDepositMandatoryTooltipMsg:
    'tradingAccountsOpenMasterAccountFormRecommendedDepositMandatoryTooltipMsg',
  tradingAccountsOpenMasterAccountFormRecommendedDepositOptionalTooltipMsg:
    'tradingAccountsOpenMasterAccountFormRecommendedDepositOptionalTooltipMsg',
  tradingAccountsPercentageLossStopCopyLevel: 'tradingAccountsPercentageLossStopCopyLevel',
  tradingAccountsPercentageLossStopCopyLevelTooltip: 'tradingAccountsPercentageLossStopCopyLevelTooltip',
  tradingAccountsPushNotificationHint: 'tradingAccountsPushNotificationHint',
  tradingAccountsRealTitle: 'tradingAccountsRealTitle',
  tradingAccountsRefillFormRefillActionTitle: 'tradingAccountsRefillFormRefillActionTitle',
  tradingAccountsRefillFormRefillAmountTitle: 'tradingAccountsRefillFormRefillAmountTitle',
  tradingAccountsRefillFormRefillErrorMessage: 'tradingAccountsRefillFormRefillErrorMessage',
  tradingAccountsRefillFormRefillSuccessMessage: 'tradingAccountsRefillFormRefillSuccessMessage',
  tradingAccountsRefillFormRefillTitle: 'tradingAccountsRefillFormRefillTitle',
  tradingAccountsRemapLinksExcludedUserIds: 'tradingAccountsRemapLinksExcludedUserIds',
  tradingAccountsRemapLinksFromTradingGroup: 'tradingAccountsRemapLinksFromTradingGroup',
  tradingAccountsRemapLinksIncludedUserIds: 'tradingAccountsRemapLinksIncludedUserIds',
  tradingAccountsRemapLinksRemapGroupLinks: 'tradingAccountsRemapLinksRemapGroupLinks',
  tradingAccountsRemapLinksRemapGroupUserCategories: 'tradingAccountsRemapLinksRemapGroupUserCategories',
  tradingAccountsRemapLinksToTradingGroup: 'tradingAccountsRemapLinksToTradingGroup',
  tradingAccountsRenameAccount: 'tradingAccountsRenameAccount',
  tradingAccountsRenameYourAccount: 'tradingAccountsRenameYourAccount',
  tradingAccountsSearchPlaceholder: 'tradingAccountsSearchPlaceholder',
  tradingAccountsServer: 'tradingAccountsServer',
  tradingAccountsSignLPOA: 'tradingAccountsSignLPOA',
  tradingAccountsSocialTradingSettings: 'tradingAccountsSocialTradingSettings',
  tradingAccountsStopCopyViaMarginLevel: 'tradingAccountsStopCopyViaMarginLevel',
  tradingAccountsStopCopyViaMarginLevelTooltip: 'tradingAccountsStopCopyViaMarginLevelTooltip',
  tradingAccountsTableHistoryClosePriceTitle: 'tradingAccountsTableHistoryClosePriceTitle',
  tradingAccountsTableHistoryCloseTimeTitle: 'tradingAccountsTableHistoryCloseTimeTitle',
  tradingAccountsTableHistoryCmdTitle: 'tradingAccountsTableHistoryCmdTitle',
  tradingAccountsTableHistoryCommentTitle: 'tradingAccountsTableHistoryCommentTitle',
  tradingAccountsTableHistoryCommissionTitle: 'tradingAccountsTableHistoryCommissionTitle',
  tradingAccountsTableHistoryOpenTimeTitle: 'tradingAccountsTableHistoryOpenTimeTitle',
  tradingAccountsTableHistoryProfitTitle: 'tradingAccountsTableHistoryProfitTitle',
  tradingAccountsTableHistorySlTitle: 'tradingAccountsTableHistorySlTitle',
  tradingAccountsTableHistorySwapsTitle: 'tradingAccountsTableHistorySwapsTitle',
  tradingAccountsTableHistorySymbolTitle: 'tradingAccountsTableHistorySymbolTitle',
  tradingAccountsTableHistoryTicketTitle: 'tradingAccountsTableHistoryTicketTitle',
  tradingAccountsTableHistoryTpTitle: 'tradingAccountsTableHistoryTpTitle',
  tradingAccountsTableHistoryVolumeTitle: 'tradingAccountsTableHistoryVolumeTitle',
  tradingAccountsTerminateLPOA: 'tradingAccountsTerminateLPOA',
  tradingAccountsTitle: 'tradingAccountsTitle',
  tradingAccountsTradingAccountName: 'tradingAccountsTradingAccountName',
  tradingAccountsTradingAccountNameSuccessfullyChanged: 'tradingAccountsTradingAccountNameSuccessfullyChanged',
  tradingAccountsTransferFormTitle: 'tradingAccountsTransferFormTitle',
  tradingAccountsType: 'tradingAccountsType',
  tradingAccountsWithdrawFormTitle: 'tradingAccountsWithdrawFormTitle',
  tradingActionLinkExistingAccount: 'tradingActionLinkExistingAccount',
  tradingContestAccountNumber: 'tradingContestAccountNumber',
  tradingContestAdminClientSourceTypeHint: 'tradingContestAdminClientSourceTypeHint',
  tradingContestAllContests: 'tradingContestAllContests',
  tradingContestAverageDrawdown: 'tradingContestAverageDrawdown',
  tradingContestAverageDrawdownCounter: 'tradingContestAverageDrawdownCounter',
  tradingContestBalanceOperationSum: 'tradingContestBalanceOperationSum',
  tradingContestCalculatedOn: 'tradingContestCalculatedOn',
  tradingContestContestEndsIn: 'tradingContestContestEndsIn',
  tradingContestContestStartsIn: 'tradingContestContestStartsIn',
  tradingContestCurrentKPI: 'tradingContestCurrentKPI',
  tradingContestDepositSum: 'tradingContestDepositSum',
  tradingContestDrawdown: 'tradingContestDrawdown',
  tradingContestEnded: 'tradingContestEnded',
  tradingContestEquity: 'tradingContestEquity',
  tradingContestInOrderToParticipateHintOne: 'tradingContestInOrderToParticipateHintOne',
  tradingContestInOrderToParticipateHintTwo: 'tradingContestInOrderToParticipateHintTwo',
  tradingContestJoined: 'tradingContestJoined',
  tradingContestMaxDrawdown: 'tradingContestMaxDrawdown',
  tradingContestName: 'tradingContestName',
  tradingContestNickname: 'tradingContestNickname',
  tradingContestNoAvailableContests: 'tradingContestNoAvailableContests',
  tradingContestNoParticipantsYet: 'tradingContestNoParticipantsYet',
  tradingContestNotJoined: 'tradingContestNotJoined',
  tradingContestPosition: 'tradingContestPosition',
  tradingContestProfitability: 'tradingContestProfitability',
  tradingContestProfitabilityOnStartingBalance: 'tradingContestProfitabilityOnStartingBalance',
  tradingContestStartBalanceOperationSum: 'tradingContestStartBalanceOperationSum',
  tradingContestStartWithdrawalSum: 'tradingContestStartWithdrawalSum',
  tradingContestState: 'tradingContestState',
  tradingContestTradingContest: 'tradingContestTradingContest',
  tradingContestWithdrawalSum: 'tradingContestWithdrawalSum',
  tradingFieldsAccountFrom: 'tradingFieldsAccountFrom',
  tradingFieldsAccountRange: 'tradingFieldsAccountRange',
  tradingFieldsAccountTo: 'tradingFieldsAccountTo',
  tradingFieldsBaseCurrency: 'tradingFieldsBaseCurrency',
  tradingFieldsCommissionSettingsInstruments: 'tradingFieldsCommissionSettingsInstruments',
  tradingFieldsCommissionSettingsIsNotManageableByIb: 'tradingFieldsCommissionSettingsIsNotManageableByIb',
  tradingFieldsCommissionSettingsIsUsedForCommissionSettings:
    'tradingFieldsCommissionSettingsIsUsedForCommissionSettings',
  tradingFieldsCommonSettingsArchivingAllowed: 'tradingFieldsCommonSettingsArchivingAllowed',
  tradingFieldsCommonSettingsChangeInvestorPasswordAllowed: 'tradingFieldsCommonSettingsChangeInvestorPasswordAllowed',
  tradingFieldsCommonSettingsChangeLeverageAllowed: 'tradingFieldsCommonSettingsChangeLeverageAllowed',
  tradingFieldsCommonSettingsChangeMasterPasswordAllowed: 'tradingFieldsCommonSettingsChangeMasterPasswordAllowed',
  tradingFieldsCommonSettingsDepositAllowed: 'tradingFieldsCommonSettingsDepositAllowed',
  tradingFieldsCommonSettingsInvestorsAutoAttachmentAllowed:
    'tradingFieldsCommonSettingsInvestorsAutoAttachmentAllowed',
  tradingFieldsCommonSettingsWithdrawalAllowed: 'tradingFieldsCommonSettingsWithdrawalAllowed',
  tradingFieldsContractSize: 'tradingFieldsContractSize',
  tradingFieldsDepositWithdrawalSettingsDepositSettings: 'tradingFieldsDepositWithdrawalSettingsDepositSettings',
  tradingFieldsDepositWithdrawalSettingsIsAllowed: 'tradingFieldsDepositWithdrawalSettingsIsAllowed',
  tradingFieldsDepositWithdrawalSettingsIsAllowedOnWeekend: 'tradingFieldsDepositWithdrawalSettingsIsAllowedOnWeekend',
  tradingFieldsDepositWithdrawalSettingsWithdrawalSettings: 'tradingFieldsDepositWithdrawalSettingsWithdrawalSettings',
  tradingFieldsFullPip: 'tradingFieldsFullPip',
  tradingFieldsGroupMapping: 'tradingFieldsGroupMapping',
  tradingFieldsGroupMappingType: 'tradingFieldsGroupMappingType',
  tradingFieldsMaxNumber: 'tradingFieldsMaxNumber',
  tradingFieldsMinBalanceToMakeAccount: 'tradingFieldsMinBalanceToMakeAccount',
  tradingFieldsMinDeposit: 'tradingFieldsMinDeposit',
  tradingFieldsNextLogin: 'tradingFieldsNextLogin',
  tradingFieldsProfitCurrency: 'tradingFieldsProfitCurrency',
  tradingFieldsSymbol: 'tradingFieldsSymbol',
  tradingFieldsTradingAccountSettingsEnabled: 'tradingFieldsTradingAccountSettingsEnabled',
  tradingFieldsTradingAccountSettingsIsDisplay: 'tradingFieldsTradingAccountSettingsIsDisplay',
  tradingFieldsTradingAccountSettingsIsReadonly: 'tradingFieldsTradingAccountSettingsIsReadonly',
  tradingFieldsTradingAccountSettingsLastUpdateDateFromTP: 'tradingFieldsTradingAccountSettingsLastUpdateDateFromTP',
  tradingFieldsTradingAccountSettingsSendReports: 'tradingFieldsTradingAccountSettingsSendReports',
  tradingFieldsUseForCheckPreferred: 'tradingFieldsUseForCheckPreferred',
  tradingPlatformsTitle: 'tradingPlatformsTitle',
  tradingToolsMarketBuzzMentionsSourcesDescription: 'tradingToolsMarketBuzzMentionsSourcesDescription',
  tradingToolsMarketBuzzNewsFeedDescription: 'tradingToolsMarketBuzzNewsFeedDescription',
  tradingToolsMarketBuzzOverallMentionsDescription: 'tradingToolsMarketBuzzOverallMentionsDescription',
  tradingToolsMarketBuzzPlaceholder: 'tradingToolsMarketBuzzPlaceholder',
  tradingToolsMarketBuzzTitle: 'tradingToolsMarketBuzzTitle',
  tradingToolsTitle: 'tradingToolsTitle',
  trustedDeviceDeviceInfo: 'trustedDeviceDeviceInfo',
  trustedDeviceIpAddress: 'trustedDeviceIpAddress',
  trustedDeviceLastLogin: 'trustedDeviceLastLogin',
  trustedDeviceLocation: 'trustedDeviceLocation',
  tutorialVideoSeeTutorialAction: 'tutorialVideoSeeTutorialAction',
  tutorialVideoSkipAction: 'tutorialVideoSkipAction',
  tutorialVideoUserChoice: 'tutorialVideoUserChoice',
  userBankAccount: 'userBankAccount',
  userBankAccounts: 'userBankAccounts',
  userCard: 'userCard',
  userCards: 'userCards',
  userCardAccounts: 'userCardAccounts',
  userCardAccount: 'userCardAccount',
  userCryptoWalletAccount: 'userCryptoWalletAccount',
  userDigitalWalletAccount: 'userDigitalWalletAccount',
  userDigitalWalletAccounts: 'userDigitalWalletAccounts',
  tradingBonusList: 'tradingBonusList',
  tradingBonus: 'tradingBonus',
  tradingBonuses: 'tradingBonuses',
  userNameAlias: 'userNameAlias',
  userNameAliases: 'userNameAliases',
  userOnlyChineseCharactersCanBeUsed: 'userOnlyChineseCharactersCanBeUsed',
  userPspAccessType: 'userPspAccessType',
  userPspUserType: 'userPspUserType',
  userPspUserTypeHint: 'userPspUserTypeHint',
  usersTickets: 'usersTickets',
  videoTitlesPlatformVideoTitle: 'videoTitlesPlatformVideoTitle',
  videoTitlesPspVideoTitle: 'videoTitlesPspVideoTitle',
  withdrawalFinancialIdentityType: 'withdrawalFinancialIdentityType',
  withdrawalWarningMessageApologize: 'withdrawalWarningMessageApologize',
  withdrawalWarningMessageBankDetailsProceedRequest: 'withdrawalWarningMessageBankDetailsProceedRequest',
  withdrawalWarningMessageBankDetailsTitle: 'withdrawalWarningMessageBankDetailsTitle',
  withdrawalWarningMessageBestRegards: 'withdrawalWarningMessageBestRegards',
  withdrawalWarningMessageEnterInformation: 'withdrawalWarningMessageEnterInformation',
  yesCloseWithoutSaving: 'yesCloseWithoutSaving',
  youHaveNoCopyingAccounts: 'youHaveNoCopyingAccounts',
});
export type KeyMapKeys = keyof typeof keyMap;
export type KeyMap = typeof keyMap;
